<template>
<div class="chapter">
<div class="inner_page">
<h1 class="calibre4">+++</h1>
<p class="calibre2">Tage der Kindheit, euch will ich zurückrufen, Zeiten ohne
Schuld, freundliche Zeiten, eurer will ich gern gedenken.</p>
<p class="calibre2">Meiner Mutter leichte Schritte werden durch helle Stuben
klingen, und Menschen, die jetzt unter der Last des Lebens ergraut
sind, werden lachen wie einst, als sie ihr Schicksal nicht kannten.
Die Toten sollen wieder mit sanften Stimmen reden, und alte Lieder
werden sich in den Chor der Erinnerungen mischen.</p>
<p class="calibre2">Doch auch bittere Worte werden erklingen, herbe Worte, wie
Menschen sie sprechen, welche die harte Abrechnung mit dem schweren
Leben kennen.</p>
<p class="calibre2">Tell me the tales,<br class="calibre3"/>
that to me were so dear,<br class="calibre3"/>
long, long ago,<br class="calibre3"/>
long, long ago.</p>
<p class="calibre2">Es war daheim in der Dämmerstunde.</p>
<p class="calibre2">Draußen senkte sich sacht Schleier auf Schleier über
den leuchtenden Schnee. Die Gebäude verdämmerten, die
großen Pappeln verschwanden. Nur Jens, der Stallknecht,
schlich mit seiner Laterne drüben bei den Ställen
umher.</p>
<p class="calibre2">Drinnen saßen wir Kinder im Kreise auf Schemeln. Die Stube
war groß, die Ecken fern. Vielleicht versteckten wir nur
deshalb den Kopf hinter einer Gardine, weil es drinnen so dunkel
war.</p>
<p class="calibre2"><a id="page8" title="woldemar/wedi"></a> Mutters
Stimme klang so zart, die Saiten des Klaviers tönten mehr wie
eine Harfe:</p>
<p class="calibre2">Tell me the tales,<br class="calibre3"/>
that to me were so dear,<br class="calibre3"/>
long, long ago,<br class="calibre3"/>
long, long ago.</p>
<p class="calibre2">Der Gesang verstummte. Man hörte keinen Laut. William, der
der Mutter am nächsten saß, war auf seinem Schemel
eingeschlafen.</p>
<p class="calibre2">»Mutter, sing weiter.«</p>
<p class="calibre2">Über die weißen Tasten fiel ein schwacher Lichtschein,
glitt über alle Möbel und verschwand. Jens, der
Stallknecht, trabte leise an den Fenstern vorbei mit seiner
Laterne.</p>
<p class="calibre2">»Mutter, sing weiter.«</p>
<p class="calibre2">Eine Tür wird aufgemacht, ganz vorsichtig. Das war Vaters
Tür.</p>
<p class="calibre2">Herr Peter grub wohl Runen in den Steg,<br class="calibre3"/>
Dort, wo Klein Hellen oft nahm ihren Weg.<br class="calibre3"/>
Drauf lichtet er den Anker,<br class="calibre3"/>
Dem Winde durft er trau'n,<br class="calibre3"/>
Er segelte von Dänemark<br class="calibre3"/>
Und von den dänschen Frau'n.</p>
<p class="calibre2">Schöne Worte<br class="calibre3"/>
Rühren manches Herz,<br class="calibre3"/>
Schöne Worte<br class="calibre3"/>
Brachten mir viel Schmerz,<br class="calibre3"/>
Schöne Worte.</p>
<p class="calibre2">Alles ist still. Wie einen Schatten, fein und schlank, sehen wir
die Mutter dasitzen. Wenn der Schatten schweigt, hört man die
große Uhr.</p>
<p class="calibre2">Schöne Worte<br class="calibre3"/>
Rühren manches Herz,<br class="calibre3"/>
Schöne Worte<br class="calibre3"/>
Brachten mir viel Schmerz,<br class="calibre3"/>
Schöne Worte.</p>
<p class="calibre2"><a id="page9" title="woldemar/wedi"></a>
Draußen wird behutsam eine Tür aufgeklinkt. Es sind die
Mädchen, die zuhören wollen. Um das Licht geschart, das
im Messingleuchter auf dem Küchentisch steht, hören sie
zu, wenn die Frau singt.</p>
<p class="calibre2">Der Großknecht schleicht herein. Die Holzpantoffel hat er
vorsichtig ausgezogen und lehnt sich an den Türpfosten neben
dem Wassereimer.</p>
<p class="calibre2">»Kinder.«</p>
<p class="calibre2">»Ja, Mutter.«</p>
<p class="calibre2">»Singt mit.«</p>
<p class="calibre2">Mutter erhebt die Stimme, schlägt die zitternden Tasten
etwas kräftiger an und setzt wieder ein.</p>
<p class="calibre2">Herrlich ist die Erde,<br class="calibre3"/>
Prächtig Gottes Himmel,<br class="calibre3"/>
Schön ist der Seelen Pilgrimsgang.</p>
<p class="calibre2">Etwas ängstlich vor dem Dunkel kommen aus den Ecken die
Stimmen der Kinder durch die Finsternis, geführt von der
Stimme der Mutter.</p>
<p class="calibre2">Hin durch die weiten Reiche der Erde<br class="calibre3"/>
Gehn wir zum Paradies mit Gesang.</p>
<p class="calibre2">Draußen in der Küche sitzen die Mädchen noch
immer still um das brennende Licht.</p>
<p class="calibre2">Die Männer-Marie wischt mit dem Rücken der schwieligen
Hand eine Träne fort</p>
<p class="calibre2">»Den Psalm,« sagt sie, »will die Frau sich
vorsingen lassen, wenn sie einmal sterben muß.«</p>
<p class="calibre2">Alles ist still. Nur die große Uhr an der Tür
spricht.</p>
<p class="calibre2">Da sagt aus seiner Ecke einer von den Knaben leise:</p>
<p class="calibre2">»Mutter, sing nochmal das Lied, das ich nicht
verstehe.«</p>
<p class="calibre2">Der Mutter Schatten schweigt noch. Dann ertönen abermals
– aber schwächer – die harfengleichen
Töne:</p>
<p class="calibre2">Tell me the tales,<br class="calibre3"/>
that to me were so dear,<br class="calibre3"/>
long, long ago,<br class="calibre3"/>
long, long ago.</p>
<p class="calibre2"><a id="page10" title="woldemar/wedi"></a> Tage der
Kindheit, euch will ich zurückrufen – ihr holden Zeiten
ohne Schuld, da mein Herz froh war. Ihr Tage voll Zartheit, da die
Tränen linde waren.</p>
<p class="calibre2">Tage der Kindheit, als die Mutter lebte. – Ich weiß
noch einen Tag, als wir Brombeeren sammelten, Mutter, wir Kinder
und Tine aus der Schule.</p>
<p class="calibre2">Es waren so viele Beeren da, und die Ranken waren so schön.
Hinunter in die Gräben, ging es und an den Hecken liefen wir
entlang. Wir Kinder blieben an den Ranken hängen und
kreischten. Unsere Gesichter waren schmutzig, daß wir aussahen
wie die Schmiedbuben.</p>
<p class="calibre2">»Sieh einer den Jungen an, sieh einer den Jungen an!«
rief die Mutter.</p>
<p class="calibre2">Tine aber hatte eine mächtige Ranke ergriffen, die reich
voll dunkler Beeren prangte, und warf sie schnell der Mutter um die
Schultern.</p>
<p class="calibre2">»Ach, Sie entzückende Frau,« sagte sie.</p>
<p class="calibre2">Die Mutter stand an der Hecke, die Ranke hing ihr auf die Brust
herab. Hoch gegen den leuchtenden Himmel.</p>
<p class="calibre2"> </p>
<p class="calibre2">Tage der Kindheit, euch will ich zurückrufen.</p>
<p class="calibre2"><a id="page11" title="woldemar/wedi"></a> Es war
ein weißes Haus, und in dem Hause waren die Tapeten hell.</p>
<p class="calibre2">Alle Türen standen offen, auch im Winter, wenn mit Holz
geheizt wurde.</p>
<p class="calibre2">Zwischen den Mahagonimöbeln standen Marmortische und auch
weiße Konsolen, die von Augustenburg, vom Schloß,
herübergekommen waren, als dort Auktion abgehalten wurde. Um
die alten Porträte waren Immortellen gewunden, und es waren
viele Efeupflanzen da, denn die Mutter liebte es, wenn der Efeu
sich an einer hellen Wand emporrankte.</p>
<p class="calibre2">Die Gartenstube war so weiß, daß sie förmlich
glänzte.</p>
<p class="calibre2">Die Kinder liebten diese Stube, vor allem aber die Gartentreppe,
auf deren weißgestrichenem Geländer sie
hinunterrutschten.</p>
<p class="calibre2">»Kinder, Kinder!« rief die Mutter, »lehnt euch ja
nicht an das Geländer.«</p>
<p class="calibre2">»Um Gottes willen,« sagte sie zu Tine, der
Lehrerstochter, »es endet eines schönen Tages damit,
daß sie sich den Hals brechen. Wir schicken doch auch nie zum
Tischler.«</p>
<p class="calibre2">Das Geländer war wackelig und wurde nie zurechtgemacht.</p>
<p class="calibre2">Aber die Gartentür wurde früh im Herbst geschlossen,
der Riegel vorgeschoben und die grünen Gardinen über die
weißen gehängt, damit es gemütlich wurde. Denn die
<a id="page12" title="woldemar/gary"></a> Mutter
liebte den Garten und die große Allee nicht, wenn nicht Sonne
darüber war, Sonne, die lange schien.</p>
<p class="calibre2">»Gott mag wissen, wie es im Küchengarten
aussieht,« sagte sie plötzlich zu Schullehrers Tine, wenn
sie nachmittags beim Kaffee saßen.</p>
<p class="calibre2">Sie kam die neun Monate nicht in den Küchengarten.</p>
<p class="calibre2">Er lag weit abseits hinter der Pappelallee und hinter dem
Wagentor, und die Kinder durften auch nicht hinlaufen, weil sie
dann nasse Füße bekamen. Aber hin und wieder, wenn die
Wege ganz aufgeweicht waren und man auf dem ganzen Hofe nicht
gründen konnte, dann wollte die Mutter hin und nach dem Garten
sehen.</p>
<p class="calibre2">In den Holzpantinen der Männer-Marie und mit
hochgeschürzten Röcken zog sie los, über den
Hof.</p>
<p class="calibre2">Alle Mädchen standen draußen auf der Treppe, um ihr
nachzusehen.</p>
<p class="calibre2">»Kinderchen, Kinderchen!« rief sie; sie machte keine
zehn Schritte, ohne mit den Holzpantinen stecken zu bleiben.</p>
<p class="calibre2">Wenn sie wiederkam, mußte sie warme Zwiebäcke zur
Stärkung haben.</p>
<p class="calibre2">»Liebes Kind,« sagte sie zur Lehrerstochter,
»daß die Leute im Winter nicht in der Stube
bleiben.«</p>
<p class="calibre2">Die Kinder spielten auf dem Teppich. Er war rot und grau, mit
vielen großen Feldern. Die Felder waren Königreiche,
über die die Kinder herrschten, und um die sie kämpften.
Sie zankten sich und vergossen Tränen. Sie verbarrikadierten
ihre Königreiche mit den Möbeln. Die ganze Wohnstube sah
aus wie Babylon im Aufruhr.</p>
<p class="calibre2">»Was die Kinder doch für einen Lärm machen,«
sagte die Mutter zur Mamsell (sie stiftete sie aber selber dazu
an).</p>
<p class="calibre2">»So, so, jetzt verliert Nina wieder die
Mamelucken!«</p>
<p class="calibre2">Mit den Mamelucken war immer etwas los. Bald zerknitterten sie,
und bald gingen sie im Kampf um die Königreiche verloren.</p>
<p class="calibre2"><a id="page13" title="woldemar/gary"></a> Vor den
Fenstern lag der Schnee. Der Großknecht, der Knecht und der
Kuhhirt versahen ihre Hantierung. Langsam und bedächtig gingen
sie zwischen Ställen und Scheune hin und her.</p>
<p class="calibre2">Wenn die Stalltür geöffnet wurde, hörte man die
Kühe brüllen.</p>
<p class="calibre2">»Mutter,« sagte Nina, »da brüllt Williams
Kuh.«</p>
<p class="calibre2">Aber es konnte auch passieren – wenn der Vater aus war
–, daß die Mutter den Kuhhirten bat, alle Kühe
»nur einen Augenblick« in den weißen Hof
hinauszulassen. Und nun sprangen sie alle vierzehn, die roten, die
weißen und die scheckigen, im Schnee herum, während die
Kinder juchzten.</p>
<p class="calibre2">»Macht die Zauntür zu, macht die Zauntür
zu!« rief die Mutter. Sie lachte am lautesten, mitten auf der
Treppe stehend. Aber in eine von den scheckigen war der Teufel
gefahren.</p>
<p class="calibre2">»O, wie die springt,« sagte die Mutter.</p>
<p class="calibre2">Sie rannte so weit, den Schwanz steil in die Luft, daß sie
erst oben beim Dorfschulzen eingefangen wurde.</p>
<p class="calibre2">Wenn der Vater nach Hause kam, war die Stalltür
geschlossen, und der Hof lag wieder ruhig da wie früher.</p>
<p class="calibre2">Die Mutter aber hatte Zahnschmerzen bekommen, weil sie mit
bloßem Kopf auf der Treppe gestanden hatte.</p>
<p class="calibre2">Tine mußte geholt werden.</p>
<p class="calibre2">Tine mußte fortwährend geholt werden. Tine kam, den
Kleiderrock über dem Kopf zusammengeschlagen.</p>
<p class="calibre2">»Gott, was Sie für eine Kälte mitbringen,«
sagte die Mutter, die immer fröstelte, sobald nur eine
Tür ging.</p>
<p class="calibre2">»Tine, ich habe Zahnweh,« sagte sie.</p>
<p class="calibre2">Der Toilettenspiegel mußte mitten auf einen großen
Tisch gestellt werden, und es mußte mit kleinen Zweigen von
einem Busch, der im Garten des Lehrers wuchs, geräuchert
werden. Alle Kinder, Tine und die Mamsell standen herum.</p>
<p class="calibre2"><a id="page14" title="woldemar/gary"></a> Das
ganze Schlafzimmer war in Qualm gehüllt, während die
Mutter den geöffneten Mund über die rauchenden Zweige
hielt.</p>
<p class="calibre2">»Tine, Tine, jetzt!« rief die Mutter.</p>
<p class="calibre2">Tine sollte mit einer Haarnadel in die Zähne
hineinstechen.</p>
<p class="calibre2">»Da ist er, da ist er!« rief die Mutter.</p>
<p class="calibre2">»Seht den Wurm!«</p>
<p class="calibre2">Tine hatte sich angestrengt, und es fiel ein Stück Email
vor dem Toilettenspiegel nieder.</p>
<p class="calibre2">Die Mutter glaubte unerschütterlich, es sei ein Wurm, und
wenn drei bis vier Würmer herausgekommen waren, hatte sie nie
mehr Zahnweh.</p>
<p class="calibre2">Tine war aber die einzige, die sie herausstochern konnte. Sie
stocherte sie gewissenhaft aus allen Zähnen der Kinder
heraus.</p>
<p class="calibre2">»Lieber Fritz,« sagte die Mutter zum Vater, der
Einwendungen machte, »ich sehe doch die Würmer mit diesen
meinen beiden Augen. Aber es muß mit Karböllings Busch
geräuchert werden.«</p>
<p class="calibre2">Der Kreisarzt in Sonderburg sagte, der Rauch vom Busch des
Lehrers sei sehr giftig.</p>
<p class="calibre2">Ein Zahnwehprozeß konnte gut einen halben Nachmittag
ausfüllen, bis die Dämmerung hereinbrach.</p>
<p class="calibre2">In der Dämmerung war es herrlich im Waschhaus. Der warme
Dampf füllte den ganzen Raum, und das Feuer unter dem Kessel
sah aus wie ein großes, rotes Auge. Die Mädchen klopften
das gewaschene Zeug mit Hölzern, daß es nur so schallte.
Die Mutter saß auf einem Dreifuß mitten im Lärm.</p>
<p class="calibre2">Nirgendwann und nirgendwo ging den Mädchen das Mundwerk so
wie im Waschhaus.</p>
<p class="calibre2">Der ganze Dorfklatsch strömte zur Tür herein.</p>
<p class="calibre2">Die Mutter konnte auf ihrem Dreifuß stundenlang
zuhören, bis sie plötzlich wieder in die Stube
zurücklief.</p>
<p class="calibre2"><a id="page15" title="woldemar/gary"></a> Und
unweigerlich sagte sie nach solchen Stunden im Waschhause:
»Gott im Himmel, was solche Leute für Ideen
haben.«</p>
<p class="calibre2">Und es war, als schöbe sie mit ihren schönen
Händen etwas von sich weg.</p>
<p class="calibre2">»Daß Sie das alles mit anhören mögen!«
sagte Tine.</p>
<p class="calibre2">»Ja, sie sehen so drollig aus,« sagte die Mutter und
machte den Mädchen alles nach.</p>
<p class="calibre2">Sie konnte jeden einzigen Menschen imitieren, der ins Haus
kam.</p>
<p class="calibre2">Aber meistens blieb sie während der Dämmerung in der
Wohnstube. Dort sang sie. Es gab aber auch Dämmerstunden, in
denen sie im hohen Rohrsessel auf dem Fenstertritt sitzen blieb,
die Hände im Schoß.</p>
<p class="calibre2">Dann sprach sie leise in die stille Stube hinein.</p>
<p class="calibre2">Sie sprach am liebsten davon, wie es sein würde, wenn sie
alt wäre und graues Haar bekäme, ganz graues Haar.</p>
<p class="calibre2">Und wenn sie Witwe wäre, und alle ihre Kinder erwachsen,
und sie arm.</p>
<p class="calibre2">»Furchtbar arm,« sagte sie.</p>
<p class="calibre2">Dann könnte abends nichts auf den Tisch kommen als Butter
und Käse in der alten kristallenen Käseglocke.</p>
<p class="calibre2">»Die Butter muß aber gut sein,« sagte sie. Und
sie malte sich aus, wie weiß das Tischtuch sein sollte, und
wie die Kinder alle von ihrer Arbeit kommen und am Tisch bei ihr
den Tee trinken sollten, bei ihr, die grau und still und alt
dasaß und arm war. Denn die Armut war für sie eine Art
träumerischer Sorglosigkeit.</p>
<p class="calibre2">Sie hatte wohl nie andere »Arme« gesehen als die in
den kleinen weißgetünchten Häusern an der
Dorfstraße.</p>
<p class="calibre2">Wenn der Tee getrunken war und der Vater fort, kamen die besten
Stunden. Das war die Zeit, wo die Puppen hervorgeholt wurden. Der
Speisetisch wurde ausgezogen, wie zu einer Gesellschaft, und die
Mutter thronte <a id="page16" title="woldemar/gary"></a> mitten unter all ihren Pappschachteln, in denen die
Puppen aufbewahrt wurden.</p>
<p class="calibre2">Jetzt, jetzt durften sie herausgeholt werden, denn jetzt war
Vater aus.</p>
<p class="calibre2">Und dann kamen sie hervor zu Hunderten. Es waren Figuren aus
Modejournalen, auf hölzerne Klötze geklebt. Jede hatte
einen Namen, der auf die Rückseite geschrieben war, jede war
etwas – alle wurden sie aufgestellt, über den ganzen
Tisch hin. Und die Komödie begann, während die Mutter
dirigierte.</p>
<p class="calibre2">Die Puppen gaben Gesellschaften und machten Visiten.</p>
<p class="calibre2">Sie plauderten, sie machten Knixe und Bücklinge. Die Mutter
wurde rot vor Anstrengung, und sie rückte herum und leitete
alles, die Arme weit über den Tisch ausgestreckt.</p>
<p class="calibre2">Die Kinder hatten auch ihre Puppen und die Mamsell ebenfalls.
Aber nie gingen die Papierpuppen der Mutter nach Wunsch, und sie
redete für alle.</p>
<p class="calibre2">»Jungfer Jespersen, Jungfer Jespersen, Sie vergessen
Fräulein Lövenskjold.«</p>
<p class="calibre2">»Fräulein Lövenskjold« war stehen geblieben,
und sie sollte sich bewegen. Für die Mutter waren es nicht
Puppen. Für die Mutter waren es Menschen. Sie sprachen und
mimten und sangen. Sie spielten hundert Komödien. Bald in
einem Badeort und bald in Paris.</p>
<p class="calibre2">Die Kinder sahen zu, als zöge die ganze Welt, vornehm und
fein, vor ihnen auf dem Tisch vorbei.</p>
<p class="calibre2">Die Mädchen kamen herein. Sie mochten so gern zuhören.
Sie verstanden kein Wort, aber sie standen kerzengerade da, die
Hände unter den Schürzen, und hörten zu. Wenn mit
den Puppen etwas Trauriges passierte, weinten sie. Aber mitten in
der Komödie sprang die Mutter auf, und die Puppen wurden
durcheinandergeworfen – in die Schürzen, in die
Schachteln. Der Vater kam nach Hause.</p>
<p class="calibre2"><a id="page17" title="woldemar/MEsswein"></a>
»Den Tisch zusammenklappen, den Tisch zusammenklappen!«
Mägde und Kinder kriegten es eilig. Die Mutter selber
ließ vor Schreck alles liegen.</p>
<p class="calibre2">»Gott, daß die Kinder auch noch auf sind,« sagte
sie. Und die Kinder kamen Hals über Kopf ins Bett. Die Mutter
aber saß mitten auf dem Sofa zwischen den beiden
Mahagonischränken und war so erschrocken, daß sie
Eingemachtes und Zwieback haben mußte ...</p>
<p class="calibre2">Sie kostümierte auch die Mägde.</p>
<p class="calibre2">Es war an einem Abend, als sie mit den Kindern allein zu Hause
war.</p>
<p class="calibre2">Da wurde draußen laut an das Hoftor geklopft, und die
Mamsell mußte hinausgehen und aufmachen und kam schreiend
zurück.</p>
<p class="calibre2">»Ein Landstreicher ... Ein Landstreicher ...«</p>
<p class="calibre2">Und der Landstreicher kam in die Stube herein, während die
Mutter am lautesten schrie. Häßlich war er anzusehen, und
die Kinder kreischten. Plötzlich aber entdeckt einer der
Jungens, daß es »die große Marie« ist.</p>
<p class="calibre2">»Mutter, es ist die große Marie!« schreit er.
Aber im selben Augenblick flüstert die Mutter der Marie
zu:</p>
<p class="calibre2">»Gib Nina eins an die Ohren.«</p>
<p class="calibre2">Und Nina kriegte von Maries Fäusten eine Ohrfeige, daß
es nur so klatschte.</p>
<p class="calibre2">Da glaubten die Kinder, es müsse ein Landstreicher
sein.</p>
<p class="calibre2">Hinterher aber bot die Mutter der Männer-Marie einen
Schnaps an, und den mußte sie austrinken, denn jetzt war sie
ja eine richtige Mannsperson.</p>
<p class="calibre2"> </p>
<p class="calibre2">Weißes Haus, du weißes Haus, in jubelnden Scharen
kommen die Erinnerungen an dich – kommen und sammeln sich um
einen. Könnte ich nur mit Worten ein Bild malen, das
unvergänglich wäre – ein Bild von Jugend und
Lächeln, von Anmut und von Traurigkeit, von Frohsinn mit
traurigen Augen, von Schwermut, die mit zitterndem <a id="page18" title="woldemar/MEsswein"></a> Munde lachte; von
hilflosen Händen, die nur die Not der andern zu lindern
verstanden, von feinen Gliedern, die sich in der Sonne dehnten, und
fröstelten, wenn die Sonne unterging.</p>
<p class="calibre2">Ein Bild von der, die das Leben liebte und an seinem Kummer
zugrunde ging.</p>
<p class="calibre2">Sie starb wie eine schöne Blume, die geknickt wird.</p>
<p class="calibre2">Keine Rose, auch keine Lilie.</p>
<p class="calibre2">Eine seltenere Blume, mit zarten Fibern, in späten Jahren
von einem geduldigen Gärtner gezogen; ein vielfarbiger Kelch,
so schön im Sonnenlicht, der sich aber um die Abendzeit scheu
zusammenschließt ...</p>
<p class="calibre2">Ein Siegessang, den der Schmerz in der Kehle erstickt.</p>
<p class="calibre2">Eine Fremde auf Erden, und doch geliebt wie ein seltener
Gast.</p>
<p class="calibre2">Weißes Haus, du meiner Kindheit weißes Haus – so
war sie, die deine Seele war.</p>
<p class="calibre2"> </p>
<p class="calibre2">Aber der Herbst verging, und Weihnachten kam heran.</p>
<p class="calibre2">Die Mutter und Lehrers Tine saßen lange auf, und die Kinder
bekamen Zwetschen, damit sie früh ins Bett gingen.</p>
<p class="calibre2">Die alte Kutsche kam jeden zweiten Tag vor die Tür gerollt,
und der ganze Korridor war voller Fußsäcke. Es
mußten so viele Fußsäcke da sein, wenn die Mutter
ausfahren wollte. Und Sonderburg war nicht, wie Augustenburg,
etwas, das man im Sprunge erreichen konnte, es waren zwei Meilen
bis dahin, folglich eine förmliche Reise.</p>
<p class="calibre2">Wenn die Mutter aber nach Hause kam, lachte und plauderte sie
und tat geheimnisvoll, während die Kinder ins Schlafzimmer
eingeschlossen wurden, denn sie durften nichts sehen. Sie
hörten nur den Kutscher, der aus und ein ging und Kisten
hereinschleppte. Das war das aus Kopenhagen.</p>
<p class="calibre2"><a id="page19" title="woldemar/gary"></a>
»Es« war also gekommen.</p>
<p class="calibre2">Das war die große Frage, ob »es« kam – alle
die Geschenke vom Großvater. Denn kam es nicht, würden
die Weihnachtstische ja leer sein.</p>
<p class="calibre2">Ein Jahr war so viel Eis und Schnee, daß die Kisten
ausblieben. Die Mutter schickte einen Boten nach Sonderburg, und
die Mutter fuhr selber hin, und Mutter ließ den Vater
telegraphieren – es war in den ersten Jahren, als man den
Telegraphen hatte –, aber die Kisten kamen nicht.</p>
<p class="calibre2">Die Mutter weinte und wußte sich keinen Rat. Hundertmal
kehrte sie ihr altes Portemonnaie um. Es war ein Loch darin, so
daß das Geld in ihre Tasche fiel. Schließlich aber legte
sie auf alle Weihnachtstische Tannenzweige, und da sah es aus, als
sei eine Menge da.</p>
<p class="calibre2">Aber diesmal waren die Kisten gekommen, und vom Schlafzimmer aus
konnten die Kinder hören, wie Tine sich abquälte, um sie
aufzukriegen.</p>
<p class="calibre2">Die Mutter selbst hatte keine Ruhe.</p>
<p class="calibre2">»Tine, Tine, sehen Sie –«</p>
<p class="calibre2">Tine sah hin.</p>
<p class="calibre2">»Tine, so, nun geht der Deckel ab.«</p>
<p class="calibre2">Die Kinder stürzten aus dem Bett, aber das
Schlüsselloch war mit Papier zugestopft.</p>
<p class="calibre2">Drinnen in der Wohnstube kniete die Mutter auf dem Fußboden
– so erzählten die Mägde – vor den Kisten.
Der ganze Teppich war überschwemmt mit Paketen, mit Stroh und
Weihnachtssachen.</p>
<p class="calibre2">Und die Mutter rief:</p>
<p class="calibre2">»Nein, nein, das ist für Nina ...«</p>
<p class="calibre2">»Sieh doch, sieh doch, dies ist für William
...«</p>
<p class="calibre2">Und sie kramte weiter im Papier und Stroh herum. Das ganze
Zimmer war übersät damit.</p>
<p class="calibre2">»Herr du meine Güte, ist das ein Aufzug, wenn die Frau
mal was anfaßt,« sagten die Mägde. Sie waren
<a id="page20" title="woldemar/gary"></a> selber auch
furchtbar gespannt und neugierig. Erst spät in der Nacht
wurden sie fertig. Denn es mußten frische Würste gestopft
werden, Teig angerührt, und jeder Fetzen im Hause mußte
zu Weihnachten gewaschen werden.</p>
<p class="calibre2">Die Mutter saß mitten in der Wurstmacherei im Waschhause,
mit aufgeschürztem Kleid, und sang die Lieder vor. Zu einigen,
die die Mägde kannten, summte die Mutter nur die Melodie.</p>
<p class="calibre2">»Denn, Kind,« sagte sie zu Tine, »die Worte sind
zu schlimm.«</p>
<p class="calibre2">Die Alsenschen Wurstlieder waren die schlimmsten Soldatenlieder
im Lande.</p>
<p class="calibre2">»Aber,« sagte die Mutter, wenn es Weihnachten wurde,
»ich glaube wirklich nicht, daß Maren selber weiß,
was sie singt.«</p>
<p class="calibre2">Gewöhnlich sang Maren, das Waschmädchen, immer nur
Lieder vom ersten schleswigschen Krieg und von König Friedrich
VII. ... Die waren so traurig, daß sie dabei weinte.</p>
<p class="calibre2">In den letzten Tagen wurde gebacken.</p>
<p class="calibre2">Das ganze Haus war voll Apfel- und Kuchenduft, und die Tür
zum blauen Fremdenzimmer stand nicht still. Denn dort wurden Apfel,
Gewürz, Zwetschen und alle guten Dinge aufbewahrt. Dann kam
Tine die Treppe heraufgelaufen, daß ihr die Röcke
flogen:</p>
<p class="calibre2">»Hallo, Kinderchen, jetzt geht's los!« rief sie.</p>
<p class="calibre2">Die Kinder formten Männer und Frauen aus dem braunen Teig,
der zuletzt ganz dreckig wurde.</p>
<p class="calibre2">Die Mutter hatte eine weiße Schürze um, und der Vater
ging ganz bekümmert umher, weil sie sich die Hände dabei
verderben könne.</p>
<p class="calibre2">Die Mutter wollte immer die letzte Hand anlegen, sie bestrich
die Kuchen mit Eiweiß, und sie setzte den
Pfefferkuchenmännern die Augen ein.</p>
<p class="calibre2">»Jetzt laßt mich, jetzt laßt mich,« sagte
sie.</p>
<p class="calibre2"><a id="page21" title="JohannN/woldemar"></a> Und
ihre weiße Schürze flatterte, so eilig hatte sie es,
während alle Kinder immerfort hinter ihr herliefen.</p>
<p class="calibre2">War das ein Dampf und ein Duft von Gewürz und ein Klappern
mit den Kuchenplatten und ein Spektakel mit den Öfen. Denn die
Öfen flogen auf und zu, und Kuchenplatten kamen hinein, und
Kuchenplatten kamen heraus. Lehrers Tine aber peitschte den Teig
für die weißen Schaumkuchen und hielt dabei die irdene
Schüssel fest zwischen die Knie geklemmt, denn die weißen
Kuchen erforderten Kräfte, und die Eier mußten
stundenlang geschlagen werden.</p>
<p class="calibre2">»So, jetzt will ich,« sagte die Mutter.</p>
<p class="calibre2">Und sie faßte die irdene Schüssel und rührte mit
dem großen Löffel darin herum.</p>
<p class="calibre2">»Puh, macht das heiß,« sagte sie und ließ
sie wieder los.</p>
<p class="calibre2">Und sie fing an zu singen, im Qualm auf dem Haublock sitzend,
mit roten Wangen und so vergnügt:</p>
<p class="calibre2">Lisbeth, Lisbeth!<br class="calibre3"/>
O wie bist du süß und nett!<br class="calibre3"/>
Nicht so kokett!<br class="calibre3"/>
Lisbeth, Lisbeth!<br class="calibre3"/>
O wie bist du süß und nett!</p>
<p class="calibre2">Und alle sangen sie mit, im Qualm und Dunst, die Mädchen
und die Kinder und Tine, die Mutter aber war schon wieder drinnen
in der Wohnstube:</p>
<p class="calibre2">»Tine, Tine!« rief sie, »lassen Sie jetzt die
Kinder dran.«</p>
<p class="calibre2">Sie hatte sich in den Schaukelstuhl fallen lassen.</p>
<p class="calibre2">Sie war von den vielen Nichtigkeiten müde geworden.</p>
<p class="calibre2">Alle Türen standen offen, so daß der Kuchendunst
hereindrang, die Schneebesen lärmten und die Ofentüren
klapperten.</p>
<p class="calibre2">»Ach, Tine geben Sie mir meine Briefe her,« sagte die
Mutter.</p>
<p class="calibre2">Es waren die Briefe aus dem Sekretär, alle Jugendbriefe der
Mutter von ihrer eigenen Mutter, von ihren <a id="page22" title="JohannN/woldemar"></a> Freundinnen und von ihrem
Vater. Sie lagen zierlich in Pakete geordnet, vergilbt,
zusammengefaltet, wie in jener Zeit, als man noch keine Kuwerte
hatte, mit verwelkten Veilchen dazwischen, mit Bändern
umwunden.</p>
<p class="calibre2">Die Mutter liebte ihre Briefe.</p>
<p class="calibre2">Sie las sie nicht. Sie saß aber und hielt sie in ihrem
Schoß.</p>
<p class="calibre2">Und dann erzählte sie.</p>
<p class="calibre2">– Von ihrem Vater, dem alten Postmeister mit der hohen
Halsbinde – einem von den richtigen Beamten, einem von denen,
die immer dachten, sie müßten sehr grob sein, wenn sie im
Amt waren. Die Bauern nannten ihn »Vater«, aber sie
zitterten, wenn sie ihn stören sollten.</p>
<p class="calibre2">– Und von ihrer Mutter, die, durch die Gicht an ihren
Rollstuhl gefesselt, so zart und so fein gewesen, als hätte
sie gar keinen Körper, mit einem bleichen Gesicht, einem
Gesicht ohne Farbe und einem Munde, der nicht gern redet, weil er
sich müde geredet hat und jetzt lieber seine Geheimnisse
verschweigt.</p>
<p class="calibre2">»Ja, sie schwieg sich aus,« sagte die Mutter und sah
vor sich hin, die Briefe in ihrem Schoß. Es war, als wenn eine
plötzliche Mattheit sie überkäme, und ihre Stimme
klang verändert. »Aber das lernen wir wohl alle,«
sagte sie. Man hörte plötzlich den Vater ins Zimmer
kommen. »Ich bin es nur,« sagte er. Die Mutter senkte den
Kopf. Gleich darauf erzählte sie weiter, aber
gewissermaßen hastiger.</p>
<p class="calibre2">Sie erzählte von ihren Freundinnen, den jungen Mädchen
aus dem weißen Hause.</p>
<p class="calibre2">»Ach, wir hatten unsere Zimmer ganz oben im Turm,«
sagte sie, »und wenn wir unsere Fenster aufmachten, sahen wir
das Meer ...« Die Mutter legte ihre Hände in den
Schoß.</p>
<p class="calibre2">»Ja, Gott mag wissen, wie es zuging,« sagte sie,
»aber es ist ihnen allen schlecht gegangen.«</p>
<p class="calibre2"><a id="page23" title="lac/woldemar"></a>
Unglücklich verheiratet hatten sie sich, auf Abwege waren sie
geraten und in der weiten Welt verstreut.</p>
<p class="calibre2">Das einzige, was sie sich bewahrt hatten, war ihr Geld und ihre
Vornehmheit.</p>
<p class="calibre2">»Sie hatten zu heißes Blut,« sagte die Mutter.
»Ich glaube,« – und sie schwieg einen Augenblick
– »die Familie war liebeskrank.«</p>
<p class="calibre2">Manchmal kamen Briefe von ihnen, aus fernen Städten und
Ländern, wo sie als Baronessen und Gräfinnen lebten, mit
Verbannten und Spielern verheiratet.</p>
<p class="calibre2">Eine von ihnen wohnte in Norditalien. Die Mutter weinte immer,
wenn sie von ihr einen Brief bekam.</p>
<p class="calibre2">»Ach,« sagte sie, »sie wurde mit so einem alten
Knast verheiratet, einige sagen, er sei ein Lord, und andere sagen,
er sei Schuhmacher gewesen.« Aber jedes Jahr kamen von dieser
Freundin auch Briefe aus Kopenhagen.</p>
<p class="calibre2">Sie war daheim – – um ihren Sohn zu sehen.</p>
<p class="calibre2">»Das ist ja das einzige, was sie hier auf Erden
liebt,« sagte die Mutter zu Tine.</p>
<p class="calibre2">Den Sohn hatte sie wahrscheinlich auf etwas irreguläre
Weise bekommen, und da hatte sie wegreisen müssen und war dort
unten in Norditalien mit dem Lord oder Schuhmacher verheiratet
worden.</p>
<p class="calibre2">»Aber reich ist sie ja,« sagte die Mutter. Es war
fast, als käme der Weltschmerz über sie, wenn sie von
dieser Freundin sprach.</p>
<p class="calibre2">»Gott mag wissen, wie es zugeht,« sagte sie wieder,
»aber es ging ihnen allen schlecht.«</p>
<p class="calibre2">Der Vater der Freundin kam zuweilen, immer ganz plötzlich
und blieb immer nur kurze Zeit.</p>
<p class="calibre2">Ein großer, magerer Mann mit der Haltung eines Menschen,
der, ohne den Rücken zu beugen, gewohnt ist, bei Hofe zu
verkehren.</p>
<p class="calibre2">Die Mädchen meldeten manchmal ganz unvermutet:</p>
<p class="calibre2">»Der Herr Hofjägermeister ist da!«</p>
<p class="calibre2"><a id="page24" title="lac/woldemar"></a> Und er
trat ein und verbeugte sich so merkwürdig tief und so seltsam
bewegt vor der Mutter, die ihm entgegenschritt. Und dann ließ
er sich immer in großem Abstand von ihr nieder und sprach mit
einer Stimme, die weit herzukommen und vom Kummer matt geworden zu
sein schien.</p>
<p class="calibre2">Und er ging so plötzlich, wie er gekommen war.</p>
<p class="calibre2">Die Mutter aber weinte, wenn er fort war, und die Kinder hatten
Angst, denn es war beinah, als sei ein Gespenst da gewesen.</p>
<p class="calibre2">»Ich wollte Sie nur sehen,« sagte er, wenn er
fortging, verbeugte sich wieder und küßte der Mutter die
Hand.</p>
<p class="calibre2">Er kam, um von denen sprechen zu können, die so weit
entfernt waren ...</p>
<p class="calibre2">... Die Mutter aber blieb im Weihnachtsdampf sitzen mit ihren
Jugendbriefen auf dem Schoß. Lehrers Tine saß auf einem
Schemel neben ihrem Stuhl.</p>
<p class="calibre2">Die Mutter erzählte von ihrer Verlobungszeit.</p>
<p class="calibre2">Sie kam ja aus der Provinz; sie kannte nichts und wußte von
nichts und fühlte sich fremd im alten Hause der Exzellenz.</p>
<p class="calibre2">Das war etwas ganz Neues und sehr Beängstigendes, im
Erdgeschoß die Mynsters und die Örsteds, und oben im
zweiten Stock der Öhlenschläger.</p>
<p class="calibre2">Es war ein Leben, die Kronleuchter immer angezündet, die
Schwiegermutter in schwarzem Samt, und die alten Familienwappen auf
alle Kissen gestickt, dazu die silbernen Kannen auf den Etageren,
und die Gemälde an den Wänden so feierlich wie in einer
Kunstsammlung.</p>
<p class="calibre2">Die Mutter ging ganz verschüchtert umher.</p>
<p class="calibre2">Aber bei der Verlobungsfeier, wo Toaste ausgebracht wurden und
Seine Exzellenz selber die Verse gemacht hatte, da schlich sich die
Mutter auf die Treppe hinaus, die zu Öhlenschläger
hinaufführte, und dort saß sie und weinte; das Gesicht in
den Händen, weinte sie und weinte. <a id="page25" title="lac/woldemar"></a> Der Diener fand sie.</p>
<p class="calibre2">Er mußte den Vater holen.</p>
<p class="calibre2">»Nein, nein, ich will nicht hinein,« sagte sie,
»laß mich nach Hause, laß mich nach Hause.«</p>
<p class="calibre2">Und sie weinte, als ginge es ihr ans Leben.</p>
<p class="calibre2">Und die Mutter erzählte weiter, mit den Briefen im
Schoß, von ihrer Jugend, von den entschwundenen Tagen.
Plötzlich sagte sie:</p>
<p class="calibre2">»Ja, es gibt Dinge, an die man nie denken sollte.«</p>
<p class="calibre2">Tine sagte: »Es ist doch immer gut, an das Glück zu
denken.«</p>
<p class="calibre2">»Nein, die Erinnerung daran zerbricht einen.« Die
Mutter stand auf. »Aber wie wunderbar schön war das
Schlittschuhlaufen,« sagte sie.</p>
<p class="calibre2">Dann lief sie wieder hinaus zu den Schaumkuchen. Jetzt
mußten sie doch genug gerührt sein. Oder sie mußte
plötzlich Lorbeerblätter auf die Sülze legen.</p>
<p class="calibre2">»Denn es muß doch alles gemacht werden,« sagte
sie, und lief hin und her, während Tine alles machte. –
–</p>
<p class="calibre2"> </p>
<p class="calibre2">Kindertage –<br class="calibre3"/>
zu euch bin ich zurückgeflüchtet,<br class="calibre3"/>
daß ihr lindert meines Herzens Weh.<br class="calibre3"/>
Niemand zählt die Tränen,<br class="calibre3"/>
die verweinte Augen<br class="calibre3"/>
so gerne weinen möchten.<br class="calibre3"/>
Kindheitstage,<br class="calibre3"/>
Kindheitsfreuden,<br class="calibre3"/>
lindert meines Herzens Weh!</p>
<p class="calibre2">Du, Mutter,<br class="calibre3"/>
die selber litt,<br class="calibre3"/>
schlank wie die Blume,<br class="calibre3"/>
die jäh geknickt.<br class="calibre3"/>
Du, Mutter,<br class="calibre3"/>
die selber liebte,<br class="calibre3"/>
bleib jetzt bei mir<br class="calibre3"/>
in meines Herzens Weh.</p>
<p class="calibre2"><a id="page26" title="lac/woldemar"></a><br class="calibre3"/>
Weit muß der Mensch gehn,<br class="calibre3"/>
und fest muß sein Schritt sein.<br class="calibre3"/>
Kindheitsfreuden,<br class="calibre3"/>
kommt mit eurem Jubel,<br class="calibre3"/>
lindert<br class="calibre3"/>
– eine Weile nur –<br class="calibre3"/>
meines Herzens Weh.<br class="calibre3"/>
Kindheitsfreuden<br class="calibre3"/>
ich flehe euch an:<br class="calibre3"/>
daß ihr mögt lindem meines Herzens Weh.</p>
<p class="calibre2"> </p>
<p class="calibre2">Mutters größter Tag aber war der Tag vor dem Heiligen
Abend.</p>
<p class="calibre2">Denn das war der Tag der Armen.</p>
<p class="calibre2">Vom frühen Morgen an – und es war sicher der einzige
Tag im Jahre, an dem sie so früh aufstand – hatte die
Mutter Reis in Beutel getan und Kaffeebohnen in Tüten und
Kandiszucker danebengelegt.</p>
<p class="calibre2">Auf dem Tisch stand eine Wage, und Tine wog ab.</p>
<p class="calibre2">Recht mußte sein und in jedem Beutel gleich viel.</p>
<p class="calibre2">Die Mutter aber schüttete hinzu, und ihr war es nie
genug.</p>
<p class="calibre2">»Lieber Gott,« sagte sie, »als ob mehr als einmal
im Jahr Weihnachten wäre.«</p>
<p class="calibre2">Wenn alle Beutel gefüllt waren, gab es keine Kaffeebohnen
und keinen Zucker mehr im Hause.</p>
<p class="calibre2">»Denn wir nehmen von unserm eigenen,« sagte die
Mutter, wenn es knapp war.</p>
<p class="calibre2">Am Nachmittag kamen dann die Tagelöhnerfrauen angesockt. Es
war gleichsam, als schlichen sie sich am Hause entlang. Und sie
stellten ihre Holzpantoffel in eine Reihe auf den Flur und traten
auf schwarzen Socken in die Wohnstube, sprachen kein Wort, sondern
bekamen nur ihr Teil und reichten mit einem »Schön
Dank« ihre schlaffe Hand hin.</p>
<p class="calibre2">Die Mutter aber hatte genug mit Fragen zu tun: die hatte dies
nötig und die andere das.</p>
<p class="calibre2"><a id="page27" title="Choleriker/woldemar"></a>
Wenn die Tagelöhnerfrauen glücklich fort waren, gab es im
Kinderzimmer keinen überflüssigen Lappen mehr.</p>
<p class="calibre2">»Tinchen,« sagte die Mutter, »wir werden schon
etwas wieder kriegen.«</p>
<p class="calibre2">Sie sank in einen Lehnstuhl nieder, ließ alle Fenster weit
öffnen und mit Eau de Cologne sprengen.</p>
<p class="calibre2">»Denn, Kinderchen,« sagte sie, »die Reinlichsten
stinken nach grüner Seife.«</p>
<p class="calibre2">Der Vater befahl dem Stubenmädchen, alle Türklinken
abzuwischen.</p>
<p class="calibre2">... Am andern Tage wurden die Weihnachtstische zurechtgemacht.
Das war eine mühsame Sache, und die Mutter brauchte viel Zeit
dazu. Denn jeder sollte gleich viel haben. Den ganzen Tag ging die
Mutter umher und maß und schätzte mit den Augen ab; wenn
auf einem Tisch zu wenig war, so stahl sie eine Kleinigkeit von
einem andern.</p>
<p class="calibre2"> </p>
<p class="calibre2">Der Baum wurde angezündet. Tine stand auf einer Leiter,
während sie ihn anzündete. Nur Silber und Silber und
lauter weiße Kerzen. Die Mutter ging rund um den Baum herum.
»Da ist noch eins,« sagte sie. Und sie deutete auf ein
unangezündetes Licht. Sie konnte nie Licht genug bekommen, und
sie setzte die Kerzen viel zu dicht auf die Zweige.</p>
<p class="calibre2">»Aber wir stecken den Baum an,« sagte Tine von der
Leiter herab. Ein Jahr hatten sie wirklich den Weihnachtsbaum in
Brand gesetzt. In einem Moment brannte es hell auf, während
all das Silber flammte und verkohlte und die Mutter zusah, den
Feuerschein auf dem Gesicht. »Wie schön, wie
schön,« sagte sie. Da fingen die Zweige Feuer. »Hier
wird Feuer,« rief die Mutter.</p>
<p class="calibre2">»Ja, freilich,« sagte Tine, die auf den Korridor
hinausstürzte und zwei wollene Tücher holte, die sie
über den brennenden Baum warf. Die Mutter aber stellte mehrere
<a id="page28" title="woldemar/gary"></a> Armleuchter
auf alle Tische, und die Kinder mußten um den verkohlten Baum
tanzen. »Stella,« sagte der Vater, »wie unvorsichtig
du bist.«</p>
<p class="calibre2">Mutters Augen blitzten plötzlich auf. »Fritz,«
sagte sie und hob den Kopf, als sähe sie den schönen,
flammenden Baum noch vor sich: »Fritz, es war so
schön!« ...</p>
<p class="calibre2">... »Da ist noch eins.« Dann war keins mehr da. Alle
Lichte zwischen dem glitzernden Silber waren angezündet. Die
Mutter stand schweigend im Glanz des Baumes.</p>
<p class="calibre2">»Das ist unser dreizehntes Weihnachten hier,« sagte
sie, und ihre Stimme klang plötzlich matt. »Aber die
Tische, Tine,« sagte sie und wechselte den Ton, während
sie schnell und gründlich über die weißen
Tischtücher hinblickte. »Für Lars, den
Großknecht, ist nicht genug da.« Sie stand grübelnd
vor dem Tisch des Großknechts. »Aber was soll man
für Lars auch finden, Tine?« Plötzlich nickte sie
mit dem Kopf. »Tine,« sagte sie, »laufen Sie zu
Fritz hinein. Wir stehlen zehn Zigarren.«</p>
<p class="calibre2">Tine schlich in des Vaters Zimmer hinein. »Dürfen wir
kommen?« riefen die Kinder in der Wohnstube.</p>
<p class="calibre2">»Gleich,« sagte Tine und machte die Tür hinter
sich zu. Sie hatte die Zigarren in Sicherheit gebracht.</p>
<p class="calibre2">»Gott sei Dank,« sagte die Mutter und seufzte, als sei
sie von einer Last befreit. »Nun binden wir sie mit einem
roten Band zusammen,« sagte sie.</p>
<p class="calibre2">»Ich habe kein Band,« sagte Tine.</p>
<p class="calibre2">Die Mutter sah sich um, auf allen Tischen. »Wir nehmen eine
Schleife von Fräulein Jespersens Fischü.« Das
Fischü war ein Geschenk für Mutter von Fräulein
Helene Jespersen. Es war mit vielen kleinen rosa Schleifen besetzt.
»Ja,« sagte die Mutter, während Tine das Band
abtrennte, »es sind auch zu viele Schleifen auf Fräulein
Jespersens Fischü.« Das rosarote Bandende wurde um die
Zigarren geknotet. »So, jetzt machen wir auf,« sagte
<a id="page29" title="woldemar/gary"></a> die Mutter.
Sie öffnete selbst die Tür, und die Kinder stürmten
herein. »Fröhliche Weihnachten,« sagte die Mutter.
Sie stand mitten auf der Schwelle.</p>
<p class="calibre2">»Wo ist mein Tisch?«</p>
<p class="calibre2">»Wo ist mein Tisch?«</p>
<p class="calibre2">»Wo ist meiner?« riefen die Kinder im Chor. »Da,
da,« sagte die Mutter. Ihr Gesicht strahlte. Die Kinder
scharten sich mit hochgereckten Händen um sie.</p>
<p class="calibre2">»Mutter, Mutter,« riefen sie, »jetzt das vom Baum
– jetzt das vom Baum.«</p>
<p class="calibre2">»Ja.« Die letzten Geschenke lagen, in viel Papier
eingewickelt, unter dem Weihnachtsbaum. Die Mutter kroch auf dem
Fußboden umher, holte sie hervor und sammelte die Pakete in
ihrem Schoß. Jetzt hatte sie alle, und sie stand mitten
zwischen den Kindern auf.</p>
<p class="calibre2">»Jetzt, jetzt,« riefen die Kinder.</p>
<p class="calibre2">»Ja.« Und sie warf sie wie wahllos zu den
emporgereckten Händen der Kinder hinunter: »für
dich,« und »für dich,« und »für
dich,« rief sie, während die Kinder jubelten.</p>
<p class="calibre2">Der Vater war in die offene Tür getreten. An den
Türrahmen gelehnt, stand er schweigend da und betrachtete die
Mutter und seine Kinder. Und hastig, während ein Schimmer von
Zärtlichkeit – oder vielleicht nur von Bewunderung
– einen Moment in seinen Augen aufblitzte, ging er auf die
Mutter zu. »Du Geberin,« flüsterte er. Die Mutter
schlug die Augen nieder, daß es fast aussah, als schlösse
sie sie eine Sekunde. »Du gibst, Fritz,« sagte sie. Der
Vater glitt beiseite. »Aber jetzt müssen die Leute
herein, Tine,« sagte die Mutter. Sie hatten sich schon auf dem
Korridor versammelt. Die Mägde waren auf Socken, und die
Knechte hatten Stiefel an. »So, Kinder,« sagte die Mutter
und machte die Tür auf, »jetzt ist Weihnachtsabend.«
Sie kamen alle herein, einer nach dem andern, sehr langsam, mit
einem wunderlichen Sprung über die <a id="page30" title="woldemar/gary"></a> Türschwelle, als setzten sie
über eine Barrikade. Und Gesichter machten sie, als gingen sie
zum Altar. Zuletzt kam Jens, der Kuhhirt. Er hatte eine gestreifte
Weste über traurig hängenden Hosen an. Sie bekamen die
Geschenke und bedankten sich – was sie sagten, hat nie ein
Mensch gehört – und trugen die Dinge in die Ecke, als
wollten sie sie in Sicherheit bringen; dabei schielten sie nach den
Geschenken der anderen hin.</p>
<p class="calibre2">»So, Jens,« sagte die Mutter, »jetzt wollen wir
tanzen.« Es wurde eine Kette gebildet. Den Anfang machte sie
selbst mit Jens, dann kamen die Kinder mit den Mägden und
Knechten.</p>
<p class="calibre2">»Den Kreis schließen,« rief sie Tine zu und sie
setzte sich in Bewegung. Langsam zog der Kreis um den Baum,
während die Mutter mit ihrer etwas zitternden Stimme zu singen
anfing.</p>
<p class="calibre2">»Schön ist die Erde,<br class="calibre3"/>
Prächtig ist Gottes Himmel,<br class="calibre3"/>
Schön ist der Seelen Pilgrimsgang.<br class="calibre3"/>
Hin durch die holden<br class="calibre3"/>
Reiche der Erde<br class="calibre3"/>
Gehn wir zum Paradies mit Gesang.«</p>
<p class="calibre2">Nach und nach fielen alle ein, während Mutters Stimme
lauter wurde und sie langsam weiter um den Baum wanderten. Alle
Gesichter waren nach oben gewandt, zum Licht des Weihnachtsbaumes.
Vom anderen Zimmer aus dem Halbdunkel fiel plötzlich Vaters
Stimme ein, so merkwürdig tief, wie von weit her. Die Mutter
war beim Klang seiner Stimme stehen geblieben. Dann ging sie wieder
weiter, immer in das Licht des Baumes starrend.</p>
<p class="calibre2">»Durch die holden<br class="calibre3"/>
Reiche der Erde<br class="calibre3"/>
Ziehn wir zum Paradies mit Gesang.«</p>
<p class="calibre2">Der Gesang erstarb.</p>
<p class="calibre2">»Singe jetzt allein, Mutter,« sagte der älteste
Junge.</p>
<p class="calibre2">»Ja, gnädige Frau, singen Sie allein,« sagte die
<a id="page31" title="woldemar/gary"></a>
Männer-Marie, die die ganze Zeit bitterlich weinte, ohne es zu
wissen.</p>
<p class="calibre2">»Ja,« sagte die Mutter. Und ohne ihre Augen vom Licht
des Baumes fortzuwenden, sang sie halblaut – sie allein
–, während sie alle noch langsamer gingen:</p>
<p class="calibre2">Freude hat heute auf Erden<br class="calibre3"/>
Der Himmelskönig gebracht.<br class="calibre3"/>
Da wird der Ärmsten werden<br class="calibre3"/>
Zur Weihnachtsfreud gedacht.</p>
<p class="calibre2">Nun tanze, Kind, auf Mutters Schoß,<br class="calibre3"/>
Ein Freudentag erstand,<br class="calibre3"/>
Jetzt führt in seiner Gnade groß<br class="calibre3"/>
Der Heiland uns an der Hand.</p>
<p class="calibre2">Es war einen Augenblick still, und alle waren stehen geblieben.
»Nun spielen wir,« sagte die Mutter. Und sie setzte Jens,
den Kuhhirten, in Galopp, daß alle folgen mußten,
während sie sang, und die Kinder fielen ein: »Um den
Baum, da wird gesungen, und ein froher Reihn geschwungen.«</p>
<p class="calibre2">»Du meine Güte,« sagte die Mutter, »singt
der Bengel falsch.« Der Alteste brüllte nur so zum Baum
hinauf. Der Kleinste in der Kette fiel. »Auf,« sagte
Tine. Aber der Kleinste weinte. »Tanzt nur weiter,« sagte
die Mutter, und sie setzte sich und nahm den Kleinsten auf den
Schoß.</p>
<p class="calibre2">Die Lichter brannten herab, und sie hörten auf zu tanzen.
Die Leute trabten davon, und Tine fing an, die Kleinsten zu Bett zu
bringen. Die Mutter saß noch immer auf demselben Fleck. Auf
dem Fußboden, den Kopf an ihren Knien, lag der älteste
Junge, während die Kerzen verlöschten, eine nach der
andern, und der Glanz des Silbers matt wurde. »Mutter,«
sagte er, »jetzt stirbt der Weihnachtsbaum.« »Ja,
mein Junge,« sagte die Mutter, und ihre schöne Hand fiel
von seinem Haar in ihren Schoß. »Jetzt stirbt
er.«</p>
<p class="calibre2">Tine kam zurück. Noch brannten die letzten Lichte. <a id="page32" title="woldemar/gary"></a> »Bring ihn zu
Bett,« sagte die Mutter. »Schlaf wohl,« sagte sie,
und sie küßte den Jungen auf die Stirn. »Gute Nacht,
Mutter.«</p>
<p class="calibre2">Die Mutter saß allein.</p>
<p class="calibre2">Die letzten Lichte flackten auf und erloschen. Der Baum war
dunkel. Durch die Zimmer hörte man den Schritt des Vaters.</p>
<p class="calibre2">»Sind Sie hier, gnädige Frau?« sagte Tine, die
zurückkam.</p>
<p class="calibre2">»Ich sitze hier.«</p>
<p class="calibre2">Sie schwiegen einen Augenblick. Dann sagte die Mutter:
»Tine, nehmen Sie die Doppeltür fort.« Tine tat es.
»Und machen Sie auf,« sagte die Mutter. Sie war
aufgestanden und hatte sich einen Schal um die Schultern gelegt.
Still trat sie hinaus auf die schneebedeckte Gartentreppe. Tine
folgte ihr. Vor ihnen lag der Garten weiß und stumm. Die
Mutter stand lange mit aufwärts gewandtem Gesicht und starrte
zu den Sternen hinauf.</p>
<p class="calibre2">»Gnädige Frau,« sagte Tine, »wo ist der
Stern von Bethlehem?«</p>
<p class="calibre2">Die Mutter antwortete nicht. Vielleicht hatte sie es nicht
gehört. »Sehn Sie die Venus, Tine?« sagte sie dann.
Und wieder standen sie schweigend da. Man hörte keinen Laut in
dem weißen Garten. Die stillen Felder schliefen. Stumm
wanderten die Sterne über ihnen.</p>
<p class="calibre2"> </p>
<p class="calibre2">Nach Weihnachten kam die Zeit, wo gelesen wurde.</p>
<p class="calibre2">Tine kam in der Dämmerung und bekam den Inhalt der
Bücher erzählt.</p>
<p class="calibre2">Die Mutter saß vor dem Kachelofen, die weißen
Hände um die Knie geschlungen, und erzählte und dichtete
um. Es gab kein Buch, das in ihren Gedanken dasselbe Buch
blieb.</p>
<p class="calibre2">Öhlenschläger war in solchem feierlichen, schwarzen
Einband, und auf den Blättern waren so viele Zeichen. Die
<a id="page33" title="hella/woldemar"></a> Mutter
konnte die Tragödien fast auswendig, und doch las sie sie
immer wieder. Wenn sie vom Buch aufsah, während die Kinder
lauschten, schienen ihre Augen doppelt so groß geworden zu
sein.</p>
<p class="calibre2">»Mutter, lies weiter,« sagte der älteste
Junge.</p>
<p class="calibre2">»Sollen denn die Kinder nie ins Bett?« sagte der Vater
und öffnete seine Tür.</p>
<p class="calibre2">»Ja, Fritz, gleich,« antwortete die Mutter und las
weiter.</p>
<p class="calibre2">Ihre Stimme war sanft, wie traurige Liebkosungen, und in ihren
Augen standen Tränen. Am liebsten las sie Thoras Worte, wo sie
von Hakons Leiche Abschied nimmt.</p>
<p class="calibre2">Tine aber saß und schnaufte wie ein Seehund.</p>
<p class="calibre2">»Kommen die Kinder noch ins Bett?«</p>
<p class="calibre2">»Gleich, Fritz, gleich ...«</p>
<p class="calibre2">Und die Mutter las weiter.</p>
<p class="calibre2">Oft war es Christian Winther. Meistens »die
Hirschflucht«. Ihre Stimme legte sich so weich um die
Verse.</p>
<p class="calibre2">»Ach. Niemand liest wie die Frau,« sagte das
Stubenmädchen. Sie hörte hinten in der Ecke beim
Bücherschrank zu.</p>
<p class="calibre2">Schließlich riß dem Vater die Geduld, die Kinder
mußten ins Bett.</p>
<p class="calibre2">Dann weinten sie und bekamen Zwetschen, damit sie artig mit dem
Kindermädchen fortgingen.</p>
<p class="calibre2">Die Mutter aber begleitete Tine mit bloßem Kopf die Allee
hinauf.</p>
<p class="calibre2">In klaren Nächten ging sie dort lange auf und ab. Sie
liebte die Sterne so sehr. Lange Zeit konnte sie stehen und
zählen, wie viele sie auf einer Stelle sehen konnte.</p>
<p class="calibre2">Tine stand daneben.</p>
<p class="calibre2">Sie fragte, wie die Sterne hießen.</p>
<p class="calibre2">Die Mutter aber hatte ihnen Namen nach ihren Freunden
gegeben.</p>
<p class="calibre2">Der dort war ihrer Mutter Stern.</p>
<p class="calibre2">»Sehen Sie ihn?«</p>
<p class="calibre2"><a id="page34" title="woldemar/gary"></a> Und das
war Alices Stern. »Sehen Sie ihn? Der sieht so traurig
aus.«</p>
<p class="calibre2">Es gab so viele traurige Sterne, und die liebte sie am
meisten.</p>
<p class="calibre2">»Stella!« rief der Vater vom Giebelfenster her.
»Stella! Du erkältest dich.«</p>
<p class="calibre2">»Ich sehe mir nur die Sterne an,« sagte sie. Sie blieb
einen Augenblick stehen und hatte ihr weißes Gesicht noch
immer nach oben gerichtet. »Das ist Fritzens Stern,«
sagte sie ganz leise. Und sie ging still hinein.</p>
<p class="calibre2">Aber in die Sterne zu starren war bei ihr fast eine
Leidenschaft.</p>
<p class="calibre2">»Ich bin dann mit all meinen Freunden zusammen,« sagte
sie. Zuweilen begleitete sie Tine bis zum Kirchhof, aber nie
weiter. Denn sie fürchtete sich vor Gespenstern. Sie glaubte
steif und fest an Gespenster, und daß es zu Hause im blauen
Zimmer spukte, war bombensicher.</p>
<p class="calibre2">Sie bekräftigte es mit einem Kopfnicken.</p>
<p class="calibre2">»Fritz weiß es auch,« sagte sie.</p>
<p class="calibre2">In dem blauen Zimmer spukte eine weiße Dame, und wenn sie
sich sehen ließ, mußte jemand sterben.</p>
<p class="calibre2">Die Mutter hatte sie einmal gesehen, und da war der alte
Postmeister gestorben.</p>
<p class="calibre2">Außerdem wußte sie viele Spukgeschichten und
erzählte sie im Dämmern, daß es die Kinder
gruselte.</p>
<p class="calibre2">Am liebsten erzählte sie die von Aaholm, denn von der
wußte sie, daß sie wahr sei, sie war einer ihrer Tanten
passiert.</p>
<p class="calibre2">»Auf Aaholm hatte es schon immer gespukt,« sagte die
Mutter, »diesmal aber war es ganz sicher, denn Olivia saß
und frisierte sich zum Ball, als sie plötzlich eine Dame aus
der Wand heraustreten sieht – leibhaftig – sie sah sie
im Spiegel. In grauem Seidenkleid mit großen
Rosensträußen kam sie auf Olivia zu und stellte sich
hinter ihren Stuhl – –</p>
<p class="calibre2"><a id="page35" title="woldemar/gary"></a> Olivia
aber fuhr auf, stürzte auf den Gang hinaus und schrie, schrie
– – Ein Glück war es aber, daß die Dame sie
nicht bei der Hand gefaßt hatte. Denn das war doch einer
Gesellschafterin passiert ... und die kam auf den Gang
hinausgelaufen, die Treppe hinauf, zur Gräfin hinein, und
rief: ›Eine Dame kam aus der Wand heraus, ging gerade auf
mich zu und faßte mich bei der Hand – – und drehte
mich herum‹ ...</p>
<p class="calibre2">Und da im selben Augenblick wurde die Gesellschafterin
verrückt ...</p>
<p class="calibre2">Es war nichts zu machen, sie war und blieb
verrückt!«</p>
<p class="calibre2">Erzählte die Mutter.</p>
<p class="calibre2">Und sie fügte hinzu, schließlich habe der Graf zu
Aaholm jene Stelle in der Mauer niederreißen lassen, und in
einem geheimen Raum habe man ein Skelett gefunden.</p>
<p class="calibre2">»Natürlich war sie ermordet worden,« sagte die
Mutter.</p>
<p class="calibre2">Trotzdem sei es mit den Gespenstern eine eigene Sache.
Vorbedeutungen dagegen, das sei etwas Tatsächliches. Und Hunde
und Eulen wüßten mehr als Menschen.</p>
<p class="calibre2">Niemals schrien die Eulen am Kirchturm, wenn nicht in der
Gemeinde bald jemand starb.</p>
<p class="calibre2">»Das weiß der Küster auch,« sagte die Mutter
und nickte.</p>
<p class="calibre2">An Winternachmittagen ging die Mutter mit den Kindern auf
Besuch. Alle Kinder plauderten, während sie die Allee
hinaufschritten und die Mutter umringten wie ein Schwarm junger
Vögel.</p>
<p class="calibre2">Oben, am Ende der Allee, wohnte der Dorfschulze. Schmuck und
sauber und weiß, breit und groß lag der Hof da, mitten im
weißen Felde, abgeschlossen durch ein grüngestrichenes
Tor.</p>
<p class="calibre2">Manchmal gingen sie zu Dorfschulzens hinein. Die Frau des
Dorfschulzen ging sofort in die Küche.</p>
<p class="calibre2">Sie sagte Guten Tag mit einer Stimme, die man nicht hörte,
streckte einem eine feuchte Hand entgegen, die man nicht zu fassen
bekam, und ging in die Küche, um fürs <a id="page36" title="woldemar/gary"></a> Essen zu sorgen. Man war
noch keine zehn Minuten beim Dorfschulzen, so strotzte der Tisch
von Eßwaren. Immer gabs Rippspeer und rote Beten und
Sülze. Die Brotscheiden waren so groß wie Landkarten.</p>
<p class="calibre2">Der Dorfschulze war ein dicker Mann, der zur Kirche und zum
Markt in Augustenburg einen Rock anhatte, sonst aber in
Hemdsärmeln einherging. Er sagte nie etwas, lachte aber immer,
daß es seinen ganzen Körper nur so schüttelte.</p>
<p class="calibre2">Die Mutter setzte sich verzweifelt zur Sülze nieder.</p>
<p class="calibre2">Kam sie aber von einem Besuch bei Dorfschulzens nach Hause, so
mußte sie immer ein Glas Rotwein haben, um damit das Fett
hinunterzuspülen.</p>
<p class="calibre2">Jahre waren verstrichen, bei Dorfschulzens blieb immer alles
beim alten. Die Frau ging nach ihrem Guten Tag in die Küche,
und in dem Mann fing es an zu glucksen, daß die ganze kleine
Stube bebte, sobald er nur Mutters Gesicht erblickte.</p>
<p class="calibre2">Eines Tages aber, es war in der Dämmerung, schleppte sich
etwas wie ein schweres Bündel in unsere Wohnstube hinein. Und
das Bündel – nichts als Tücher, darüber ein
großer Schal und wieder ein kleiner Schal – kam nicht
weiter als bis zum Stuhl neben dem Bücherschrank, aber dort
sank es nieder, wie ein schweres Federbett niedersinkt, und das
Bündel weinte, weinte, weinte.</p>
<p class="calibre2">Aus all den Kleidern heraus kam das Weinen, still und
ununterbrochen.</p>
<p class="calibre2">Dies Bündel war des Dorfschulzen Weib – ihr Sohn war
durch einen Fehlschuß umgekommen.</p>
<p class="calibre2">Die Mutter kniete nieder und versuchte, bis zur Frau zu dringen
– durch all die Tücher hindurch, um sie zu
trösten.</p>
<p class="calibre2">Das Bündel aber weinte nur und weinte und sagte:</p>
<p class="calibre2">»Ich muß mit dem Pastor sprechen.«</p>
<p class="calibre2">»Ja, ja, Madam Hansen, ja, ja, Madam Hansen ...«</p>
<p class="calibre2"><a id="page37" title="woldemar/gary"></a>
»Ich muß mit dem Pastor sprechen.«</p>
<p class="calibre2">Und das Bündel ging, leise vor sich hinjammernd,
schwerfällig, als sei es ohne Leben, durch das Zimmer zum
Pfarrer hinein.</p>
<p class="calibre2">»Wie sie weinte,« sagte die Mutter, »wie sie
weinte – hätte man ihr nur die Tücher abnehmen
können.«</p>
<p class="calibre2">Als ob sie das diesem Kummer nähergebracht hätte.</p>
<p class="calibre2">... Die Mutter und der älteste Junge wollten hin, um
Dorfschulzens Sohn zu sehen.</p>
<p class="calibre2">In dem Hause war förmlich kein Laut zu hören. Der Hund
bellte nicht, und das Federvieh war eingesperrt.</p>
<p class="calibre2">Der Dorfschulze empfing die Mutter und den Jungen in der
Tür. Er hatte einen schwarzen Rock an und seufzte. Er sprach
kein Wort, während die Mutter und der Junge still durch die
Stuben schritten, wo alle Türen offen standen.</p>
<p class="calibre2">Im Saal stand der Sarg.</p>
<p class="calibre2">Dort war so ein gelbes Licht, wie es entsteht, wenn die Fenster
mit Laken verhängt sind.</p>
<p class="calibre2">Der Dorfschulze nahm das Tuch vom Antlitz des Toten.</p>
<p class="calibre2">Da lag der Sohn, still.</p>
<p class="calibre2">Daheim, in der Leutestube, hatten sie gesagt, durch Andres Niels
seien viele Mädels ins Elend gekommen.</p>
<p class="calibre2">Denn er hätte so einen weibischen Mund, hatte der
Großknecht gesagt. Kein Mädel könnte da widerstehen.
– Und ein Paar Beine, sie kriegten ihre Augen nicht los davon
...</p>
<p class="calibre2">Jetzt aber lag er still. Es war, als sei gar kein Ausdruck in
seinem Gesicht – nur Kälte.</p>
<p class="calibre2">Der Dorfschulze ging umher und murmelte einige Bibelstellen vor
sich hin, die er von seiner Konfirmation her wußte.</p>
<p class="calibre2">Die Mutter sah lange in das Gesicht des Toten. Dann deckte sie
selber das Tuch darüber. Es lag so hoch über der
großen, geraden Nase. Die Frau des Dorfschulzen <a id="page38" title="woldemar/gary"></a> war nicht im Zimmer
gewesen. Sie wirtschaftete auf schwarzen Socken in ihrer Küche
umher.</p>
<p class="calibre2">Als die Mutter und der Junge in die vorderste Stube kamen, war
der Tisch gedeckt. Er stand voll allerlei Eßwaren.</p>
<p class="calibre2">Die Frau ging umher und bot uns an.</p>
<p class="calibre2">Die Tür zur stillen Leichenstube stand offen.</p>
<p class="calibre2">Der Dorfschulze aß bedächtig ein Stück nach dem
andern. Er mußte viel essen während der Trauertage.</p>
<p class="calibre2">Gesprochen wurde nicht.</p>
<p class="calibre2">Der Junge bekam Johannisbeerpunsch und trank das ganze Glas aus
– denn die Mutter sah es nicht –, so daß ihm ganz
schwindlig wurde.</p>
<p class="calibre2">Sie saßen lange bei Tisch. Die Frau des Dorfschulzen hatte
sich neben die Tür gesetzt. Sie hatte kein Wort
gesprochen.</p>
<p class="calibre2">Als aber die Mutter gehen wollte und sich der Frau näherte,
um ihr Lebewohl zu sagen, spürte sie, wie die Ärmste am
ganzen Körper zitterte.</p>
<p class="calibre2">Sie blickte zu Boden, und als sie zu sprechen versuchte, bekam
sie die Worte beinahe nicht heraus ...</p>
<p class="calibre2">Es sei so viel, sagte sie nur immer ... aber sie möchte
bitten, ob die Frau nicht etwas singen wolle ... an der Leiche
etwas singen.</p>
<p class="calibre2">Die Mutter antwortete nicht, sie legte nur still ihr Zeug wieder
ab, und sie gingen alle vier hinein – durch die Wohnstube,
durch die Mittelstube in das gelbe Licht hinein.</p>
<p class="calibre2">Der Schulze brachte ein großes Gesangbuch herbei.</p>
<p class="calibre2">Die Mutter aber sang in die Luft hinaus, und ohne den toten Sohn
anzusehen:</p>
<p class="calibre2">Wenn ich bedenke recht den Tod,<br class="calibre3"/>
Daß ich von hinnen scheide,<br class="calibre3"/>
Wie's Vöglein froh das Morgenrot,<br class="calibre3"/>
Begrüß ich ihn mit Freude.</p>
<p class="calibre2"><a id="page39" title="woldemar/gary"></a> O milder Tag,<br class="calibre3"/>
Wo Streit und Plag<br class="calibre3"/>
Wird selig gehn zu Ende.<br class="calibre3"/>
In Jesu Schoß<br class="calibre3"/>
Mit Wonne groß<br class="calibre3"/>
Falt ich die müden Hände.</p>
<p class="calibre2">Die Eltern regten sich nicht. Die Mutter allein sang. Der Junge
stand und sah sie an. Sie war ganz weiß im Gesicht.</p>
<p class="calibre2">Diese einsame Stimme klang so seltsam dort über dem fremden
Toten.</p>
<p class="calibre2">Eia, mein Herz, sei stark und hold<br class="calibre3"/>
In Christus, deinem Herrn:<br class="calibre3"/>
Den Tod, der Sünde bittern Sold,<br class="calibre3"/>
Empfängst du jetzo gern.<br class="calibre3"/>
Denn jede Wund,<br class="calibre3"/>
Sie ist jetzund<br class="calibre3"/>
Die Tür zum Himmelreiche.<br class="calibre3"/>
Der Tod ein Ruhn<br class="calibre3"/>
Nach schwerem Tun,<br class="calibre3"/>
Daß jeder Kummer weiche.</p>
<p class="calibre2">Für einen Augenblick war alles still.</p>
<p class="calibre2">Dann legte die Frau das Tuch über des Toten Antlitz. Der
Junge hörte die Mutter nicht einmal Lebewohl sagen.</p>
<p class="calibre2">Der Dorfschulze ging mit ihnen über den Hof. Er schloß
das Tor auf und wieder zu.</p>
<p class="calibre2">Die Mutter und der Junge schritten auf den Weg hinaus. Die
Mutter sprach nicht.</p>
<p class="calibre2">»Mutter,« sagte der Junge, »dein Gesicht war so
weiß.«</p>
<p class="calibre2">»Komm jetzt,« sagte die Mutter.</p>
<p class="calibre2">Als sie nach Hause kamen, war die Mutter schweigsam und
fröstelte. Beim Abendtisch wurde fast nichts gesprochen.</p>
<p class="calibre2">»Fritz,« sagte die Mutter plötzlich, »der
Mensch hat keine Seele gehabt.«</p>
<p class="calibre2">»Stella!«</p>
<p class="calibre2">»Nein.«</p>
<p class="calibre2">Die Mutter schwieg einen Augenblick.</p>
<p class="calibre2"><a id="page40" title="woldemar/gary"></a> »Er
hat nur Blut gehabt ... und jetzt ist es kalt geworden.«</p>
<p class="calibre2">Der Vater antwortete nicht.</p>
<p class="calibre2">Die Mutter saß einen Augenblick still.</p>
<p class="calibre2">»Die Menschen müßten immer alt werden, ehe sie
stürben,« sagte sie.</p>
<p class="calibre2">»Stella, wie du redest.«</p>
<p class="calibre2">»Ja, es ist wahr. Denn dann haben die Leiden ihnen immer
eine Art Seele gegeben.«</p>
<p class="calibre2">Sie schwieg einen Augenblick: »Die Jugend hat nur
Blut.« Es war, als befände sich die Mutter in einem
inneren Aufruhr: »Ich kann dies Gesicht nicht vergessen, in
dem Nichts war. – –«</p>
<p class="calibre2">Die ganze Insel fand sich ein bei der Beerdigung ...</p>
<p class="calibre2">Hatte man aber den Hof des Dorfschulzen hinter sich, dann lagen
da hinter den Zäunen die kleinen Kätnerhäuser. Ihre
Fensterrahmen waren grüngestrichen, und ihre Türen waren
grün, sie selbst aber lagen weiß mitten im Schnee.</p>
<p class="calibre2">Die Mutter nickte in jedes Fenster hinein, und die Kinder
nickten auch, und der älteste Knabe lief in jeden Schneehaufen
hinein, der am Wege aufgeworfen war.</p>
<p class="calibre2">»Wie der Bengel läuft,« sagte die Mutter.</p>
<p class="calibre2">Im äußersten Hause wohnte Elsbeth. Sie war die
Älteste im Dorf. Sie war sicher hundert Jahre alt. Es war so
still in der Stube, daß es den Kindern schien, als wage nicht
einmal die Katze zu schnurren. Oder vielleicht hatte sie es
verlernt. Denn auch sie war alt und lag neben dem Bette. Wenn sie
aber ihre graugelben Augen ab und zu öffnete, dann glaubte
man, daß sie mancherlei wußte.</p>
<p class="calibre2">In früheren Zeiten hatte Elsbeth gesponnen –
gesponnen, gesponnen.</p>
<p class="calibre2">Jetzt aber war der Rocken beiseite gestellt worden.</p>
<p class="calibre2">Er stand am Fenster. Wie eine Uhr, die nicht mehr geht.</p>
<p class="calibre2"><a id="page41" title="woldemar/gary"></a> Elsbeth
nickte der Mutter zu, wenn diese eintrat.</p>
<p class="calibre2">Die Stimme rang sich mühsam, tief aus der Brust hervor.</p>
<p class="calibre2">»Ja, ich sitze hier,« sagte sie.</p>
<p class="calibre2">»Da sitzen Sie ja gut, Elsbeth,« sagte die Mutter.</p>
<p class="calibre2">Die Katze regte sich leise, und die Mutter warf ihr einen
verstohlenen Blick zu, denn sie fürchtete sich vor der Katze:
sie mochte keinen Besuch, sie wollte, Elsbeth und sie sollten
allein sein.</p>
<p class="calibre2">»Ja, man sitzt und wartet,« sagte Elsbeth. »Erst
lebt man, und dann denkt man zurück, und dann zuletzt sitzt
man nur und wartet.«</p>
<p class="calibre2">»Alte Leute werden klug,« sagte die Mutter.</p>
<p class="calibre2">»Ja. Aber es nützt ihnen nichts, Madam, und den andern
auch nicht. Denn Blut ist Blut, das will sieden, bis es matt oder
kalt wird.«</p>
<p class="calibre2">Elsbeth schaute den ältesten Jungen an – sie hatte so
klare Augen, aber sie lagen tief im Kopf –:</p>
<p class="calibre2">»Der wird auch einmal Blut genug haben,« sagte sie.
»Blut genug und Tränen genug, das bekommt man zur selben
Zeit.«</p>
<p class="calibre2">»Was sagt sie?« fragte der Junge.</p>
<p class="calibre2">Aber die Mutter antwortete nicht.</p>
<p class="calibre2">Elsbeth schwieg eine Weile, während die Katze die Augen
geöffnet hatte.</p>
<p class="calibre2">»Dann kommt die Zeit der Muttersorge, aber auch die geht
vorüber.«</p>
<p class="calibre2">»Was sagt sie?« fragte der Junge.</p>
<p class="calibre2">»Es gibt Mütter, welche sterben, wenn ihre Kinder
klein sind,« sagte die Mutter.</p>
<p class="calibre2">»Ihnen ist wohl,« erwiderte Elsbeth. Es war still in
der Stube. Auch die Uhr stand still. Elsbeth zog sie nicht mehr
auf.</p>
<p class="calibre2">Die Nachbarsfrau kam, wenn es Zeit war – nach der Sonne
–, half Elsbeth beim Aufstehen und brachte Elsbeth zu
Bett.</p>
<p class="calibre2"><a id="page42" title="woldemar/MEsswein"></a>
»Zuletzt denkt man nur, was das Ganze eigentlich
soll.«</p>
<p class="calibre2">»Was meinen Sie, Elsbeth?«</p>
<p class="calibre2">»Ja, Madam. Gott ist zu groß, und er kann sich auch
nicht mit uns abgeben.«</p>
<p class="calibre2">»Das wissen wir nicht, Elsbeth,« sagte die Mutter.</p>
<p class="calibre2">»Doch, Madam. Denn wir sind zu klein, und er hat nicht die
Zeit, sich mit uns abzugeben.«</p>
<p class="calibre2">Elsbeth schwieg, und die Mutter erhob sich mit ihren
Kindern.</p>
<p class="calibre2">»Adieu, Elsbeth,« sagte die Mutter, »hier stelle
ich den Fliederbeersaft hin.«</p>
<p class="calibre2">»Leben Sie wohl,« erwiderte Elsbeth.</p>
<p class="calibre2">Aber draußen auf der Landstraße war die Mutter
schweigsam.</p>
<p class="calibre2">»Was hat sie alles gesagt?« fragte der Junge.</p>
<p class="calibre2">»Sie sprach von dir,« antwortete die Mutter. Und sie
schwieg wieder.</p>
<p class="calibre2">Aber wenn der älteste Junge allein draußen war, ging
er, so oft er an Elsbeths Haus kam, immer auf die andere Seite des
Weges hinüber. Es war, als hätte er Angst.</p>
<p class="calibre2">Ging man nun weiter auf dem Wege zu Küsters, so kam man zu
Madam Jespersen.</p>
<p class="calibre2">Ihr Haus lag auf einem Erdwall, und man mußte eine Stiege
hinaufklettern, die nur ein Geländer hatte. Die Diele war mit
Sand bestreut, und es roch nach Jungfräulichkeit und
Lavendel.</p>
<p class="calibre2">Madam Jespersen saß auf einem Fenstertritt und strickte
Schutzdecken. Da hatte sie gesessen, so lange man denken konnte.
Die Schutzdecken, die sie strickte, lagen weißschimmernd auf
jedem Möbel und auf jedem Stuhl.</p>
<p class="calibre2">Hatten die Kinder sich gesetzt und standen sie dann wieder auf,
so ging ein jedes von ihnen davon mit einer Decke, die an einem
selten genannten Körperteil festgeklebt war.</p>
<p class="calibre2">»Junge, Junge,« sagte die Mutter zu dem Ältesten
und <a id="page43" title="woldemar/MEsswein"></a>
brachte die Decke wieder auf ihren Platz. Alle Stuhlkissen waren
von Fräulein Helene auf Kanevas gestickt. Fräulein Helene
stickte immer Sterne in vielen Farben auf verschiedenem Grunde.</p>
<p class="calibre2">Madam Jespersen sprach Holsteinisch – denn daher stammte
sie – und war früher Kammerzofe bei den Rantzaus
gewesen. Niemand wußte, wie sie hierher, gerade in diesen
Winkel verschlagen war.</p>
<p class="calibre2">Sie war immer in Moiree und füllte einen ganzen
Mahagonilehnstuhl mit breiten Lehnen aus. Auf dem Kopf trug sie
eine turmhohe Haube – die Kinder glaubten, sie schliefe
damit. An den Handgelenken hatte sie Armbänder aus
Bernstein.</p>
<p class="calibre2">Sie verließ ihren Tritt nur, wenn sie in die Kirche ging.
Dann trug sie eine Moireemantille und darüber einen
gestrickten Schal.</p>
<p class="calibre2">Wenn der Kaffee auf den Tisch sollte, mußte Fräulein
Helene immer viele Muster beiseite räumen. Es waren Muster aus
grauem Packpapier zu ihrer nie vollständigen Garderobe. Sie
war zweimal im Jahr in Flensburg und kehrte zurück, den Kopf
voller Modelle zu Kleidertaillen, die sie im folgenden Halbjahre
beschäftigten.</p>
<p class="calibre2">An Stoffen bevorzugte sie die schottischen Muster.</p>
<p class="calibre2">Sie veränderte aber nur die Taillen. Die Röcke blieben
ungefähr dieselben. Nur dann und wann wurden sie mit
Garnierungen versehen.</p>
<p class="calibre2">Die Kuchen zum Kaffee wurden aus einem Kasten hervorgeholt, der
unter Madam Jespersens Bett stand. Madam Jespersens Bett war hoch
wie ein Berg.</p>
<p class="calibre2">»Ach ja, man muß geduldig sein,« sagte Madam
Jespersen und ließ die Hände sinken. Sie hatte sie einst
vor Zeiten mit vielen Kammerzofenringen geschmückt, die jetzt
im Fett der kurzen Finger verschwunden waren.</p>
<p class="calibre2">Jungfer Helene huschte hin und her und schwatzte.</p>
<p class="calibre2">Jungfer Stine steckte nur ein knochiges Gesicht zur Tür
<a id="page44" title="woldemar/MEsswein"></a> herein
zum Guten Tag. Sie mußte in ihrer Nähschule bleiben.</p>
<p class="calibre2">»Sie können doch eine Minute da bleiben,« sagte
die Mutter, »lassen Sie doch die Mädels
nähen.«</p>
<p class="calibre2">Aber Jungfer Stine war schon wieder draußen in einer Stube
hinten am Flur, wo sieben kleine Mädchen mit
Mäuseschwänzen und zusammengekniffenem Munde
Weißnähen lernten.</p>
<p class="calibre2">Jungfer Stine war lang wie eine Mannsperson und sehnig wie ein
alter Gaul.</p>
<p class="calibre2">Sie hatte eine Buchstabierschule vormittags und eine
Nähschule nachmittags. Sie bekam in der Nähschule im
Monat pro Kopf eine Mark.</p>
<p class="calibre2">»Ach ja,« sagte Madam Jespersen, »die Stine
gönnt sich keine Ruhe. Aber man muß geduldig
sein.«</p>
<p class="calibre2">Jungfer Helene legte die Kuchen auf eine kleine
Porzellanschüssel, mit sechzehn kleinen Handbewegungen bei
jedem Kuchen.</p>
<p class="calibre2">Sie lief in der Küche aus und ein, um den Kaffee zu
besorgen, während sie in einem fort schwatzte. Jungfer Helene
schwatzte das ganze Jahr unaufhörlich, ohne daß eine
Menschenseele am einunddreißigsten Dezember gewußt
hätte, was sie gesagt.</p>
<p class="calibre2">»Die Kleine schwärmt,« sagte Madam Jespersen.</p>
<p class="calibre2">War der Kaffee auf dem Tisch, kam Jungfer Stine auf einen Sprung
herein und setzte sich neben die Tür auf einen der drei
Mahagonistühle mit richtigen Sitzen – die anderen
Sitzgegenstände waren wackeliger und hatten einen geflochtenen
Rücken – denn sie setzte sich hart nieder und mußte
etwas unter sich haben.</p>
<p class="calibre2">Sie schlang den Kaffee hinunter und war wieder draußen.</p>
<p class="calibre2">Von der Kuchenschüssel waren immer einige Kränze
verschwunden. Die verteilte sie zur Belohnung in der
Nähschule. Das Stehlen war sonst durchaus nicht Fräulein
Stines Sache, aber von den Kuchen stahl sie in unbewachten <a id="page45" title="woldemar/gary"></a> Augenblicken.
Konnte sie es nicht, so kaufte sie Zuckerkringel im Krug.</p>
<p class="calibre2">Die Mauseschwänze bekamen sie. Eine war doch immer mit
einem Wäschestück fertig.</p>
<p class="calibre2">Wenn die Mutter in den Gang hinaus kam, beim Fortgehen, steckte
Jungfer Stine ihren Kopf aus der Schulstubentür – es kam
eine laue Stickluft aus dem kleinen, weißgetünchten Loch
heraus –, sie mußte der Mutter immer einen Kuß zum
Abschied geben. Sie war der einzige erwachsene Mensch, den sie
küßte.</p>
<p class="calibre2">Der älteste Junge stolperte über sämtliche
vierzehn Holzpantoffel auf der Diele:</p>
<p class="calibre2">»Wie ungeschickt der Junge ist,« sagte die Mutter,
»er lernt es nie, sich zu benehmen.«</p>
<p class="calibre2">Jungfer Stine blieb in der Haustür stehen und nickte,
Jungfer Helene aber bog mit einer zierlichen Hand die Blumen am
Stubenfenster zur Seite und lächelte nur.</p>
<p class="calibre2">»Mutter,« sagte der älteste Junge, wenn sie
wieder auf der Landstraße waren, »Jungfer Stine hat
Augenbrauen wie Kutscher Lars.«</p>
<p class="calibre2">Jungfer Stine hatte Augenbrauen wie eine Mannsperson über
ein Paar Jungmädchenaugen.</p>
<p class="calibre2">Die Mutter liebte es, ihren ältesten Sprößling
schwatzen zu hören. Er sprach ganz wie sie, mit denselben
Ausdrücken, in der gleichen Wortstellung, mit einer altklugen
Wichtigkeit, die wie Weisheit wirkte. Und immer guckte sein Kopf,
der zu groß für seinen Körper war, neben Mutters
Kleiderrock hervor.</p>
<p class="calibre2">Wenn sie von einer Kindergesellschaft nach Hause kamen, wollte
die Mutter immer einen Bericht über das Fest haben.</p>
<p class="calibre2">Sie setzte sich in ihren Lieblingsstuhl mitten in der Wohnstube,
als setze sie sich an einen gedeckten Tisch.</p>
<p class="calibre2">»So,« sagte sie, »nun laßt
hören.«</p>
<p class="calibre2">Alle Kinder redeten durcheinander.</p>
<p class="calibre2"><a id="page46" title="woldemar/gary"></a>
»Der Junge zuerst,« sagte die Mutter.</p>
<p class="calibre2">Und der Junge sprang in seiner Samtbluse umher und imitierte
alle, Knaben und Mädchen, in Stimmen und Gebärden,
daß die Mutter sich in ihrem Stuhl vor Lachen
krümmte.</p>
<p class="calibre2">»Und was dann? Und was dann?«</p>
<p class="calibre2">Der Junge fuhr fort. Er konnte die ganze Gesellschaft auswendig.
Er machte alle nach und sprang umher wie ein Verrückter.
Schließlich sagte die Mutter:</p>
<p class="calibre2">»Was habt ihr bekommen?«</p>
<p class="calibre2">Und die Kinder schrien die Gerichte durcheinander.</p>
<p class="calibre2">Über das Essen auf Gesellschaften lachte die Mutter am
meisten.</p>
<p class="calibre2">»Essen lernen sie hierzulande nie,« sagte sie.
»Herr Jesus, was setzen sie einem alles vor.«</p>
<p class="calibre2">Bei den Kindergesellschaften gab es ja ein für allemal nur
Butterbrot und Mandelpudding.</p>
<p class="calibre2">Schließlich öffnete der Vater die Tür seiner
Stube:</p>
<p class="calibre2">»Stella, du verdirbst den Jungen ganz,« sagte er.
»Kinder dürfen doch nicht schon kritisieren, wenn sie
noch in der Wiege liegen!«</p>
<p class="calibre2">»Ich kann den Jungen doch nicht am Sehen hindern,
Fritz.«</p>
<p class="calibre2">Und des Vaters Tür schloß sich wieder.</p>
<p class="calibre2">Des Vaters Tür war fast immer geschlossen, und die Kinder
wußten kaum, wie es hinter der Tür aussah. Denn sie kamen
so selten hinein, und drinnen war es dunkel. Die Stube lag nach
Norden, niemals schien die Sonne hinein. Die Möbel waren aus
dunklem Mahagoni.</p>
<p class="calibre2">Der Vater wanderte fast immer in seiner Stube auf und ab.</p>
<p class="calibre2">»Wer ist da?« sagte er, wenn jemand hereintrat, und
schrak leicht zusammen.</p>
<p class="calibre2">»Ich bin es,« antwortete eins der Kinder, das gekommen
war, um ein Buch zu holen.</p>
<p class="calibre2"><a id="page47" title="woldemar/gary"></a> Und der
Vater wanderte weiter in seinem Zimmer auf und ab, zwischen seinen
vier Wänden.</p>
<p class="calibre2">Er hatte es gern heiß im Zimmer und hatte doch immer
weiße Hände vor Kälte.</p>
<p class="calibre2">Beim Mittagstisch, wenn eins der Kinder sprach, konnte er sich
plötzlich von seinen Gedanken losreißen – er
saß immer hinter einer Flasche seinem Rotwein mit rotem
Siegellack:</p>
<p class="calibre2">»Gott weiß, wie die Kinder erzogen werden,« sagte
er.</p>
<p class="calibre2">»Lieber Fritz,« erwiderte die Mutter, »wie soll
man Kinder auf dem Lande erziehen.«</p>
<p class="calibre2">»Wie Kinder,« sagte der Vater und versank wieder in
Gedanken.</p>
<p class="calibre2">Er war immer blaß im Gesicht, und sein Bart fing an grau zu
werden.</p>
<p class="calibre2">Die Mutter aber sagte zu Lehrers Tine:</p>
<p class="calibre2">»Liebes Kind, Kinder sind Kinder, was sie hier nicht
hören, das hören sie in der Gesindestube.«</p>
<p class="calibre2">Das war wirklich wahr. Die frohesten Stunden der Kinder waren
die Stunden in der Gesindestube. Dort war es so siedendheiß,
daß sie puterrote Köpfe bekamen, während sie in den
Ecken saßen und zuhörten. Es war da stets eine große
Versammlung aus dem ganzen Dorf, weil nie jemand nachzählte,
wieviel Bier in die Krüge geschenkt wurde.</p>
<p class="calibre2">Das Küchenmädchen lief immer wieder ab und zu auf
ihren schwarzen Socken und schenkte ein.</p>
<p class="calibre2">Es war wie in einem Wirtshause.</p>
<p class="calibre2">Lars, der Großknecht, saß am Tischende und hatte den
Vorsitz. Die Tagelöhner garnierten die Wände. Maren, das
Waschmädchen, stand an der Tür und grinste.</p>
<p class="calibre2">Es gab keinen Klatsch im ganzen Dorf, der nicht durch die
Gesindestube ging.</p>
<p class="calibre2">Die Mutter machte zuweilen die Tür auf:</p>
<p class="calibre2">»Na, Kinder, gibt's was Neues?«</p>
<p class="calibre2"><a id="page48" title="woldemar/gary"></a> Und sie
setzte sich selbst an den Kachelofen. Dann führte nur Lars,
der Großknecht, das Wort, während die Tagelöhner
dasaßen und auf ihre Krüge schielten.</p>
<p class="calibre2">Lars war da gewesen, so lange man denken konnte. Alle
Dienstboten blieben unendliche Jahre im Hause. Die Mutter klagte
beständig beim Vater über ihr Betragen. Der Vater
sagte:</p>
<p class="calibre2">»So laß sie doch gehen.«</p>
<p class="calibre2">Die Mutter schlug hilflos die Augen zur Decke auf: »Aber
sie wollen ja nicht,« sagte sie.</p>
<p class="calibre2">Und sie blieben.</p>
<p class="calibre2">Das Stubenmädchen litt an Kopfschmerzen. Sie band sich
Handtücher um den Kopf, daß sie wie ein Schwerverwundeter
aussah, und ging jammernd aus und ein. Das Mittel gegen ihr
Übel war ein unaufhaltsamer Kaffeestrom, und sie tat nicht die
geringste Arbeit.</p>
<p class="calibre2">»Ich finde Hannes Besen überall,« sagte die
Mutter.</p>
<p class="calibre2">Die Besen standen verlassen.</p>
<p class="calibre2">Hanne selber sank in der Wohnstube beim Bücherschrank
nieder und jammerte: »Ich habe es Marie gesagt, sie setzt den
Kaffee auf.«</p>
<p class="calibre2">»Das ist recht,« antwortete die Mutter.</p>
<p class="calibre2">»Will die Frau nicht auch eine Tasse haben?« jammerte
Hanne.</p>
<p class="calibre2">»Ja danke, wenn welcher da ist,« sagte die Mutter.</p>
<p class="calibre2">Die Hausmamsell saß am Fenster und stickte. Sie war eine
sehr lange, apathische Person, die stets beleidigt tat, um einen
Vorwand zum Nichtstun zu haben.</p>
<p class="calibre2">Die Mutter ärgerte sich wütend über sie und
fragte sie jeden Tag, ob sie nicht mit dem Wagen nach Sonderburg
fahren wolle.</p>
<p class="calibre2">»Gott,« sagte sie, »dann bin ich sie wenigstens
so lange los.«</p>
<p class="calibre2">Sie ließ die Hände in den Schoß sinken.</p>
<p class="calibre2">»Alle meine Hausmamsellen werden so vornehm, daß sie
nur sticken können.«</p>
<p class="calibre2"><a id="page49" title="woldemar/gary"></a> Für
das jüngste Kind hatte man eine Amme genommen. Diese Amme
führte den Namen Rose, und es zeigte sich, daß sie auf
der ganzen Insel berüchtigt war.</p>
<p class="calibre2">Als sie nicht mehr Ammendienste tat, ging sie zu einer
unbestimmbaren Stellung über, denn Kindermädchen waren
schon im Hause.</p>
<p class="calibre2">Der Vater machte der Mutter viele Vorstellungen, um sie aus dem
Hause zu bekommen.</p>
<p class="calibre2">»Lieber Freund,« sagte die Mutter, »willst du mir
sagen, wie ich sie los werden soll? – Sie sitzt ja auch nur
im Fremdenzimmer und näht. Dort tut sie ja keinen
Schaden.«</p>
<p class="calibre2">Und Rose blieb da sitzen.</p>
<p class="calibre2">Überhaupt, wenn von den Dienstboten die Rede war, sagte die
Mutter:</p>
<p class="calibre2">»Ja, Fritz, wenn du dich mal der Sache annehmen wolltest,
würdest du schon sehen.«</p>
<p class="calibre2">Der Vater war viel zu müde, um sich der Sache
anzunehmen.</p>
<p class="calibre2">Ausgenommen einmal.</p>
<p class="calibre2">Der älteste Junge ging durch die Stube und sagte zu Hanne,
dem Stubenmädchen:</p>
<p class="calibre2">»Mach die Tür zu.«</p>
<p class="calibre2">Er wußte nicht, daß Vaters Tür offen war. Der
Vater erschien sofort in seiner Tür, kreideweiß.</p>
<p class="calibre2">»Hanne, wollen Sie so freundlich sein, die anderen zu
rufen,« sagte er.</p>
<p class="calibre2">Die Dienstboten versammelten sich, während der Junge
zitterte und der Vater wartete. Als alle beisammen waren, gab der
Vater ohne jede Zeremonie seinem ältesten Sprößling
eine Ohrfeige.</p>
<p class="calibre2">»Willst du nun vielleicht Hanne um Verzeihung bitten und zu
ihr sagen:</p>
<p class="calibre2">›Hanne, wollen Sie so gut sein und die Tür
zumachen‹.«</p>
<p class="calibre2">Der Knabe tat es mit einer von Tränen erstickten Stimme,
worauf das Gesinde fortgeschickt wurde.</p>
<p class="calibre2"><a id="page50" title="woldemar/MEsswein"></a> Eine
gewisse Höflichkeit gegen Untergeordnete ging ihnen von diesem
Tage an in Fleisch und Blut über – denn keins von den
Kindern konnte sich je erinnern, daß der Vater es bestraft
hatte.</p>
<p class="calibre2">»Es ist ohnehin ein hartes Los, in dienender Stellung zu
sein,« sagte der Vater.</p>
<p class="calibre2">Vielleicht machten sich die Kinder über das harte Los im
stillen allerlei kritische Gedanken, denn hier zu Hause regierte
niemand, außer denen, die dienten.</p>
<p class="calibre2">Lehrers Tine, die die gesunde Vernunft selber war, sagte, wenn
die Mutter klagte:</p>
<p class="calibre2">»Um Gottes willen, nicht wechseln, es ist noch immer
besser, in den Händen der alten zu sein.« –</p>
<p class="calibre2">»Kommen Sie,« sagte die Mutter zu ihr, »wir
wollen ein wenig hinausgehen.«</p>
<p class="calibre2">Sie nahmen ein paar Tücher um und gingen durch die Pforte
in den Garten, nach dem eisbedeckten Teich hinunter. Am Ufer lag
der Schnee zwischen dem halbverwelkten Grase. Draußen hinter
den Pappeln erstreckten sich die weiten Wiesen.</p>
<p class="calibre2">Plötzlich wurde die Mutter traurig, und ihre schöne
Stimme klang wie eine Klage.</p>
<p class="calibre2">»Wie war es schön hier im Sommer!«</p>
<p class="calibre2">Lange und wehmütig schaute sie über Eis und Schnee der
Wiesen hin, sie, die den lauen Wind und die Sonne liebte.</p>
<p class="calibre2">Sie starrte das Gartenhaus mit den weißen Säulen an.
Zu ihrem Geburtstag im Juni waren die Säulen immer mit
Kränzen umwunden.</p>
<p class="calibre2">»Ich werde nicht mehr viele Sommer erleben,« sagte
sie.</p>
<p class="calibre2">»Unsinn,« antwortete Tine.</p>
<p class="calibre2">Die Mutter aber starrte noch immer von ihrem Gartenhause zu den
eisbedeckten Wiesen hinüber.</p>
<p class="calibre2">»Nein,« sagte sie und fing an zu weinen, sie, die das
lichte Leben liebte.</p>
<p class="calibre2"><a id="page51" title="woldemar/MEsswein"></a> Mutter, du beugtest dein Haupt,<br class="calibre3"/>
als der Schmerz kam,<br class="calibre3"/>
und schlossest dein Auge,<br class="calibre3"/>
als die Dämmerung hereinbrach<br class="calibre3"/>
für dich und für uns alle –<br class="calibre3"/>
Mutter – du –</p>
<p class="calibre2">Es werden noch immer Rosen,<br class="calibre3"/>
Rosen und Blumen<br class="calibre3"/>
um die weißen Säulen geschlungen –<br class="calibre3"/>
Rosen, Blumen, Mutter,<br class="calibre3"/>
für die andern.</p>
<p class="calibre2">Aber du konntest<br class="calibre3"/>
im Winter nicht leben;<br class="calibre3"/>
nicht, wenn die Erde,<br class="calibre3"/>
nicht, wenn das Herz erstarrt.<br class="calibre3"/>
Du gingst.</p>
<p class="calibre2">Und doch und doch<br class="calibre3"/>
blühen die glühenden Rosen –<br class="calibre3"/>
Rosen, Rosen<br class="calibre3"/>
blühen doch für die andern.</p>
<p class="calibre2"> </p>
<p class="calibre2">Ging man von Jespersens noch ein kleines Stück weiter, so
bog die Straße zum Kirchplatz ab.</p>
<p class="calibre2">Dort lag der Krug, weiß wie die Kirche, sein Nachbar. Nur
war die Krugtür grün, während das Kirchenportal
schwarz war.</p>
<p class="calibre2">Links lag die Schmiede. Sie war so merkwürdig viereckig und
hatte eine schwarze Kappe auf als Dach. Drinnen in der Schmiede
aber waren Nacht und Flammen.</p>
<p class="calibre2">Der älteste Junge schlich Sonntags oft nach der Schmiede
hinüber. Dann war es dort so still und friedlich, die
Wände waren Wände wie alle andern, und die Tür war
nur eine Tür und die Steine Steine, während der Schmied
selber nun zu einem weißen, richtigen Manne geworden war, der
heiter und breit draußen vor dem Wirtshause saß.</p>
<p class="calibre2">Er saß da und sah sich die Leute an, die zur Kirche
gingen.</p>
<p class="calibre2"><a id="page52" title="woldemar/Konmax"></a> Kam
aber der Montag, dann war die Schmiede wieder voll von schwarzer
Nacht und rotem Feuer. Und nie hätte der Knabe es gewagt, dort
hinein zu gehen, dort, wo, wie sie erzählten, der Schmied wie
ein großer schwarzer Schatten zwischen den schwarzen
Spukgestalten der Blasebälge umherging.</p>
<p class="calibre2">Rechts kam man nach der Schule. Sie lehnte sich gleichsam
freundlich an die Kirche an, stützte sich auf sie und was ihr
angehörte.</p>
<p class="calibre2">Die Treppe zur Schule war mit Sand bestreut. Die Haustür
ging so weich in ihren Angeln, und gleich im Flur schon
glänzte alles. Wände, Fußboden, Decke glänzten.
Niemand verstand es, grüne Seife unter seinen Händen so
zum Glänzen zu bringen wie Küsters Tine.</p>
<p class="calibre2">Rechts lag die Schulstube. Sie war von einem ewigen Gesumm
erfüllt. Die Kinder saßen in Reihen über ABC und
Katechismus, Knaben und Mädchen, jedes auf seiner Seite, wie
die Mannsleute und Frauenzimmer in der Kirche. Sie schwitzten und
rochen über all dem Wissen. Der alte Küster rauchte eine
Pfeife mit starkem Tabak und schwitzte mit. Er schwitzte immer, und
immer hielt er den Kachelofen glühend.</p>
<p class="calibre2">Wenn die Mutter auf den Flur kam, klinkte sie die
Schulstubentür auf:</p>
<p class="calibre2">»Guten Tag, Küster,« sagte sie. »Bei Ihnen
ist es warm.«</p>
<p class="calibre2">»Guten Tag, guten Tag,« antwortete der Küster.
Die Kinder aber flogen auf ihren roten und schwarzen Strümpfen
in die Höhe.</p>
<p class="calibre2">»Ja,« sagte der Küster, »die vielen
Körper machen warm.«</p>
<p class="calibre2">Die Mutter machte die Tür zu. Drüben auf dem Flur
hatte Tine sie schon gehört und die Stubentür
aufgemacht.</p>
<p class="calibre2">»Nein, aber kommen Sie doch herein, hier ist es schön
warm.«</p>
<p class="calibre2">In der Schule war es immer warm.</p>
<p class="calibre2"><a id="page53" title="woldemar/Konmax"></a>
»Gott bewahre, ist das stickig in der Schule,« sagte die
Mutter und versank in einem Sessel. Nirgends versank man so in
einem Sessel wie bei Küsters. Die Stühle waren so breit,
mit weitgeschweiften Armlehnen, als ständen sie nur da und
sehnten sich nach guten Freunden.</p>
<p class="calibre2">»Das sind die Kinder,« sagte Tine.</p>
<p class="calibre2">Zu Hause behauptete die Mutter, der alte Küster sei mit
dran schuld.</p>
<p class="calibre2">Drinnen in den Stuben aber duftete es nach Räucherkerzen,
getrockneten Rosenblättern und Reinlichkeit.</p>
<p class="calibre2">Die Küstersfrau erschien in der Küchentür.</p>
<p class="calibre2">»Ach, daß Sie endlich mal gekommen sind,« sagte
sie und knixte.</p>
<p class="calibre2">»Ach, du lieber Gott, wir kommen ja sechzehnmal die Woche
her.«</p>
<p class="calibre2">Die Mutter war bereits draußen in der Küche. Sie
mußte sie sehen. Küsters Küche war ihre Wonne und
ihr Staunen. So viel Kupfergeschirr, und wie das glänzen
konnte – Pfannen und Kessel und Töpfe die Wände
entlang. Die Kaffeekanne hatte einen Bauch und stand immer auf dem
Feuer.</p>
<p class="calibre2">»Sie kommt wohl nie von den Torfkohlen,« sagte die
Mutter.</p>
<p class="calibre2">»Ach nein,« entgegnete die Küstersfrau, »es
kommt ja so oft Besuch – Gottlob ... man kennt so viele
Leute.«</p>
<p class="calibre2">Die ganze Gegend kam zu Besuch. Alle machten halt vor der
Tür und guckten herein.</p>
<p class="calibre2">»Man muß hinauf,« sagte die Mutter, »es ist,
als werde man immer erwartet. Und Küsters wissen immer was
Neues – aber sie klatschen nicht.«</p>
<p class="calibre2">Die Kinder waren glücklich aus dem Zeug heraus und spielten
schon in der großen Stube Kriegen. Kein Raum war so geeignet
zum Kriegenspielen. Denn er war geräumig wie ein Saal, und
alle Stühle standen so dicht an den Wänden und
versperrten den Weg nicht.</p>
<p class="calibre2"><a id="page54" title="woldemar/Konmax"></a>
»Liebe Kinder,« sagte die Mutter zu Hause, »ich
weiß nicht, aber Küsters Möbel haben so was
freundliches an sich.«</p>
<p class="calibre2">Tine holte die Tassen hervor, und Tine kommandierte das
Spiel.</p>
<p class="calibre2">»So, da purzelt der Junge wieder hin!« sagte die
Mutter.</p>
<p class="calibre2">»Auf, auf,« rief Tine.</p>
<p class="calibre2">»Tine, was machen Sie mit Ihrem Tischzeug?« fragte die
Mutter, die wieder in der Stube und in einem andern Sessel
versunken war. Bei Küsters wechselte sie oft ihren Sitz.</p>
<p class="calibre2">»Ich bekomme meins nie so weiß,« sagte die Mutter
und schüttelte verzweifelt den Kopf.</p>
<p class="calibre2">Ihr eigenes war ganz genau so weiß, Küsters Tischzeug
kam ihr aber immer weißer vor. Alles erschien ihr am
weißesten und schönsten bei Lehrers – mit Ausnahme
der Betten. Es waren die höchsten im ganzen Dorf.</p>
<p class="calibre2">»Daß sie in diesen Bergen liegen können,«
sagte sie, wenn sie nach Hause kam.</p>
<p class="calibre2">Die Betten waren tatsächlich Berge, ein Federbett über
dem andern, mit roten Bezügen und selbstgewebten Laken.
»Ich würde ersticken,« sagte die Mutter.</p>
<p class="calibre2">Die Betten waren der Stolz der Frau Küster. Sie zeigte
stets ihre Brautlaken. Die hatte sie gewebt, als sie noch
Mädchen war, und sie waren über Tines Taufwiege gebreitet
gewesen.</p>
<p class="calibre2">»Das ist eine eigene Sache,« sagte die
Küstersfrau und liebkoste die Laken, »mit der eignen
Hände Arbeit.«</p>
<p class="calibre2">Jetzt war sie beim Waffeleisen. Die Mutter spürte schon den
Duft.</p>
<p class="calibre2">»Gibt's Waffeln?« sagte sie.</p>
<p class="calibre2">Die Mutter zog immer so etwas mit den Schultern, leise und ein
wenig hastig, wenn sie sich auf Essen freute.</p>
<p class="calibre2">»Ach, das ist schön!« sagte sie.</p>
<p class="calibre2">Die ersten Waffeln kamen herein, und der Kaffee dampfte. Die
Mutter setzte sich mit einem Plumps auf das Roßhaarsofa,
gerade unter das Bild von König Friedrich <a id="page55" title="woldemar/Konmax"></a> VII. Er hing dort zwischen
seinen zwei rechtmäßigen Gemahlinnen.</p>
<p class="calibre2">Die Kinder wurden ringsum auf die Stühle plaziert. Am
Kaffee verbrannten sie sich und wandten kein Auge von den
Waffeln.</p>
<p class="calibre2">»Passe auf deine Tasse,« rief die Mutter dem
ältesten Knaben zu.</p>
<p class="calibre2">»Jesses, lassen Sie ihn doch,« sagte Tine.</p>
<p class="calibre2">Die Mutter aber schüttelte den Kopf.</p>
<p class="calibre2">»Er faßt alle Dinge im Leben gleich ungeschickt an.
Das ist sein Pech.«</p>
<p class="calibre2">Aber Tine lachte, während sie ihm übers Haar strich.
»Er hat's vielleicht nicht von Fremden geerbt,« sagte
sie.</p>
<p class="calibre2">»Na, Tine,« warf die Küstersfrau ein.</p>
<p class="calibre2">Die Mutter aber lachte und hob die schönen Hände mit
den vollen Adern: »Ja, wirklich, die Hände sind
schön, aber sie sitzen verkehrt in den Gelenken.«</p>
<p class="calibre2">Die Küstersfrau nahm die Hände und streichelte
sie:</p>
<p class="calibre2">»Sie sind ja auch nicht fürs Gewöhnliche
gemacht,« sagte sie.</p>
<p class="calibre2">Plötzlich aber war die Mutter ernst geworden:</p>
<p class="calibre2">»Nein,« sagte sie, und mit ganz anderer Stimme fast
fügte sie hinzu: »Aber mit solchen Händen kann man
sich auch nicht wehren.«</p>
<p class="calibre2">Ihre Stimmung schlug wieder um: »Nein, Tine hat
Hände!« sagte sie und sah bewundernd auf Tines emsige
Hand hinüber, die abermals Waffeln unter die Kinder
verteilte.</p>
<p class="calibre2">Sie war so kräftig und doch nicht groß.</p>
<p class="calibre2">Dann fingen sie an von der Gräfin Danner zu sprechen.</p>
<p class="calibre2">»Gott bewahre, was für ein Frauenzimmer!« sagte
Tine.</p>
<p class="calibre2">Die Gräfin Danner war das stete Gesprächsthema der
Gegend. Schloß Gottorp lag ja in der Nähe, und von dort
kamen der König und die Gräfin nach Sonderburg
herüber. Die Gräfin hoffte stets irgendwo hinzukommen, wo
ihr in rechter Weise gehuldigt würde.</p>
<p class="calibre2"><a id="page56" title="woldemar/Konmax"></a> Wenn
die Gräfin nach Sonderburg kam, wurden alle Beamten der Insel
nebst ihren Ehefrauen zur Tafel befohlen. Die Beamten erschienen,
und die Frauen ließen absagen.</p>
<p class="calibre2">Die Mutter war so gut wie allein da.</p>
<p class="calibre2">»Ich will sie sehen,« sagte sie. »Merkwürdig
ist sie doch auf alle Fälle, lieben Leute.«</p>
<p class="calibre2">Der Vater und die Mutter fuhren hin und wurden recht
ungnädig empfangen. Die Gräfin kannte ihre Verwandtschaft
mit jenem Bischof von Seeland, den sie von ihrer Trauung her noch
recht gut im Gedächtnis hatte. Die Sage ging, daß sie ihn
in Frederiksborg halb wie einen Gefangenen hätten behandeln
müssen, ehe sie ihn dazu zwangen, sie zu trauen.</p>
<p class="calibre2">»Tüchtig ist sie,« sagte die Mutter von der
Gräfin, als sie nach Hause kam. »Aber du meine Güte,
was war sie doch dekolletiert ... und was hat sie denn zu zeigen
... Solche Fleischmassen zeigt man doch nicht mal seinem Spiegel
...«</p>
<p class="calibre2">Drüben in der Schule begannen sie zu singen. Der alte
Küster sang vor, und die Kinder antworteten ihm unverdrossen
in allen Tonarten. Es war ein Begräbnispsalm.</p>
<p class="calibre2">In der Wohnstube setzten sie ihr Gespräch über die
Gräfin Danner fort.</p>
<p class="calibre2">Es welken dieser Erde Kränze,<br class="calibre3"/>
Und was sich hier dem Staub entwand.<br class="calibre3"/>
Gezählt sind bald der Erde Lenze –<br class="calibre3"/>
Selbst wo es Gott mit Geist verband.<br class="calibre3"/>
Nur was der Himmel uns verleiht,<br class="calibre3"/>
Kann blühn in alle Ewigkeit.</p>
<p class="calibre2">sangen sie drüben. Der Baß des Küsters und die
Diskonte seiner Schar.</p>
<p class="calibre2">Die Mutter wußte so viele Geschichten von der Gräfin.
Sie hörte sie von ihrem Schwiegervater, der alten Exzellenz,
der »diese Person« aus aufrichtiger Seele haßte.
<a id="page57" title="woldemar/Konmax"></a> Die
Mutter erzählte eine Geschichte von den Kanälen zu
Frederiksborg. Der König und seine Gemahlin machten eine
Ruderfahrt. Da wurde Seine Majestät, der Freiheitskönig,
plötzlich wütend.</p>
<p class="calibre2">»Schmeißt sie ins Wasser!« rief er.</p>
<p class="calibre2">»Schmeißt das Weibsbild ins Wasser!« schrie
er.</p>
<p class="calibre2">Die Leute zögerten.</p>
<p class="calibre2">»Zum Teufel – schmeißt die Metze in den
See!« kommandierte Seine Majestät. Und die Gemahlin
Seiner Majestät »mußte in den See« hinein und
ans Ufer waten.</p>
<p class="calibre2">Die Mutter lachte wie toll.</p>
<p class="calibre2">Drüben setzten sie das Singen fort. Es klang so
kläglich:</p>
<p class="calibre2">Wohl jeder Seele, die ersehnet,<br class="calibre3"/>
Was nur des Engels Aug erspäht,<br class="calibre3"/>
Die sich ans Höchste gläubig lehnet,<br class="calibre3"/>
Das Flittergold der Welt verschmäht, –<br class="calibre3"/>
Ein gütger Himmel ihr verleiht,<br class="calibre3"/>
Was blüht in alle Ewigkeit.</p>
<p class="calibre2">»Ja,« sagte die Küstersfrau mitten in dem
Gräfinnengespräch, sie dachte an den Grabpsalm:
–</p>
<p class="calibre2">»Sie müssen ihn ja singen, der Chorknaben
wegen.«</p>
<p class="calibre2">Die Mutter aber wußte noch viel mehr von der Gräfin
und Seiner Majestät.</p>
<p class="calibre2">Sie erzählte weiter.</p>
<p class="calibre2">Sie erzählte, wie der König in einer Staatsratssitzung
das Protokoll dem Ratspräsidenten gerade ins Gesicht geworfen
habe, so daß es hart am Ohr des Justizministers vorbei
geflogen sei. Aber am schlimmsten war doch das mit der
Gräfin.</p>
<p class="calibre2">»Der Schwiegervater sagt, während der
Staatsratssitzungen horcht sie an der Tür. Und hinterher
erstattet sie der Zeitung Bericht.«</p>
<p class="calibre2">Stets kehrte die Mutter zu dem Thema Gräfin
zurück.</p>
<p class="calibre2">Die Küstersfrau saß und hörte zu, und Tine
lachte. Drüben in der Schule waren sie zu den
Vaterlandsliedern übergegangen. <a id="page58" title="woldemar/Konmax"></a> Der alte Küster setzte
immer kräftiger ein, wenn er ans Vaterland kam.</p>
<p class="calibre2">»Aber tüchtig ist sie,« sagte die Mutter und
machte Schluß mit der Gräfin.</p>
<p class="calibre2">Nichts in der Welt hatte der Mutter so imponiert wie Louise
Rasmussens Tüchtigkeit.</p>
<p class="calibre2">»Bei der Häßlichkeit,« sagte sie,
»Kinder – –«</p>
<p class="calibre2">Drüben in der Schule war es, als seien die Kinder wach
geworden. Es schallte nur so, der Baß voran:</p>
<p class="calibre2">O Muttersprache, traute, o wonnesamer Klang,<br class="calibre3"/>
Wo finde ich das Gleichnis, zu preisen dich im Sang?<br class="calibre3"/>
Die hochgeborne Jungfrau, die edle Königsbraut,<br class="calibre3"/>
Denn sie ist jung und lieblich, aus hellem Aug sie schaut.<br class="calibre3"/>
Denn sie ist jung und lieblich, aus hellem Aug sie schaut.</p>
<p class="calibre2">»Singt mit, Kinder,« sagte die Mutter und setzte
selber ein. Der Alte hörte es drüben, und stärker
erscholl die Melodie. Die klare Stimme der Mutter
übertönte alle die andern:</p>
<p class="calibre2">Sie legt uns auf die Lippen ein jedes schöne
Wort,<br class="calibre3"/>
Zum leisen Flehn der Liebe, zum Dank am Siegesort.<br class="calibre3"/>
Wird uns das Herz zu enge und schwillt es uns vor Lust,<br class="calibre3"/>
Verleihet sie uns Töne, erleichtert uns die Brust!</p>
<p class="calibre2">»Wie hübsch ist das,« sagte die Küstersfrau,
»es ist, als ob das ganze Haus singt.«</p>
<p class="calibre2">»Tatsächlich,« sagte die Mutter, und sie lachte
und lief in die große Stube hinein:</p>
<p class="calibre2">»Nein, nein, bleibt da,« rief sie, »ich singe
hier. Dann gibt's Gesang in der ganzen Bude.«</p>
<p class="calibre2">Und treibt uns in die Weite das Streben nach dem
Glück,<br class="calibre3"/>
Nach ferner Zeiten Weisheit, nach fremder Welt Geschick,<br class="calibre3"/>
Sie lockt und zieht uns heimwärts, wir folgen ihrem
Laut,<br class="calibre3"/>
Denn sie ist jung und lieblich, aus hellem Aug sie schaut.</p>
<p class="calibre2">Es wurde ganz still drüben beim Schmied. Jetzt konnten sie
es in der Schmiede hören, daß »die Frau die Schule
singen ließ«.</p>
<p class="calibre2"><a id="page59" title="woldemar/Konmax"></a> Der
Schmied trat aus der Schmiede auf den weißen Kirchplatz. Er
stand unter des Küsters Fenstern und lauschte.</p>
<p class="calibre2">»Jetzt aber wollen wir hier bleiben,« rief die Mutter,
und alle liefen zu ihr in die große Stube hinein.</p>
<p class="calibre2">»Ja,« sagte Tine, »nun spielt der Junge
Komödie.«</p>
<p class="calibre2">Der Junge war der Älteste. Seine Stimme war schrill wie
eine Spieldose. Aber Verse konnte er. Alles, was die Mutter las,
behielt er. Er gestikulierte und tobte umher.</p>
<p class="calibre2">»Seht den Jungen,« rief Tine, »seht den
Jungen!«</p>
<p class="calibre2">Der Junge spielte Hakon, und er spielte den Chevalier in
»Ninon«. Er mischte die Verse durcheinander, er schrie
und flüsterte. Der Ofen mußte mitspielen. Der uralte Ofen
des Küsters stand breitbäuchig und ernsthaft da. Der
Junge flog an ihm herum, beschwor ihn und donnerte ihm seine Verse
entgegen.</p>
<p class="calibre2">»Seht den Jungen, seht den Jungen!« rief die Mutter,
die sich auf ihrem Stuhl vor Lachen krümmte.</p>
<p class="calibre2">Draußen klapperten die Holzpantoffel der Kinder auf der
Treppe. Der Schultag war zu Ende. Die Mutter lief zum Fenster, um
hinauszugucken: unten auf dem weißen Schnee lärmten die
Jungens und prügelten sich.</p>
<p class="calibre2">»Satansbengels,« sagte der Küster, der
hereingekommen war, und klopfte sich mit der Spitze seiner Pfeife,
die ein wenig schief war, auf die Stirn.</p>
<p class="calibre2">»Ach,« erwiderte die Mutter, »sie sehen aus wie
Flöhe auf einem Laken.«</p>
<p class="calibre2">Der Floh war in ihren Gleichnissen ein Lieblingstier – war
überhaupt ihr Lieblingstier. Sobald eines der Kinder sich nur
rieb, sagte sie augenblicklich mit heiligem Eifer: du hast einen
Floh. Und sie zog das Kind ganz aus, untersuchte seinen ganzen
Körper, jedes Kleidungsstück, jede Falte. Der Floh war
nicht da.</p>
<p class="calibre2">Aber die Jagd machte ihr Spaß.</p>
<p class="calibre2"><a id="page60" title="woldemar/Konmax"></a>
»Zieh dich an, das widerliche Tier ist davongesprungen,«
sagte sie.</p>
<p class="calibre2">Aber war wirklich so eine kleine schwarze Kreatur da, und hatte
sie das Tier mit ihren schönen Nägeln gefangen, so
pflegte sie es lange anzusehen und darauf zu sagen:</p>
<p class="calibre2">»Laß es weiter springen.«</p>
<p class="calibre2">Der Küster setzte sich auf seinen großen Stuhl am
Fenster. Die Frau saß ihm gegenüber, während es
schummerig wurde.</p>
<p class="calibre2">»Singen Sie ein Lied,« sagte der Alte. Es war seine
Wonne, wenn »die Frau« sang.</p>
<p class="calibre2">»Das von der Liebe,« bat Tine.</p>
<p class="calibre2">»Tine ist verliebt,« lachte die Mutter.</p>
<p class="calibre2">»Das von der Liebe« war eine irische Melodie. Die
Worte sind unbekannt und vergessen. Nur die Mutter sang sie.
Vielleicht hatte sie sie selber gedichtet. – Sie sang:</p>
<p class="calibre2">Schön ist der Sonne Licht,<br class="calibre3"/>
und lieblich kann das Mondlicht sein,<br class="calibre3"/>
wenn es in stiller Nacht<br class="calibre3"/>
sich über den rinnenden Fluß<br class="calibre3"/>
ergießet weit –<br class="calibre3"/>
Schön ist der Sonne Licht.</p>
<p class="calibre2">Am schönsten doch<br class="calibre3"/>
ist der Liebe Schein,<br class="calibre3"/>
der über bei Liebenden Antlitz gleitet,<br class="calibre3"/>
wenn er unerwartet und jäh<br class="calibre3"/>
die Geliebte erblickt.</p>
<p class="calibre2">Doch wie die Sonne sinket<br class="calibre3"/>
und die Erde im Dunkeln läßt,<br class="calibre3"/>
so erlischt auch der Liebe Licht.<br class="calibre3"/>
Und es ist Nacht.</p>
<p class="calibre2">Ach, Gott Vaters Sonne,<br class="calibre3"/>
sie ist barmherzig,<br class="calibre3"/>
sie gehet wieder auf.<br class="calibre3"/>
Das Licht der Liebe, wenn es erloschen,<br class="calibre3"/>
erlischt für alle Zeit.</p>
<p class="calibre2"><a id="page61" title="woldemar/Wunibald"></a> Es ist nicht dies,<br class="calibre3"/>
daß Menschen täuschen können;<br class="calibre3"/>
ei ist nicht dies,<br class="calibre3"/>
daß Menschen verlassen wurden.<br class="calibre3"/>
Nein, nur der Liebe Licht,<br class="calibre3"/>
das jäh erlosch –<br class="calibre3"/>
und es ist Nacht.</p>
<p class="calibre2">Schön ist der Sonne Licht,<br class="calibre3"/>
die Sonne leuchtet alle Tage,<br class="calibre3"/>
und alle sehn die Sonne.<br class="calibre3"/>
Doch wer da niemals sah<br class="calibre3"/>
der Liebe Licht<br class="calibre3"/>
entzünden sich und jäh erloschen,<br class="calibre3"/>
der kennt den Tag nicht<br class="calibre3"/>
und weiß nichts von Nacht.</p>
<p class="calibre2">Das Lied erstarb.</p>
<p class="calibre2">»Wie schön das Lied ist,« sagte Tine.</p>
<p class="calibre2">»Es ist sicher wahr,« sagte die Mutter.</p>
<p class="calibre2">Aber der alte Küster sagte, hinten von seinem Stuhl im
Dunkel:</p>
<p class="calibre2">»Ja, die Liebe ist etwas, worüber man nicht nachdenkt.
Sie kommt.«</p>
<p class="calibre2">»Und geht,« sagte Mutter.</p>
<p class="calibre2">»Das stimmt,« sagte die Küstermutter so still aus
ihrem Winkel heraus.</p>
<p class="calibre2">Einen Augenblick schwieg alles. Aber dann sagte der Alte:</p>
<p class="calibre2">»Ja, kleine Frau – sehen Sie, das ist schon richtig.
Sie kommt und sie geht. Aber es gibt wohl auch Menschen, denen sie
die Tür verschließt, weil sie, wenn die Liebe nicht zu
Hause ist, sich nicht gedulden und abwarten ... bis sie wiederkommt
...«</p>
<p class="calibre2">Die Mutter antwortete nicht.</p>
<p class="calibre2">Aber kurz darauf fing sie wieder an zu singen – und da war
ihr Gesicht aufwärts gewendet und schimmerte bleich im Dunkel;
es konnte in dieses Gesicht <a id="page62" title="woldemar/gary"></a> ein Ausdruck kommen, daß es dem Gekreuzigten
glich –:</p>
<p class="calibre2">»Ach, Gott Vaters Sonne,<br class="calibre3"/>
sie ist barmherzig,<br class="calibre3"/>
sie gehet wieder auf.<br class="calibre3"/>
Das Licht der Liebe, wenn es erloschen,<br class="calibre3"/>
erlischt für alle Zeit.«</p>
<p class="calibre2">»Tine,« sagte sie, und ihre Stimme klang
plötzlich heiter, »jetzt wollen wir auf den Kirchhof
gehen.«</p>
<p class="calibre2">Das tat sie oft im Schummern oder bei Abend, aber stets
mußten Tine und die Kinder ihr auf den Fersen folgen.</p>
<p class="calibre2">Sie zogen sich an und gingen durch die blitzende Küche in
den Garten hinaus.</p>
<p class="calibre2">»Gute Nacht,« sagten die Alten. Sie standen in der
Küchentür.</p>
<p class="calibre2">»Gute Nacht.«</p>
<p class="calibre2">Der Garten war mit Schnee bedeckt. Auf den Bäumen lag Reif,
in der Kälte glitzerten feine kleinen Sterne.</p>
<p class="calibre2">»Passen Sie auf Ihre Rosen,« sagte die Mutter zu
Tine.</p>
<p class="calibre2">»Sie sind zugedeckt,« antwortete Tine.</p>
<p class="calibre2">Sie öffneten die Gittertür und traten in den Kirchhof
ein.</p>
<p class="calibre2">Alles war ganz still. Schwarze und weiße Kreuze ragten aus
dem weißen Schnee hervor. Ihre Namen waren im Dunkel
verschwunden.</p>
<p class="calibre2">»Hier ruht man sanft,« sagte die Mutter.</p>
<p class="calibre2">Durch den Schnee waren Pfade gebahnt. Die Kreuze zeigten an, wo
Gräber waren. Mitten im Schnee stand die Kirche, weiß und
groß.</p>
<p class="calibre2">Sie schritten weiter, um den Kirchhof herum.</p>
<p class="calibre2">Die Mutter und Tine gingen voran, die Kinder trabten im Schnee
hinterdrein.</p>
<p class="calibre2">Licht kam nur von den Sternen über ihnen.</p>
<p class="calibre2">Tine und die Mutter sprachen von denen, die im letzten Jahre
gestorben waren und jetzt im Grabe lagen. Sie sprachen von dem Sohn
des Dorfschulzen.</p>
<p class="calibre2"><a id="page63" title="woldemar/gary"></a>
»Ja, er hat viele unglücklich gemacht,« sagte
Tine.</p>
<p class="calibre2">»Das sagt man.«</p>
<p class="calibre2">»Und Gott mag wissen, was sie eigentlich an ihm
sahen?«</p>
<p class="calibre2">»Sahen?! Sahen?!«</p>
<p class="calibre2">Es war die Mutter, die sprach.</p>
<p class="calibre2">»Tine, die Bienen spüren, in was für Blumen Honig
ist.«</p>
<p class="calibre2">»Ja, vielleicht.«</p>
<p class="calibre2">»Es war wohl Liebesstoff in ihm,« sagte die Mutter und
schwieg eine Weile, ehe sie, indem sie vor sich hinstarrte,
fortfuhr: »und sonst nichts.«</p>
<p class="calibre2">Sie setzten ihren Weg fort.</p>
<p class="calibre2">»Kommt, Kinder,« sagte die Mutter. Zu Tine aber
bemerkte sie, und ihr Gesicht war aufwärts gewendet, ihren
Sternen zu, denen sie die vielen Namen gab:</p>
<p class="calibre2">»Tine, es gibt im Leben nur zwei Dinge – die Liebe
und den Tod.«</p>
<p class="calibre2">Sie kamen an das große Portal. Tine zog den Riegel
zurück.</p>
<p class="calibre2">»Jetzt müssen wir aber heim,« sagte die Mutter.
Sie ging nach Hause, die Kinder an ihrer Seite.</p>
<p class="calibre2">Ringsum war tiefes Schweigen, alle Häuser waren
geschlossen. Menschen begegneten ihnen nicht, und die Hunde kannten
sie.</p>
<p class="calibre2">Es war einer von Mutters schweren Tagen.</p>
<p class="calibre2">Auch als sie nach Hause kamen, wurde kein Licht angezündet,
und die Mutter sprach nicht. Sie setzte sich nur an das alte
Klavier, dessen Tasten weiß durch das viele Dunkel
schimmerten, und sang:</p>
<p class="calibre2">Es kommen die Jahre,<br class="calibre3"/>
Da wir schmerzlich wissen<br class="calibre3"/>
Des Lebens Wert.<br class="calibre3"/>
Es kommen die Jahre,<br class="calibre3"/>
Da wir verlieren müssen,<br class="calibre3"/>
Was uns beschert.</p>
<p class="calibre2">Der Vater öffnete seine Tür, und die Kinder erblickten
seinen hohen Schatten darin.</p>
<p class="calibre2"><a id="page64" title="woldemar/gary"></a> Es kommen die Jahre,<br class="calibre3"/>
Da das Heer der Gedanken<br class="calibre3"/>
Einem Leichenzug gleicht.<br class="calibre3"/>
Es kommen die Jahre,<br class="calibre3"/>
Da das sehnsüchtge Schwanken<br class="calibre3"/>
Der Müdigkeit weicht.</p>
<p class="calibre2">Der Vater regte sich nicht. Es war, als stünde er da in der
schwarzen Finsternis wie ein schwarzes Standbild.</p>
<p class="calibre2">Es kommen die Jahre –<br class="calibre3"/>
Da wird die Erinnerung<br class="calibre3"/>
Selber zum Hohn.<br class="calibre3"/>
Es kommen die Jahre,<br class="calibre3"/>
Da wir leben nicht mehr –<br class="calibre3"/>
Ach, stürben wir schon – –</p>
<p class="calibre2">Der Vater schloß die Tür.</p>
<p class="calibre2">Die Mutter fuhr bei dem Geräusch zusammen.</p>
<p class="calibre2">»Wer ist da?« fragte sie.</p>
<p class="calibre2">»Es war der Vater,« antwortete der älteste Junge
aus der Ecke.</p>
<p class="calibre2">»Mutter, sing das Lied, das wir nicht verstehen.«</p>
<p class="calibre2">Aber die Mutter schloß das Klavier.</p>
<p class="calibre2">Lange wurde es nicht mehr geöffnet.</p>
<p class="calibre2"> </p>
<p class="calibre2">Aber dann konnten Zeiten kommen, wo die Mutter nur las.</p>
<p class="calibre2">Die Tür zum Bücherschrank stand nie mehr still, ein
Band folgte dem andern. Der Kutscher fuhr nach Sonderburg, und der
Kutscher brachte Bücher mit.</p>
<p class="calibre2">Sie saß stets auf derselben Stelle, am Fenster, auf
»ihrem« Stuhl, unbeweglich. Das Buch lag auf ihrem
Nähtisch, den Kopf hatte sie in die Hände gestützt.
Die Kinder hörte sie nicht, um den Haushalt kümmerte sie
sich nicht. Sie verschlang nur Buch auf Buch.</p>
<p class="calibre2">Der Vater kam herein.</p>
<p class="calibre2">»Willst du nicht ausgehen?« fragte er.</p>
<p class="calibre2">»Ich lese.«</p>
<p class="calibre2"><a id="page65" title="woldemar/wedi"></a>
»Willst du nicht zu Lehrers gehen?«</p>
<p class="calibre2">»Du siehst ja, ich lese.«</p>
<p class="calibre2">Sie las weiter, und die Hand schlug die Blätter um.</p>
<p class="calibre2">Es verging eine Stunde. Es vergingen viele Stunden. Die Kinder
schlichen umher.</p>
<p class="calibre2">Zuweilen aber legte sie das geöffnete Buch auf die Knie,
und mit eng gefalteten Händen starrte sie vor sich hin –
schweigend, ehe sie weiter las.</p>
<p class="calibre2">Sie holte sich Bücher aus Vaters Regalen. Sie las über
Naturwissenschaft und Dogmatik. Sie las und las.</p>
<p class="calibre2">Der Vater ging durch das Zimmer:</p>
<p class="calibre2">»Willst du denn nicht ausgehen?«</p>
<p class="calibre2">»Morgen.«</p>
<p class="calibre2">»Das sagst du jeden Tag.«</p>
<p class="calibre2">»Ja, aber ich lese.«</p>
<p class="calibre2">Sie las wie ein Trinker, der sich berauscht und sich wieder
berauscht und seinen Rausch verlängert und nicht erwachen
will.</p>
<p class="calibre2">In der Dämmerung kam Tine.</p>
<p class="calibre2">»Was haben Sie angefangen?« fragte Tine.</p>
<p class="calibre2">»Ich habe gelesen.«</p>
<p class="calibre2">»Was?«</p>
<p class="calibre2">»Ich weiß nicht.«</p>
<p class="calibre2">Plötzlich aber konnte sie in Klagen ausbrechen, in lange
und heftige Vorwürfe gegen die Bücher, die sie
verschlang, die ihren Durst nicht befriedigten.</p>
<p class="calibre2">»Worüber schreiben sie?« sagte sie und schlang,
im Lichte des Feuers, vor dem sie saßen, die weißen
Hände, die im Feuerschein glühten, um ihre Knie:
»Sie schreiben schöne und dumme Worte über das, was
wir alle wissen, was wir alle zu denken gewohnt sind ... über
anderes schreiben sie nicht.«</p>
<p class="calibre2">»Alle Bücher handeln doch von Liebe,« sagte
Tine.</p>
<p class="calibre2">Die Mutter lachte.</p>
<p class="calibre2">»Das tun sie eben nicht.«</p>
<p class="calibre2">»O doch.«</p>
<p class="calibre2"><a id="page66" title="woldemar/MEsswein"></a>
»Nein, gerade in dem Punkt verdrehen die Bücher uns das
Leben, sie rauben uns den Mut, der Wahrheit in die Augen zu
sehen.«</p>
<p class="calibre2">»Was für einer Wahrheit?«</p>
<p class="calibre2">»Der <em class="calibre5">Wahrheit</em>.«</p>
<p class="calibre2">Sie schwieg einen Augenblick. Der älteste Junge lag ihr zu
Füßen und schaute empor in ihr schönes Gesicht.</p>
<p class="calibre2">»Ich kenne sie,« sagte sie, »aber sie – die
<em class="calibre5">Dichter</em>« – und sie sprach das Wort mit einem
stolzen Hohn aus, »sollten den Mut haben, sie
<em class="calibre5">auszusprechen</em> ... ich suche nach einem, der es gewagt
hat.</p>
<p class="calibre2">Sie schreiben Fabeln, die wir selber erfinden könnten, sie
setzen Verse zusammen, die wir selber drechseln und am Klavier
singen könnten ... Aber die Wahrheit sagen sie nicht ... Ja,
die Buchbinder sind die einzigen, die sie durchschauen. Sie haben
ja seit Olims Zeiten damit zu tun gehabt und haben gelernt, diese
Lügen in ein goldenes Gewand zu kleiden ...«</p>
<p class="calibre2">»Freilich,« fuhr sie fort und lächelte ein
bißchen, »die Buchhändler kennen sie vielleicht auch
– sie lächeln immer so verbindlich, wenn man ein Buch
kauft, als ob sie sagen wollten: daß du nicht klüger bist
... aber bitte schön – kaufe nur eine neue Lüge
...«</p>
<p class="calibre2">Sie saß immer noch mit verschlungenen Händen da,
plötzlich aber sprach sie ganz ruhig:</p>
<p class="calibre2">»Was mich wundert, ist nur, daß sie alle so dumm sind,
daß nicht einer von ihnen klug genug ist, sich steinigen zu
lassen, weil er die Wahrheit gesagt ...«</p>
<p class="calibre2">»Ja, aber welche Wahrheit?« fragte Tine, die
während Mutters »Leseraptus« ganz verzweifelt
war.</p>
<p class="calibre2">Die Mutter schwieg eine Weile.</p>
<p class="calibre2">»O,« sagte sie. »Der Sohn des Dorfschulzen kannte
sie. Aber der konnte nicht buchstabieren, und er war wohl auch zu
faul, um Dichter zu werden.«</p>
<p class="calibre2">Tine, die durchaus nichts verstand, sagte ablenkend: <a id="page67" title="woldemar/MEsswein"></a> »Ja, faul
war er in allem, nur nicht darin, die Mädchen ins Unglück
zu bringen ...«</p>
<p class="calibre2">»Er brachte sie nicht ins Unglück,« sagte die
Mutter, »er liebte und er hörte auf zu lieben –
– – wenn <em class="calibre5">das</em> vorbei war ...«</p>
<p class="calibre2">»Wenn was vorbei war?«</p>
<p class="calibre2">»Ja – die Begierde ... denn das ist das Geheimnis: es
gibt nichts als den Trieb, er allein ist Herr und Meister ... Der
Trieb brüllt zum leeren Himmel hinauf – er allein.
Aber,« und die Mutter machte eine Bewegung mit der Hand
»wir wollen nicht mehr davon sprechen ... weshalb sollte ich
die Wahrheit sagen? ... Glauben Sie, daß wir Schnee
bekommen?« fragte sie.</p>
<p class="calibre2">Ihr Antlitz war von dem roten Feuer beschienen ...</p>
<p class="calibre2">Dann stand sie auf. Man hörte ihre Schritte kaum. Lange
erklang das leise Vorspiel, ehe sie sang:</p>
<p class="calibre2">Laßt die Toten ruhen,<br class="calibre3"/>
laßt die Toten ruhen,<br class="calibre3"/>
ihr Erinnerungen.<br class="calibre3"/>
weckt es nimmer,<br class="calibre3"/>
laßt mein totes Herze ruhn.<br class="calibre3"/>
Nur im Tode gibt es Ruh und Frieden.<br class="calibre3"/>
Laßt es ruhen,<br class="calibre3"/>
laßt mein totes Herze ruhen.</p>
<p class="calibre2">Waren Frühlingstage,<br class="calibre3"/>
voller Fliederduften,<br class="calibre3"/>
als in lauter Sonne<br class="calibre3"/>
du das Fenster öffnest<br class="calibre3"/>
und, im Jubel strahlend,<br class="calibre3"/>
flüstertest:<br class="calibre3"/>
»Noch ein Tag –<br class="calibre3"/>
noch einen Tag zu leben.«</p>
<p class="calibre2">Waren stille, friedevolle Stunden,<br class="calibre3"/>
wenn wir unter kargen, dünnen Vorstadtbäumen<br class="calibre3"/>
schweigend schritten in der gleichen Freude,<br class="calibre3"/>
daß gemeinsam unser Träumen, unsre Tränen.</p>
<p class="calibre2"><a id="page68" title="woldemar/MEsswein"></a><br class="calibre3"/>
Laßt es ruhen, laßt es ruhen,<br class="calibre3"/>
weckt es nicht, mein totes Herze.<br class="calibre3"/>
Nur im Tode gibt es Ruh und Frieden.<br class="calibre3"/>
Ihr Erinnerungen,<br class="calibre3"/>
weckt es nicht,<br class="calibre3"/>
weckt es nicht, mein totes Herze.</p>
<p class="calibre2"> </p>
<p class="calibre2">Die Tage wurden länger, und auf dem Nähtisch in
Mutters Glas standen Schneeglöckchen. Tine war so geschickt
darin, sie unterm Schnee zu finden. Sie kannte die Stellen, an
denen sie wuchsen, und sie wühlte und wühlte, bis sie sie
fand.</p>
<p class="calibre2">Die Schneeglöckchen standen dicht an der Mauer. Tine legte
sich auf die Knie und grub mit ihren flinken Händen, die ganz
rot davon wurden.</p>
<p class="calibre2">»Seht, seht!« rief sie, wenn sie das zarte Grün
fand.</p>
<p class="calibre2">»Ja, wie hübsch ist das,« sagte die Mutter, die
am Fenster stand. »Aber wie kalt ist es noch,« fügte
sie hinzu und schloß das Fenster.</p>
<p class="calibre2">Das ganze Haus wurde mit Schneeglöckchen angefüllt.
Selbst die Mädchen hatten ein Glas voll vor ihrem Fenster
stehen (es war ein vergittertes Fenster, die Mädchen wohnten
wie in einem Gefängnis, aber die Knechte schlüpften wohl
durch die Tür hinein), und eines Tages lief die Mutter hinaus
und steckte einen Strauß an den alten Hut des Kuhhirten.</p>
<p class="calibre2">Er kam um den Kuhstall herumgeschlichen. Er schlich immer,
gleichsam als wolle er die Verdauung des lieben Viehs nicht
stören. Die Mutter saß an ihrem Fenster. Nun sprang sie
auf.</p>
<p class="calibre2">»Jens soll Schneeglöckchen am Hut haben,« sagte
sie und lief hinaus.</p>
<p class="calibre2">Über den Hof, zum Kuhstall.</p>
<p class="calibre2">Jens war ganz erschrocken. Aber die Mutter riß ihm den Hut
vom Kopf und steckte die Schneeglöckchen hinter das Band.</p>
<p class="calibre2">Der Kuhhirt blieb stehen mit dem Hut in der Hand. Dann lachte
er, meckernd und lange.</p>
<p class="calibre2"><a id="page69" title="woldemar/MEsswein"></a> Die
Mutter aber, die wieder hineingelaufen war, sagte zu Tine:
»Uff, wie eklig war sein Hut anzufassen.«</p>
<p class="calibre2">Der Frühling meldete sich. Die Schwalben kamen, und die
Anemonen sproßten hervor im Wäldchen hinter dem
Gartenhaus der Mutter.</p>
<p class="calibre2">Dann machte es der Mutter Spaß, in den Wiesen umher zu
waten.</p>
<p class="calibre2">Das Eis lag noch darauf, aber in kleine, fließende Inseln
zerteilt.</p>
<p class="calibre2">Mit aufgehobenen Röcken stand die Mutter mitten auf den
Eisschollen.</p>
<p class="calibre2">»Tine, Tine, es bricht!« ...</p>
<p class="calibre2">Tine stand mitten im Morast, bis zu den Knien aufgeschürzt,
auf das Schlimmste gefaßt.</p>
<p class="calibre2">Die Mutter flog von Scholle zu Scholle.</p>
<p class="calibre2">Bums – da lag der älteste Junge, bardauz, in der
nassen Wiese.</p>
<p class="calibre2">»So, da liegt der Junge!«</p>
<p class="calibre2">Die Mutter sah sich die Situation einen Augenblick an. Nur der
kurzgeschorene Kopf des Knaben guckte aus dem Wasser hervor.</p>
<p class="calibre2">»Herr Jesus, er sieht aus wie ein Seehund.«</p>
<p class="calibre2">Die Mutter lachte, daß sie und die Schollen bebten.</p>
<p class="calibre2">»Tine, Tine, ziehen Sie ihn heraus, damit Fritz nichts
sieht.«</p>
<p class="calibre2">Tine packte den Jungen, daß er aufheulte.</p>
<p class="calibre2">Die Mutter flog von Scholle zu Scholle, während sie mit den
Armen schlug wie ein Vogel, der sich zum Fliegen anschickt.</p>
<p class="calibre2">Die Knechte und der Kuhhirt kamen heraus, um zuzuschauen. Jens
grinste, daß ihm die Pfeife aus dem Mund fiel.</p>
<p class="calibre2">Lars aber, der Großknecht, äußerte, die Frau
spränge weiß Gott ebenso famos wie die, die durch den
Reifen springen.</p>
<p class="calibre2"><a id="page70" title="woldemar/MEsswein"></a> Lars
war häufig in Flensburg gewesen und hatte die Zirkusdamen
gesehen.</p>
<p class="calibre2">»Meiner Seel, ebenso famos,« sagte Lars und spreizte
die Fäuste in den Hosentaschen.</p>
<p class="calibre2">Jens, der Kuhhirt, aber hatte seine eigene Meinung und zwar die,
daß die Beine der Frau beinah so zierlich seien wie die einer
Geiß, ganz bestimmt.</p>
<p class="calibre2">Die Mutter sprang auf den Schollen umher, bis es dunkel wurde.
Dann setzten sie und Tine sich auf eine Bank, am Wegrand. Jenseits
des Weges standen Pappeln.</p>
<p class="calibre2">»Wie glühend die Sonne untergeht,« sagte die
Mutter.</p>
<p class="calibre2">»Ja, es gibt Sturm,« antwortete Tine.</p>
<p class="calibre2">Die Mutter sah lange auf die leise wiegenden Pappeln; sie
standen so schlank gegen den Himmel.</p>
<p class="calibre2">Dann sagte sie leiser: »Ob die Pinien sehr viel anders
ausschauen?«</p>
<p class="calibre2">Sie erhoben sich beide. Auf der Hoftreppe begegneten sie dem
Vater.</p>
<p class="calibre2">»Was hast du für rote Backen!« sagte er, denn die
Mutter war noch ganz glühend.</p>
<p class="calibre2">»Ach ja,« sagte sie und holte tief Atem, »ich bin
auch direkt vom Schmied hierher gelaufen.«</p>
<p class="calibre2">Es war dunkel in allen Stuben, und alle Türen standen
offen.</p>
<p class="calibre2">»Setzen Sie sich hierher, Tine,« sagte die Mutter, und
Tine setzte sich, mit dem Kopf gegen den Klavierstuhl, zu ihren
Füßen.</p>
<p class="calibre2">Mutters Finger liefen über die Tasten hin:</p>
<p class="calibre2">»Wie seltsam, aber es ist, als ertrüge ich es nicht
länger als eine Stunde, froh zu sein.« Die Läufe
wurden zu einem Vorspiel, und die Mutter sang:</p>
<p class="calibre2">Ein jedes Kind, das du gebierst,<br class="calibre3"/>
Gebierst du für die Not,<br class="calibre3"/>
Und keimt ein neues Blatt hervor,<br class="calibre3"/>
Es keimt nur für den Tod.</p>
<p class="calibre2"><a id="page71" title="woldemar/MEsswein"></a> Ein jeder Liebesrausch, genossen,<br class="calibre3"/>
Trägt Schmerz in seinem Schoß,<br class="calibre3"/>
Ein jedes Liebeswort, verflossen,<br class="calibre3"/>
Ist aller Farbe bloß.</p>
<p class="calibre2">Ein jedes Glücksgespinst, gesponnen,<br class="calibre3"/>
Zerreißt es dir gar bald.<br class="calibre3"/>
Als er der einen Kuß genommen,<br class="calibre3"/>
Sein Traum der andern galt.</p>
<p class="calibre2">»Wie ist das Lied traurig!« sagte Tine.</p>
<p class="calibre2">Die Mutter schwieg eine Weile, dann sagte sie:</p>
<p class="calibre2">»Wissen Sie, was ich mir wünschen könnte, Tine?
– Daß ich ein Lied schreiben könnte, so traurig wie
das Leben.«</p>
<p class="calibre2">Sie schwieg abermals, während die weißen Hände
über den Tasten schimmerten: »Aber es ist weise bedacht:
daß das Glück keinen Plural hat.«</p>
<p class="calibre2">»Ja, das ist seltsam.«</p>
<p class="calibre2">Die Mutter stützte ihren Kopf in die Hand:</p>
<p class="calibre2">»Nein,« sagte sie, »es gibt nur eins.«</p>
<p class="calibre2">Der Vater ging durch die Stube, durch die Dämmerung, wie
ein Schatten.</p>
<p class="calibre2">»Wollt ihr nicht Licht machen?« fragte er.</p>
<p class="calibre2">»Gleich wird es angezündet,« antwortete die
Mutter.</p>
<p class="calibre2">Und Tine steckte die Lampe an.</p>
<p class="calibre2">»Jetzt wollen wir Patience legen,« sagte die Mutter,
und sie vergrub sich stundenlang in die Karten.</p>
<p class="calibre2">»In den Karten begegnet man immer dem
Glücksbuben,« sagte sie.</p>
<p class="calibre2">Tine sah zu, bis ihr die Augen schwer von Schlaf wurden.</p>
<p class="calibre2">Nebenan im Zimmer hörte man unablässig den Vater hin
und her gehen, hin und her.</p>
<p class="calibre2"> </p>
<p class="calibre2">Der Frühling kam.</p>
<p class="calibre2">An kalten und klaren Abenden streifte die Mutter mit Tine umher,
über die Felder mit ihrem zarten Grün, auf Hügel und
Anhöhen hinauf, wo sie weit sehen konnte.</p>
<p class="calibre2"><a id="page72" title="BeBi/woldemar"></a> Dort
stand sie so gern.</p>
<p class="calibre2">Die Luft war noch kalt und biß sie in die Wangen,
während die Sonne in einem blassen Rot unterging. Sie stand,
mit der erhobenen Hand über den Augen, schlank gegen den
Himmel, als spähe sie nach dem nahenden Frühling.</p>
<p class="calibre2">Dann wurden die Tage milder, in den Stuben daheim standen alle
Schalen voll duftender Veilchen, und im Küchengarten kamen an
den langen Reihen von Stachelbeerbüschen feine Blätter
hervor.</p>
<p class="calibre2">Die Erde auf den Feldern wurde glänzend schwarz, der Humus
lag feucht und blank und fruchtbar da – die Mutter konnte
abends, wenn sie die Feldwege entlang gingen, Tine und die Kinder
anhalten:</p>
<p class="calibre2">»Seht,« sagte sie, »seht, wie die Erde
atmet.«</p>
<p class="calibre2">Die Frühjahrssaat sproßte in grünendem Gewimmel
hervor, während der Roggen stramm und schlank dastand und den
Abend mit dem starken Duft des jungen Grüns erfüllte.</p>
<p class="calibre2">Auch die Bäume bekamen Blätter, und alle Knospen
sprangen, während die Luft satter und schwerer wurde; und der
erste Dunst stieg aus der lebenden Erde auf, zu einem Blau des
Himmels empor, das sich immer dunkler und kräftiger
färbte.</p>
<p class="calibre2">Die Mutter hatte die Wanderkrankheit.</p>
<p class="calibre2">Sie ging und ging.</p>
<p class="calibre2">Plötzlich konnte sie stehen bleiben.</p>
<p class="calibre2">»Tine,« sagte sie, »es ist, als stöhnte die
Erde.«</p>
<p class="calibre2">Im Garten blühten die Lilien auf.</p>
<p class="calibre2">Hoch und schlank würzten sie die dämmernde Nacht mit
ihrem süßlichen Hauch.</p>
<p class="calibre2">Vom Teich stieg der Dunst auf, gesättigt mit dem Duft des
Humus, wie ein heißer Atemstrom der Erde.</p>
<p class="calibre2">Um das weiße Gartenhaus schlangen sich glänzend die
Rosenranken, und die Blätter entfalteten sich, während
sie ihren sinnlich-herben Wohlgeruch verbreiteten.</p>
<p class="calibre2"><a id="page73" title="woldemar/Monne3"></a> Und
überall, auf allen Dächern, flogen die weißen Tauben
zueinander, während in Pappeln und Büschen die Vögel
riefen und lockten.</p>
<p class="calibre2">»Wir wollen weiter gehen,« sagte die Mutter.</p>
<p class="calibre2">Sie ging mit Tine durch das Wäldchen hinter der Kirche,
– Paradies wurde es genannt – die Anhöhe
hinan.</p>
<p class="calibre2">Die Mutter pflückte schweigend einen Strauß tauiger
Blumen.</p>
<p class="calibre2">Alles war grün geworden, und von Feldern und Wäldern
und allen Sümpfen stieg ein zitternder Nebel zum dunkelnden
Himmel auf.</p>
<p class="calibre2">Häuser und Höfe sahen sie zu ihren Füßen,
und die Umrisse der weißen Kirche, und alles war in der
schwangeren Feuchtigkeit der dampfenden Erde gleichsam
verwischt.</p>
<p class="calibre2">Die Mutter schaute zum gewölbten Himmel auf und sagte:</p>
<p class="calibre2">»Die Sterne, Tine, wollen es nicht sehen.«</p>
<p class="calibre2">Sie schritten zurück durch das Wäldchen.</p>
<p class="calibre2">»Wie ist die Luft schwer!« sagte die Mutter.</p>
<p class="calibre2">»Das ist der Holunder,« sagte Tine.</p>
<p class="calibre2">»Wir wollen auf den Kirchhof gehen,« sagte die
Mutter.</p>
<p class="calibre2">Sie öffneten die Pforte und traten ein.</p>
<p class="calibre2">Alle Büsche strotzten von Laub, und die Buchsbaumhecken
glänzten. Hinter den weißen Mauern lag der Blumenduft
dicht und schwer. Ringsum standen die stummen Kreuze.</p>
<p class="calibre2">Die Mutter blieb bald bei dem einen, bald bei dem andern Kreuz
stehen. Und in die gesättigte Luft hinaus sprach sie leise die
Namen auf den Kreuzen und die Worte der Inschriften:</p>
<h1 class="calibre4">»Mir geschehe nach deinem Wort.«</h1>
<p class="calibre2">Und sie schritt weiter:</p>
<h1 class="calibre4">»Die Liebe ist des Gesetzes Erfüllung.«</h1>
<p class="calibre2">Sie schritt weiter den Pfad entlang, und sie bog die Lilien zur
Seite, als ertrage sie ihren Duft nicht.</p>
<p class="calibre2"><a id="page74" title="woldemar/Monne3"></a>
»Jetzt haben Dorfschulzens den Hügel machen lassen,«
sagte Tine.</p>
<p class="calibre2">»Ja,« antwortete die Mutter.</p>
<p class="calibre2">Sie beugte sich nieder und legte behutsam den Strauß, den
sie trug, auf den frischen Hügel.</p>
<p class="calibre2">»Von ihnen, denen er das Glück brachte und die weinen
mußten,« sagte sie.</p>
<p class="calibre2">»Ist das ein Dank?« fragte Tine.</p>
<p class="calibre2">Die Mutter antwortete nicht.</p>
<p class="calibre2">Schweigend, starr vor sich hinsehend, blieb sie vor dem frisch
aufgeworfenen Grabe stehen.</p>
<p class="calibre2">Eine Fledermaus flog vorbei, und die Mutter fuhr zusammen.</p>
<p class="calibre2">»Kommt,« sagte sie. Und als sie draußen waren,
faßte sie sich an den Kopf:</p>
<p class="calibre2">»Tine – leben die Toten denn?« sagte sie, und
sie versuchte zu lachen.</p>
<p class="calibre2">Unten am Abhang hinter der Mauer gab's ein Geflüster und
Gehusche.</p>
<p class="calibre2">»Ach,« sagte Tine und lachte, »das sind ja nur
die Knechte mit ihren Mädchen.«</p>
<p class="calibre2">Die Mutter kam nach Hause zurück, über den Hof, und
ging in ihre Stube hinauf.</p>
<p class="calibre2">Es war Halbdunkel, und alle Türen standen offen.</p>
<p class="calibre2">»Maren, Maren!« rief sie durch das Haus.</p>
<p class="calibre2">Aber niemand antwortete.</p>
<p class="calibre2">Nur die Heimchen sangen im Waschhause und am Herde.</p>
<p class="calibre2">Die Mutter öffnete die Tür zum Waschhause.</p>
<p class="calibre2">»Maren, Maren!« rief sie über den Hof hinaus.</p>
<p class="calibre2">Sie sah nur ein paar Schatten, die zum Teiche
hinunterflüchteten.</p>
<p class="calibre2">Sie schloß die Tür und ging langsam ins Haus. Wenn
durch die Scheiben Licht auf ihr Gesicht fiel, schimmerte es
bleich.</p>
<p class="calibre2"><a id="page75" title="woldemar/MEsswein"></a> Sie
setzte sich auf ihren Stuhl, und mit gefalteten Händen starrte
sie in den leeren Raum hinaus.</p>
<p class="calibre2">Der Vater öffnete seine Tür.</p>
<p class="calibre2">»Ist hier jemand?« fragte er.</p>
<p class="calibre2">Im Halbdunkel antwortete sie leise:</p>
<p class="calibre2">»Ja – ich.«</p>
<p class="calibre2">Und der Vater sagte:</p>
<p class="calibre2">»Ich sah dich nicht.«</p>
<p class="calibre2">Er begann im Zimmer auf und nieder zu gehen und sagte:</p>
<p class="calibre2">»Ich rief vorhin, aber hier ist kein Mensch.«</p>
<p class="calibre2">»Nein,« antwortete die Mutter.</p>
<p class="calibre2">»Ja, wo sind sie denn – was machen sie
alle?«</p>
<p class="calibre2">Mit einem leichten Wechsel der Stimme sagte die Mutter:</p>
<p class="calibre2">»Es ist Frühling, Fritz.«</p>
<p class="calibre2">Der Vater ging eine Weile hin und her.</p>
<p class="calibre2">»Du mußt sie zu Hause halten,« sagte er.
»Das ganze Haus steht abends leer – das geht nicht
an.«</p>
<p class="calibre2">Die Mutter regte sich nicht, aber indem sie den Hinterkopf an
die Wand lehnte, sprach sie in die Luft hinaus und nicht zu
ihm.</p>
<p class="calibre2">»Die Erde ist der Lehrmeister für ihre Kinder
geworden.«</p>
<p class="calibre2">Der Vater blieb in einer Ecke stehen und setzte sich. Lange
saß er schweigend da.</p>
<p class="calibre2">Dann sagte er:</p>
<p class="calibre2">»Wie weit du dich entfernt hast –«</p>
<p class="calibre2">Die Mutter antwortete nicht. Doch nach einer Weile sagte
sie:</p>
<p class="calibre2">»Fritz, die Natur ist am stärksten, und die Erde
selber treibt sie. Ja, Fritz,« und sie redete heftiger:</p>
<p class="calibre2">»Je mehr ich nachdenke, desto sicherer erkenne ich, es gibt
nur ein Gesetz, ein einziges: daß das Leben fortgepflanzt sein
will.«</p>
<p class="calibre2"><a id="page76" title="woldemar/MEsswein"></a> Sie
schwieg wieder einen Augenblick, dann sagte sie langsamer:</p>
<p class="calibre2">»Das glaube ich.«</p>
<p class="calibre2">»Fortgepflanzt zu welchem Ziel?«</p>
<p class="calibre2">»Ziel? Das Ziel ist die Fortpflanzung.«</p>
<p class="calibre2">»Und weshalb?«</p>
<p class="calibre2">Die Mutter sah in die leere Luft hinaus.</p>
<p class="calibre2">»Das weiß ich nicht,« sagte sie. »Gibt es
nicht Billionen von Sternen? Sie werden das Ziel wohl vollbringen
helfen.«</p>
<p class="calibre2">Sie schwiegen eine Weile.</p>
<p class="calibre2">Dann sagte sie:</p>
<p class="calibre2">»Weshalb, Fritz, sind die Menschen so eitel? Sind wir etwa
nicht die geringsten Dienstboten in einem großen Hause, dessen
Herrn wir nie von Angesicht zu Angesicht sehen?</p>
<p class="calibre2">Wir müssen unsere Tränen verbergen. Wir leiden und
– bereiten Leiden.</p>
<p class="calibre2">Mehr wissen wir nicht.«</p>
<p class="calibre2">Der Vater erhob sich, aufgeregt.</p>
<p class="calibre2">»Dein ganzes eigenes Leben widerspricht dem, was du sagst;
glaubst du denn, ich weiß nicht, daß dein ganzes Leben
eine einzige Aufopferung ist?«</p>
<p class="calibre2">Die Mutter antwortete nicht gleich, dann sagte sie unendlich
mild:</p>
<p class="calibre2">»Fritz, wenn man sich über die Leere des Lebens klar
geworden ist, muß man es mit etwas ... Gleichgültigem
füllen.«</p>
<p class="calibre2">»Ist denn die Aufopferung auch etwas
Gleichgültiges?«</p>
<p class="calibre2">»Ja – vollkommen.«</p>
<p class="calibre2">Der Vater gab keine Antwort.</p>
<p class="calibre2">Es war, als glitte sein wandernder Schatten ins Dunkel
hinein.</p>
<p class="calibre2">»Oder,« sie sprach ruhig, wie jemand, der eine letzte
Frage stellt, »macht zum Beispiel meine Aufopferung dein Leben
wirklich reicher?«</p>
<p class="calibre2"><a id="page77" title="woldemar/MEsswein"></a>
Vielleicht erwartete sie nur eine Sekunde lang eine Antwort; aber
der Vater blieb stumm; und im Dunkeln zitterten vielleicht ihre
Hände einen Augenblick.</p>
<p class="calibre2">Von ihrem erhöhten Platz her sagte sie dann:</p>
<p class="calibre2">»Es gibt zwar mancherlei Arten Scheinleben: in der Kunst,
in der Aufopferung, in der Arbeit, in der Freundschaft, in der Tat;
nur an einem Ort ist das Leben – dort, wo die Natur es
gewollt hat.«</p>
<p class="calibre2">Die Mutter schwieg, und in der Stube war es still.</p>
<p class="calibre2">Leise wurden draußen die Türen aufgeklinkt.</p>
<p class="calibre2">Die Leute kamen nach Hause.</p>
<p class="calibre2">»Jetzt kommen sie wieder,« sagte die Mutter. Der Vater
schritt zur Tür und rief hinaus, seine Stimme zitterte.</p>
<p class="calibre2">Dann erscholl von der Allee her Gesang, er tönte so hell
und frühlingsgesättigt zu ihnen hinauf.</p>
<p class="calibre2">»Ach, das ist Tine,« sagte die Mutter. Und sie
riß das Fenster auf.</p>
<p class="calibre2">Glühend kam des Küsters Tochter angelaufen.</p>
<p class="calibre2">»O, ich mußte her, dies sind die ersten Erdbeeren.
Mutter hat sie heute abend gepflückt,« und sie reichte
die roten Beeren zum Fenster hinauf.</p>
<p class="calibre2">»Entzückende Frau,« sagte sie.</p>
<p class="calibre2">Und die Mutter beugte das Gesicht über den Duft der
Beeren.</p>
<p class="calibre2"> </p>
<p class="calibre2">Jeden Tag zur Mittagsstunde mußte Tine hinunter und sehen,
ob die Rosen aufblühten.</p>
<p class="calibre2">Die wilden Rosen an den weißen Säulen von Mutters
Gartenhaus.</p>
<p class="calibre2">»Ja, sie kommen schon,« sagte sie.</p>
<p class="calibre2">»Voriges Jahr kamen sie nicht,« sagte die Mutter,
»und da hatten wir auch keine Erdbeeren.«</p>
<p class="calibre2">Rosen und Erdbeeren, die gehörten zu Mutters
Geburtstag.</p>
<p class="calibre2"><a id="page78" title="woldemar/gary"></a>
»Ja, voriges Jahr,« sagte Tine, »daran war nur die
Kälte schuld.«</p>
<p class="calibre2">Und sie setzten sich hinein auf die weiße Bank und starrten
über den Teich hin und sprachen davon, wie es letztes Jahr und
vorletztes Jahr und das Jahr vordem und vor vielen, vielen
Geburtstagen gewesen.</p>
<p class="calibre2">»Ach ja, aber damals waren Sie klein,« sagte die
Mutter.</p>
<p class="calibre2">Mit einem Male lachte die Mutter, daß sie sich
schüttelte:</p>
<p class="calibre2">»Du lieber Gott! Sie hatten ein schottisches Kleid an, wie
saß das an Ihrem Körper! Nie in meinem Leben habe ich
etwas so Rotohriges gesehen wie Sie, als Sie klein waren. Und
drall!« sagte die Mutter.</p>
<p class="calibre2">Die Mutter lachte noch immer und redete von Tine als Kind.</p>
<p class="calibre2">Am schlimmsten aber war es an dem Geburtstag gewesen, als die
dicke Madam Jespersen in den Teich gefallen war.</p>
<p class="calibre2">»Kinder!« sagte die Mutter. »Da sitzt sie, ganz
nah am Rande, und plötzlich nimmt der liebe Gott sie und ihren
Stuhl, und sie plumpst hintenüber, die
Rechtsundlinksgestrickten hoch in die Luft.«</p>
<p class="calibre2">Der Anblick war gräßlich gewesen.</p>
<p class="calibre2">»Man sah ja nichts weiter als die drei Straußfedern
über dem Wasserspiegel,« sagte die Mutter.</p>
<p class="calibre2">»Ja, da war ich eben konfirmiert,« bemerkte Tine.</p>
<p class="calibre2">Am Tage vor dem Geburtstage war ein Betrieb wie vor
Weihnachten.</p>
<p class="calibre2">Tine buk, und Tine knetete.</p>
<p class="calibre2">Alle Küchenfenster standen weit offen, und Maren, das
Waschmädchen, die einen selbstgestrickten wollenen Unterrock
anhatte, schwitzte, daß es nur so troff.</p>
<p class="calibre2">Die Knechte kamen abwechselnd herbei und stellten sich in die
Tür, um zuzusehen.</p>
<p class="calibre2">»Weg da, Lars,« sagte Tine. Sie flog ein und aus und
rührte dabei unverdrossen die Sandtorte in einer
Schüssel, <a id="page79" title="woldemar/gary"></a> so groß, als solle die ganze Gegend sich
Leibschmerzen davon holen.</p>
<p class="calibre2">Die Mutter stand hilflos mitten in der Küche.</p>
<p class="calibre2">»Tine, daß es nur ja genug wird! Sie wissen, was in
Jespersens hineingeht, wenn sie eingeladen sind.«</p>
<p class="calibre2">Die Schneebesen klangen gegen die irdenen Schüsseln, und
die Männer-Marie heizte, daß der Ofen glühte.</p>
<p class="calibre2">Der Vater öffnete die Tür.</p>
<p class="calibre2">»Stella, deine Hände.«</p>
<p class="calibre2">»Fritz, ich rühre mich ja nicht.«</p>
<p class="calibre2">Und der Vater machte die Tür wieder zu.</p>
<p class="calibre2">Die Kinder stürmten herein vom Waschhause her und
füllten die halbe Küche; sie wollten den Teig
probieren.</p>
<p class="calibre2">Sie probierten, daß sie alle eigelbe Schnäbel
kriegten.</p>
<p class="calibre2">»Und nun hinaus!« sagte Tine.</p>
<p class="calibre2">»Jetzt schließen wir die Tür zu.«</p>
<p class="calibre2">Die Kinder wurden vor die Tür gesetzt, die Mutter auch, und
sie hörten nur, draußen im Hofe, die Löffel klappern
und Tine kommandieren.</p>
<p class="calibre2">Maren, das Waschmädchen, stimmte das Lied von dem General
Rye an.</p>
<p class="calibre2">Die Mutter lief die Allee hinunter und alle Kinder hinter ihr
her.</p>
<p class="calibre2">»Fangt mich,« rief sie und lief voran.</p>
<p class="calibre2">Der Vater öffnete sein Fenster.</p>
<p class="calibre2">»Stella, deine Brust,« sagte er.</p>
<p class="calibre2">»Fritz, wir laufen nur!«</p>
<p class="calibre2">Die ganze Schar jagte weiter.</p>
<p class="calibre2">Am Ende der Allee begegnete ihnen ein Mann mit einem
Leierkasten.</p>
<p class="calibre2">»Da ist ein Leierkasten!« rief die Mutter,
»lieber Mann, kommen Sie doch herein.«</p>
<p class="calibre2">Und der Leierkastenmann hinkte voran, die anderen folgten
hinterher, und die Mutter rief:</p>
<p class="calibre2">»Tine, Tine, hier ist ein Leierkasten!«</p>
<p class="calibre2"><a id="page80" title="woldemar/MEsswein"></a> Der
Mann fing mitten im Hof an zu spielen, die Mutter aber schob ihn
weg und sagte:</p>
<p class="calibre2">»Lassen Sie mich.«</p>
<p class="calibre2">Und unter der Linde begann sie selber zu drehen, während
sie laut auflachte, denn es war General Bertrams Abschiedslied, das
sie leierte.</p>
<p class="calibre2">In der Küche liefen sie an die Fenster, und die Knechte
erschienen in der Waschhaustür.</p>
<p class="calibre2">Jens, der Kuhhirt, steckte seinen Kopf aus dem Stall heraus.</p>
<p class="calibre2">»Da spielt die Frau selber,« sagte er.</p>
<p class="calibre2">General Bertrams Abschiedslied war vorüber, und die Mutter
leierte weiter.</p>
<p class="calibre2">»Hei, hopp!« sagte sie, »jetzt kommt eine Polka!
Tine, Tine,« rief sie, »jetzt könnt ihr
tanzen.«</p>
<p class="calibre2">Die Mädchen liefen hinaus, Tine an der Spitze, und
schweißtriefend und barhäuptig begannen sie mitten auf
dem Hof um den Leierkasten herum zu tanzen. Marens Rock reichte ihr
kaum bis zu den Knöcheln herab.</p>
<p class="calibre2">»Tanzt! tanzt!« rief die Mutter den Knechten zu.</p>
<p class="calibre2">Aber niemand außer Lars, dem Großknecht, wagte es; er
schlich, ein bißchen verlegen, heran und zog die Holzpantoffel
aus, ehe er Tine aufforderte und mit ihr, in seinen wollenen
Socken, auf dem Rasen tanzte.</p>
<p class="calibre2">»Hallo, hallo,« rief die Mutter, »jetzt feiern
wir Erntefest.«</p>
<p class="calibre2">Sie drehte den Leierkasten, daß ihr der Schweiß auf
dem bleichen Gesicht stand.</p>
<p class="calibre2">Die Kinder umtosten jauchzend den Leierkasten.</p>
<p class="calibre2">»Tanzt, tanzt!« rief die Mutter, und die Kinder
sprangen. Der lahme Leiermann aber stand gemütlich da und
schnüffelte nach dem Backgeruch.</p>
<p class="calibre2">Lars hatte Tine geschwungen, daß ihr Kattunkleid flatterte
– viel war nicht drunter – und jetzt machte er eine
schiefe Verbeugung vor dem Leierkasten.</p>
<p class="calibre2">»Tine, drehen Sie!« rief die Mutter.</p>
<p class="calibre2"><a id="page81" title="woldemar/MEsswein"></a> Tine
lief herbei und drehte, und die Mutter schwang sich im Tanze,
während alle Kinder schrien.</p>
<p class="calibre2">»Mutter tanzt, Mutter tanzt!«</p>
<p class="calibre2">Lars, der Großknecht, hielt die schlanke Mutter so behutsam
umfaßt, als sei sie von Porzellan, während er auf den
Socken umherhüpfte.</p>
<p class="calibre2">»Ah, ich kann nicht mehr,« sagte die Mutter. Tine aber
drehte weiter, und die Mutter rief plötzlich:</p>
<p class="calibre2">»Nein, wenn Fritz nicht zu Hause wäre,
müßten wahrhaftig die Pferde heraus.«</p>
<p class="calibre2">Sie wollte die Pferde heraus haben.</p>
<p class="calibre2">»Tine, am Tage vor meinem Geburtstag sagt er
nichts.«</p>
<p class="calibre2">Sie rief den Kuhhirten.</p>
<p class="calibre2">»Jens! Jens!«</p>
<p class="calibre2">Jens kam herangehinkt.</p>
<p class="calibre2">»Jens,« sagte die Mutter und fing plötzlich zu
flüstern an, »laß die Pferde heraus.«</p>
<p class="calibre2">Ringsumher tanzten die Mädchen, und die Kinder schrien, als
mache ihr eigenes Geheul sie von Minute zu Minute toller.</p>
<p class="calibre2">»Da sind sie,« rief die Mutter. Die beiden Braunen
setzten aus der Stalltür.</p>
<p class="calibre2">Hinterher kam »Beauty«.</p>
<p class="calibre2">»Jagt sie, jagt sie!« rief die Mutter, und sie selber
schwenkte mit ihrem Taschentuch.</p>
<p class="calibre2">Die Pferde rasten umher, und die Mägde tanzten.</p>
<p class="calibre2">»Vorsicht! Vorsicht!« rief die Mutter. Es war ein
einziger Spektakel.</p>
<p class="calibre2">»Stella, Stella!« erklang es plötzlich vom
Fenster her.</p>
<p class="calibre2">»Herrgott – Fritz!« sagte die Mutter und stand
plötzlich ganz steif da.</p>
<p class="calibre2">Die Mägde verschwanden in einem Nu, als habe die Erde sie
verschlungen.</p>
<p class="calibre2">»Ja,« sagte die Mutter stotternd, »Fritz, ich
weiß nicht, wie es gekommen ist.«</p>
<p class="calibre2"><a id="page82" title="woldemar/MEsswein"></a> Der
Vater aber schloß sein Fenster, und die Mutter sagte leise zu
Tine, indem sie die Schultern hochzog, als ergötze sie
sich:</p>
<p class="calibre2">»Jetzt soll der Mann Kaffee haben.</p>
<p class="calibre2">Denn, Tine, solche Leiermänner wissen tausend
Geschichten.«</p>
<p class="calibre2">Der Leiermann kam in die Gesindestube, und die Mutter hörte
stundenlang seinem Geschwätz zu.</p>
<p class="calibre2">»Ja, ja – weiter, Leiermann, weiter,« sagte sie
und rückte ihm immer näher auf der Bank.</p>
<p class="calibre2">Der Leierkastenmann erzählte Geschichten von seiner
Weltumsegelung.</p>
<p class="calibre2">Als er ging, bekam er einen Taler.</p>
<p class="calibre2">»Tine, nein,« sagte die Mutter voller Entzücken:
»wie der Mann lügen kann. Das ist ganz wie in dem
Stück im Lesebuch, wo die Negerkönigin sich zur Verdauung
auf den Leib trampeln läßt.</p>
<p class="calibre2">Das stand im deutschen Lesebuch, und das ist wahr, wenn auch
Fritz sagt, ich lüge. Aber kommen Sie nun,« sagte sie,
»jetzt gehen wir.«</p>
<p class="calibre2">Sie gingen durch den Garten hinab.</p>
<p class="calibre2">Der Abend war lau und licht, und der Teich lag spiegelblank
da.</p>
<p class="calibre2">Die ersten Rosen dufteten an der Hecke.</p>
<p class="calibre2">»Hören Sie, wie still es ist,« sagte die
Mutter.</p>
<p class="calibre2">»Ja, so still.« –</p>
<p class="calibre2">Von den Wiesen stieg der Dampf auf. Weit in der Ferne sahen sie
den Wald.</p>
<p class="calibre2">»Tine,« sagte die Mutter, »hier möchte ich
gern sterben.«</p>
<p class="calibre2">Und an die weiße Säule gelehnt, daß die Rosen
über ihr Haar fielen, schaute sie über den Teich und die
Wiese und den Wald hin.</p>
<p class="calibre2">»Weshalb ist der Rahmen des Lebens so schön,«
sagte sie. Und müde sank ihre schöne Hand seitwärts
herab.</p>
<p class="calibre2"> </p>
<p class="calibre2"><a id="page83" title="woldemar/MEsswein"></a> Am
nächsten Morgen erschien Tine um fünf. Das erste, was sie
tat, war die Mutter einzuschließen.</p>
<p class="calibre2">Sie drehte den Schlüssel in beiden Türen zweimal herum
– auch in der Tür zum Schrankzimmer.</p>
<p class="calibre2">Denn vor drei Jahren hatte sich die Mutter am Geburtstage durch
das Schrankzimmer über den Boden hinausgeschlichen und hatte
plötzlich mitten im Gartenhaus gestanden: »Gott, da ist
die Frau,« hatte Tine gesagt:</p>
<p class="calibre2">»Und Sie sind im Nachthemd!«</p>
<p class="calibre2">Die Mutter aber hatte alle Geschenke gesehen, ehe der Tisch
fertig gedeckt war.</p>
<p class="calibre2">Die Kinder waren nach sechs nicht im Bett zu halten.</p>
<p class="calibre2">Sie wollten auf.</p>
<p class="calibre2">Die Mutter hatte auch keine Ruhe in ihrem Bett.</p>
<p class="calibre2">Sie sprang auf bloßen Füßen auf den Boden und
donnerte an die verschlossene Tür.</p>
<p class="calibre2">»Jetzt will ich hinaus!« rief sie.</p>
<p class="calibre2">Und sie donnerte noch stärker.</p>
<p class="calibre2">Tine war aber noch nicht fertig mit dem Tisch.</p>
<p class="calibre2">Er war mit einem Damasttuch gedeckt; und von Rosen sollten
lauter S auf das Tuch gelegt werden und ein S sollte auf den
Geburtstagskringel gemacht werden. Es wurde aus einer Tüte
daraufgespritzt, die mit Wasser und weißem Zucker gefüllt
war.</p>
<p class="calibre2">Tine stand in der Küche und spritzte das Kunstwerk,
während sich die Kinder um sie drängten, um
zuzusehen.</p>
<p class="calibre2">Alle ihre Münder standen offen.</p>
<p class="calibre2">»So,« sagte Tine, »jetzt puste ich.«</p>
<p class="calibre2">Und mit hochrotem Kopfe pustete sie das S auf den Kringel,
während die Kinder sie anstarrten.</p>
<p class="calibre2">»So,« sagte Tine, »jetzt den
Schnörkel.«</p>
<p class="calibre2">Und sie pustete wieder.</p>
<p class="calibre2">Die Mutter hämmerte immer noch oben an die Tür:</p>
<p class="calibre2">»Tine, Tine!«</p>
<p class="calibre2"><a id="page84" title="woldemar/MEsswein"></a>
»Ja, ja!« rief Tine, die den Kringel trug, »Sie
müssen wirklich noch dableiben.«</p>
<p class="calibre2">Die Mägde liefen mit rotangemalten Blumentöpfen in den
Händen zum Gartenhaus hinunter.</p>
<p class="calibre2">Sie schenkten an jedem Geburtstage der Frau Goldlackstauden, die
im Mägdezimmer bei der vielen nächtlichen Hitze
aufgezogen waren.</p>
<p class="calibre2">Alle Gaben lagen an ihrem Platze auf dem Tisch, und Tine und die
Kinder nahmen die Pracht in Augenschein.</p>
<p class="calibre2">Der Vater kam an der Hecke entlang gewandert.</p>
<p class="calibre2">Still legte er sein Geschenk auf den Tisch, halb versteckt, und
schritt wieder davon.</p>
<p class="calibre2">»Jetzt können wir die Frau holen,« sagte
Tine.</p>
<p class="calibre2">Die Kinder stürmten davon, ins Haus hinein, die Treppe
hinauf.</p>
<p class="calibre2">»Mutter, Mutter – jetzt! –«</p>
<p class="calibre2">Und Tine öffnete die Tür.</p>
<p class="calibre2">Weißgekleidet liefen die Kinder der Mutter voraus, durch
die grünen Hecken zum weißen Gartenhause hinunter.</p>
<p class="calibre2">»Mutter, Mutter,« schallte es in einem fort.</p>
<p class="calibre2">»Mama, Mama,« erscholl es, bis sie das weiße
Gartenhaus erreichten. Und jedes der Kinder ergriff sein Geschenk
und hielt es der Mutter mit ausgestreckten Händen
entgegen.</p>
<p class="calibre2">»Mutter, Mutter, das ist von mir!«</p>
<p class="calibre2">»Mutter, Mutter, nein, dies ist von mir!«</p>
<p class="calibre2">Und sie standen auf den Zehen, um es ihr hinaufreichen zu
können.</p>
<p class="calibre2">Einen Augenblick stand die Mutter da, weiß zwischen den
weißen Kindern. Sie schaute weit über die sommerlichen
Wiesen hin. Alles war in Licht gebadet: Himmel und Luft und
Erde.</p>
<p class="calibre2">»Wie schön ist der Tag!« sagte die Mutter.</p>
<p class="calibre2">Und sie lächelte.</p>
<p class="calibre2">Da riß sie die Hand hoch – Tyras leckte ihr die
Finger und legte sich ihr zu Füßen.</p>
<p class="calibre2"><a id="page85" title="woldemar/MEsswein"></a>
»Ach, bist du es?« sagte sie.</p>
<p class="calibre2">Und mitten im Sonnenlicht stand sie da zwischen den wilden
Rosen, die Kinder um sich geschart und Tyras ihr zu
Füßen.</p>
<p class="calibre2">Die Mägde kamen und die Knechte, die heute Stiefel
trugen.</p>
<p class="calibre2">Sie schlichen ganz behutsam um den Teich herum, mit geducktem
Nacken und Knien – sie sahen aus, als wollten sie in der
Kirche den Opferpfennig erlegen.</p>
<p class="calibre2">Die Mutter drückte ihnen die Hand, einem nach dem
andern.</p>
<p class="calibre2">Die Mägde schielten jede nach ihrem Geschenk hinüber
und gingen dann weiter.</p>
<p class="calibre2">Zuhinterst trabte Jens, der Kuhhirt. Seine Hosen hingen hinten
so traurig hinab, als käme er kondolieren.</p>
<p class="calibre2">Wenn sie glücklich alle fort waren, spülte sich die
Mutter im Teich die Hände.</p>
<p class="calibre2">Tine war hinaufgegangen, um die Schokolade zu holen.</p>
<p class="calibre2">»Liebe Kinder, laßt sie uns gleich trinken,«
sagte die Mutter: »dann ist es überstanden
–«</p>
<p class="calibre2">Die Kinder waren weggelaufen, und sie war allein.</p>
<p class="calibre2">Still schritt sie hinein und öffnete den Brief, den der
Vater auf ihren Tisch gelegt hatte.</p>
<p class="calibre2">Langsam faltete sie den Brief auseinander und las: »Dir
Glück zu wünschen, kommt mir so wunderlich vor. Aber ich
wünsche Dir das Beste, was das Leben Dir geben kann.</p>
<p class="calibre2">Dein Fritz.«</p>
<p class="calibre2">Die Mutter senkte wieder den Kopf.</p>
<p class="calibre2">Sie wußte selbst nicht, daß ihre Hände
allmählich den Blumennamen auf dem Tischtuch
zerstörten.</p>
<p class="calibre2">Da sah sie den Vater, der von der Hecke her auf sie zukam:</p>
<p class="calibre2">»Danke, mein Freund,« sagte sie und faßte seine
Hand.</p>
<p class="calibre2">Und einen Augenblick standen sie da vor den vielen Gaben –
beide schweigend.</p>
<p class="calibre2"><a id="page86" title="woldemar/MEsswein"></a> Dann
verschwand der Vater in der Richtung nach dem Wäldchen.</p>
<p class="calibre2"> </p>
<p class="calibre2">Um fünf Uhr nachmittags erschien die Bevölkerung des
Ortes. Tine war zu Hause gewesen, um die Küsterfrau zu holen,
die eine Sandtorte trug, eingewickelt in ein weißes
Kopftuch.</p>
<p class="calibre2">Wenn die Familie Jespersen die Küsterfamilie beim Hofe des
Dorfschulzen um die Ecke hatte biegen sehen, setzte sich Madam
Jespersen mit den beiden Töchtern auch in Bewegung.</p>
<p class="calibre2">Madam Jespersen trug über ihrer Festperücke einen
diademähnlichen Hut, an dem zwei unechte Straußfedern
prangten.</p>
<p class="calibre2">Fräulein Stine war in einem schwarzen Damastkleid, das den
Eindruck machte, als sei sie in diesem Aufputz konfirmiert.
Übrigens war es den Kleidern Fräulein Stines
eigentümlich, daß sie immer aussahen, als sei sie an den
Handgelenken und unten herausgewachsen.</p>
<p class="calibre2">Der Geburtstag der Frau war, außer den gesetzlichen Ferien
und Festzeiten, der einzige Tag, an dem Fräulein Stine sich
frei machte.</p>
<p class="calibre2">Ihr Geschenk war eine Flasche Eau de Cologne, die die Mutter
nachher in aller Stille in zwei kleine Flaschen verteilte und in
der Gesindestube verschenkte.</p>
<p class="calibre2">Fräulein Helene war in hell und munter wie eine Geiß.
Ihr Geschenk, das in rosa Seidenpapier gewickelt war, bestand aus
einer Kanevasstickerei, deren Einfassung auf den Tapezierer
wartete.</p>
<p class="calibre2">Fräulein Helenes Geschenke wurden regelmäßig im
folgenden Herbst an den Basar in Sonderburg für die Verlosung
abgeliefert.</p>
<p class="calibre2">Die Frau des Dorfschulzen war nach dem Tode des Sohnes zum
erstenmal ausgegangen. Sie war feierlich wie ein Gesangbuch. Sie
hatte morgens einen Topf Butter geschickt. <a id="page87" title="woldemar/MEsswein"></a> Mannsleute waren
überhaupt nicht da.</p>
<p class="calibre2">»Fritz,« sagte die Mutter, »an meinem Geburtstage
wenigstens will ich frei sein. Ein einziger Mann genügt, um
störend auf das Geklatsch zu wirken.«</p>
<p class="calibre2">Die Familie Jespersen nahm mitten im Gartenhause Platz, wo Frau
Jespersen, ohne zu fragen, im Handumdrehen die Geschenke untersucht
hatte.</p>
<p class="calibre2">Fräulein Stine drückte ihren Männermund so hart
auf die Wange der Mutter, daß es fast weh tat.</p>
<p class="calibre2">Und geniert, während sie etwas murmelte, das halb ein
Glückwunsch, halb eine Entschuldigung war, steckte sie die Eau
de Cologneflasche in Mutters Tasche.</p>
<p class="calibre2">»Ach Gott,« sagte sie und wußte wohl selber kaum,
was sie sagte, »was ist doch das Leben.«</p>
<p class="calibre2">Fräulein Helene war lauter jugendliche Unruhe. Jedes
Geschenk mußte sie graziös an sich selber probieren.</p>
<p class="calibre2">Die Küstersfrau, die neben Fräulein Stine saß,
erzählte, daß Madam Esbensen vorbeigefahren sei, nach
Ulkeböl zu.</p>
<p class="calibre2">Madam Esbensen war die Hebamme.</p>
<p class="calibre2">»Natürlich,« sagte die Küstersfrau,
»wollte sie zu Sörensens. Ich hab's ja gesehen, als sie
letzthin vorbei fuhr, wie sie den Wagensitz füllte. Es
mußte ganz nahe bevorstehen.«</p>
<p class="calibre2">Das Thema interessierte alle.</p>
<p class="calibre2">»Der liebe Gott behüte sie,« sagte die Mutter,
»es ist das neunte.«</p>
<p class="calibre2">Alle redeten, außer des Dorfschulzen Frau, die in ihrem
schwarzen Schal stramm und gerade dasaß und, ohne ein Wort zu
sprechen, drei Tassen Schokolade leerte.</p>
<p class="calibre2">Die Küstersfrau sagte plötzlich, lauter als die
anderen:</p>
<p class="calibre2">»Aber sonderbar ist es, Madam Jespersen, daß jedes
Kirchspiel gewissermaßen <em class="calibre5">seinen</em> Monat hat. Hier ist
es der Mai.«</p>
<p class="calibre2">Die Mutter, die sich krümmte wie ein Kätzchen, das in
die Wärme kommt, lachte und fragte:</p>
<p class="calibre2"><a id="page88" title="woldemar/MEsswein"></a>
»Aber liebste Madam Bölling, woher wissen Sie
das?«</p>
<p class="calibre2">»Das kann man doch aus den Kirchenbüchern sehen,«
sagte die Küstersfrau.</p>
<p class="calibre2">Und sie fügte hinzu:</p>
<p class="calibre2">»Aber die Todesfälle fallen am häufigsten in den
November.«</p>
<p class="calibre2">Fräulein Stine sagte, in ihrer Schule hätten sie die
meisten Geburtstage im Dezember.</p>
<p class="calibre2">Die Mutter begann über Ammen zu sprechen, während
Fräulein Helene sich ein Korallenhalsband umgebunden hatte und
vor dem Gartenhause mit Tyras spielte.</p>
<p class="calibre2">Durch viele kleine Schreie emanzipierte sie sich von der
Konversation.</p>
<p class="calibre2">Da sagte die Mutter:</p>
<p class="calibre2">»Jetzt spielen wir.«</p>
<p class="calibre2">Und sie sprang von ihrer Bank auf und wollte Helene fangen.</p>
<p class="calibre2">»Fangt mich,« rief sie.</p>
<p class="calibre2">Tine flog hinterher.</p>
<p class="calibre2">»Fangt mich!«.</p>
<p class="calibre2">Die Kinder kamen hinter der Hecke hervor und liefen mit.</p>
<p class="calibre2">»Fangt mich!«</p>
<p class="calibre2">Die Mutter war voran.</p>
<p class="calibre2">»Fangt mich!«</p>
<p class="calibre2">Sie flogen um den Teich herum.</p>
<p class="calibre2">Stines Eau de Cologneflasche schlug gegen Mutters Beine, bis sie
sie herausholte und auf den Rasen am Teiche setzte.</p>
<p class="calibre2">»Stine, Sie müssen mitspielen!« rief die
Mutter.</p>
<p class="calibre2">Stine kam aus dem Gartenhaus heraus und setzte in großen
Sprüngen hinter Tine her.</p>
<p class="calibre2">Die Mutter mußte sich vor Lachen an einen Baum lehnen.</p>
<p class="calibre2">Jungfer Stine sah, wenn sie lief, leibhaftig aus wie des
Hühnerhändlers lendenlahme Mähre.</p>
<p class="calibre2"><a id="page89" title="woldemar/MEsswein"></a> Mit
einem Male warf die Mutter sich auf den Rasen nieder und alle
andern legten sich um sie her.</p>
<p class="calibre2">»Jetzt wollen wir die Stichlinge füttern,« sagte
die Mutter. Und alle warfen Krumen in den Teich hinein, wo die
Stichlinge munter im Sonnenschein schwammen.</p>
<p class="calibre2">Die drei Alten saßen im Gartenhause.</p>
<p class="calibre2">Madam Jespersen hatte im geheimen die Geschenke betastet.</p>
<p class="calibre2">Tine bot Wein an, und die Gläser standen im Grase am
Teich.</p>
<p class="calibre2">»Schenken Sie Stine ein,« sagte die Mutter. Jungfer
Stine wurde immer so schwermütig, wenn sie ein paar
Gläser getrunken hatte.</p>
<p class="calibre2">»Auch den Kindern,« sagte die Mutter.</p>
<p class="calibre2">Die Kinder bekamen Kirschwein, daß sie ganz schwindelig
wurden.</p>
<p class="calibre2">Jungfer Stine aber hatte ihr Kinn in die Hände
gestützt, und während die Mutter lachte und die Kinder
umhertobten – der älteste Junge trank alle Reste aus den
Gläsern –, deklamierte sie still in die Luft hinaus ein
Gedicht aus einem alten deutschen Kalender.</p>
<p class="calibre2">»Weiter, weiter,« bat die Mutter.</p>
<p class="calibre2">Und Jungfer Stine deklamierte weiter mit ihrer Männerstimme
– es klang, als lese sie die Messe.</p>
<p class="calibre2">Die Frau des Dorfschulzen hatte sich erhoben. Schweigend
streckte sie die Hand aus zum Abschied, und die Mutter begleitete
sie bis an die Hecke.</p>
<p class="calibre2">Die andern folgten ihr bald, und die Mutter sagte zu Tine:</p>
<p class="calibre2">»Räumen Sie das weg, Tine.«</p>
<p class="calibre2">Sie wies auf die Gläser und Teller, und schweigend setzte
sie sich in die hinterste Ecke des Gartenhauses.</p>
<p class="calibre2">»Das alles auch,« sagte sie.</p>
<p class="calibre2">Sie meinte die Geschenke, und ihre Stimme klang, als ob das
bloße Anschauen der Sachen ihren Augen weh täte. <a id="page90" title="woldemar/MEsswein"></a> Tine ging umher
und nahm alles fort.</p>
<p class="calibre2">Die Stimmen der Kinder schallten laut draußen im Hofe
...</p>
<p class="calibre2">Als Tine zurückkam, saß die Mutter und las in einem
alten Buch.</p>
<p class="calibre2">Tine setzte sich still zu ihr.</p>
<p class="calibre2">»Was lesen Sie?« fragte sie.</p>
<p class="calibre2">»Ein Gedicht,« sagte die Mutter.</p>
<p class="calibre2">»Was für eins?«</p>
<p class="calibre2">Die Mutter wendete das Blatt im Buche um und, als lese sie es
für sich selber, wiederholte sie das Gedicht:</p>
<p class="calibre2">Ich träumte einen schönen Traum:<br class="calibre3"/>
in der Wüste war ich.<br class="calibre3"/>
Dort war nur Sand und Sand,<br class="calibre3"/>
und nichts als Sand.<br class="calibre3"/>
Doch plötzlich erblickte<br class="calibre3"/>
mein erschrockenes Auge<br class="calibre3"/>
ein furchtbares Gesicht:<br class="calibre3"/>
die Raubtiere der Wüste schritten<br class="calibre3"/>
in endlosem Zuge daher.<br class="calibre3"/>
Zuvorderst gingen die Löwen<br class="calibre3"/>
mit weißen Zähnen;<br class="calibre3"/>
Tiger und Panther kamen<br class="calibre3"/>
mit ihrem fleckigen Fell.<br class="calibre3"/>
Doch hinterdrein schritten Hyänen,<br class="calibre3"/>
deren kranke Gier nach Aas steht.</p>
<p class="calibre2">Es waren die Triebe des Menschen,<br class="calibre3"/>
welche die Wüste absuchten.<br class="calibre3"/>
Doch das Traumbild wechselte.<br class="calibre3"/>
Und ich stand einsam<br class="calibre3"/>
auf einem mächtigen Felde.<br class="calibre3"/>
Das Feld aber war die Erde.<br class="calibre3"/>
Und über der ganzen Erde<br class="calibre3"/>
lagerte nächtliches Dunkel. –<br class="calibre3"/>
Aus dem Dunkel hervor<br class="calibre3"/>
ragte ein Kreuz, so groß,<br class="calibre3"/>
als wolle sein gewaltiger Arm<br class="calibre3"/>
Himmel und Erde umschlingen.<br class="calibre3"/>
Tiefe Stille ringsum.<br class="calibre3"/>
<a id="page91" title="woldemar/MEsswein"></a> Nur
dann und wann<br class="calibre3"/>
vom Kreuze ein Tropfen fiel.<br class="calibre3"/>
Und wieder wurde es still,<br class="calibre3"/>
bis der nächste Tropfen rann.<br class="calibre3"/>
Und abermals alles schwieg,<br class="calibre3"/>
bis der nächste Blutstropfen fiel.<br class="calibre3"/>
Dein Blut war es,<br class="calibre3"/>
Gekreuzigte Menschheit.</p>
<p class="calibre2">Die Mutter schloß das Buch.</p>
<p class="calibre2">Den Kopf an die Wand ihres Gartenhauses gelehnt, starrte sie,
bleich und stumm, in die Schönheit des Sommerabends.</p>
<p class="calibre2">»Tine,« sagte sie plötzlich.</p>
<p class="calibre2">Und Tine fuhr zusammen, denn die Mutter hatte ihren Namen
gerufen fast wie einer, der um Hilfe fleht.</p>
<p class="calibre2">Aber die Mutter saß noch in derselben Stellung da, und sie
flüsterte nur einige Worte, die Tine nicht verstand.</p>
<p class="calibre2">»Außerhalb Veronas gibt's keine Welt,«
flüsterte sie.</p>
<p class="calibre2">Und sie schwieg wieder.</p>
<p class="calibre2">Nach einer Weile sagte sie:</p>
<p class="calibre2">»Tine, wissen Sie, was die Wahrheit ist – wenn man in
meine Seele hineinsehen könnte, wie man durch eine Glasscheibe
in ein Haus sieht, so würde man zwischen all dem
Hausgerät da drinnen nicht einen Wunsch finden, keine einzige
Hoffnung, nicht einmal den Schatten von einem Traum.«</p>
<p class="calibre2">»Dann wäre es besser zu sterben.«</p>
<p class="calibre2">»– Sterben, Tine, ist auch nicht das Schwerste
– – – jeden Tag versuchen zu leben, das ist viel
schwerer ...«</p>
<p class="calibre2">Stumm blieb sie sitzen, die Hände um die Knie, und
flüsternd wie vorhin bewegte sie die Lippen zu Versen, die
Tine nicht kannte.</p>
<p class="calibre2">In seiner stillen Kammer,<br class="calibre3"/>
In ferner stillen Kammer<br class="calibre3"/>
Liegt mein Herz,<br class="calibre3"/>
Liegt meines Herzens Leiche.<br class="calibre3"/>
<a id="page92" title="woldemar/MEsswein"></a><br class="calibre3"/>
Und niemand weint<br class="calibre3"/>
Über dem toten Herzen:<br class="calibre3"/>
Denn es wurde nur<br class="calibre3"/>
Von Einem geliebt.</p>
<p class="calibre2">Wer selber stirbt<br class="calibre3"/>
An seines Herzens Todestag,<br class="calibre3"/>
Der kann nicht weinen<br class="calibre3"/>
An seines Herzens Leiche.</p>
<p class="calibre2">In seiner stillen Kammer,<br class="calibre3"/>
In seiner stillen Kammer<br class="calibre3"/>
Liegt mein Herz,<br class="calibre3"/>
Liegt meines Herzens Leiche.</p>
<p class="calibre2"> </p>
<p class="calibre2">Es wurde abends nicht mehr gesungen, und den Kindern wurde nie
erlaubt, ehe sie zu Bett gingen, in ihren Nachtkleidern in der
Wohnstube herumzutanzen.</p>
<p class="calibre2">Die Tanten waren angekommen.</p>
<p class="calibre2">Sie benutzten den Ort als Aufenthalt zur Nachkur, wenn sie von
der Badereise kamen.</p>
<p class="calibre2">Sie sprachen mit gedämpfter Stimme, waren schlank wie ein
Licht und trugen stets Halbhandschuhe.</p>
<p class="calibre2">Sie waren sehr ängstlich in bezug auf die Wege und
führten stets einen Regenschirm mit, aus Rücksicht auf
die Möglichkeit eines Regens.</p>
<p class="calibre2">»Liebste,« sagten sie zur Mutter, »ein nasser
Strumpf am Fuß, auch nur eine halbe Stunde lang, und man hat
seine Bronchitis, die wochenlang dauert.«</p>
<p class="calibre2">Die Mutter, die während des Nachkurbesuchs weiß vor
Angst war, sagte ja zu allem und trug Baregekleider. Eigentlich
denken tat sie den ganzen Tag lang nur an eins, ob die Kinder wohl
wieder Unordnung in das Regiment von Tanten-Galoschen gebracht
hätten.</p>
<p class="calibre2">Tine sah sie morgens.</p>
<p class="calibre2">Es war wie eine Art stillschweigender Verabredung, daß Tine
während der Tantenkur aus dem Hause verschwand. Die Mutter und
sie trafen sich in der Zeit fast <a id="page93" title="woldemar/MEsswein"></a> wie ein paar Schmuggler.
Morgens aber mußte sie da sein, um die Mutter aus dem Bett zu
holen.</p>
<p class="calibre2">Die Kur der beiden Tanten forderte, daß sie ihr Lager um
sieben Uhr verließen, und sie waren präzis wie eine
Domuhr.</p>
<p class="calibre2">»Nun müssen Sie aufstehen,« sagte Tine.</p>
<p class="calibre2">»Ja, Liebste, wie spät ist es?«</p>
<p class="calibre2">Die Mutter liebte ihr Bett, und den Freiheitszustand, im
Nachthemd zu sein.</p>
<p class="calibre2">»Aber jetzt müssen Sie aufstehen.«</p>
<p class="calibre2">»Ja – –.«</p>
<p class="calibre2">Endlich war sie aus dem Bett heraus.</p>
<p class="calibre2">Wenn sie zu den Tanten hinunter kam, hatte sie eine große,
weiße Schürze vorgebunden und sah aus, als hätte sie
von fünf an, wenn die Buttermaschine in Gang gesetzt wurde, im
Hause gewirtschaftet.</p>
<p class="calibre2">Die beiden Tanten saßen, mit sehr steifen Rücken, jede
an ihrer Seite des Tisches in der Gartenstube und warteten auf
ihren Tee. Sie machten, wenn sie ihren kurgemäßen
Morgenspaziergang antreten wollten, völlig den Eindruck von
Reisebereitschaft. Kleider und Röcke waren mittels eines
Systems von Haken in die Höhe gerafft, und auf den Köpfen
trugen sie Hüte, groß wie Körbe, in denen man
Totenkränze verschickt.</p>
<p class="calibre2">Diese Ungeheuer waren mit Spitzen garniert, die ihnen über
die Augen hingen. »Ja, lieber Gott,« sagten sie mit Bezug
auf die Spitzen, »das erste, was man beschützen muß,
sind doch die Augen.«</p>
<p class="calibre2">Die Mutter sagte: »Sie sehen aus, als wollten sie nach
Jerusalem pilgern.«</p>
<p class="calibre2">Sie gingen nicht in den richtigen Garten aus Angst vor den
Fröschen, die sie verabscheuten.</p>
<p class="calibre2">»Es wimmelt davon, und sie hüpfen an einem empor .. es
ist fast noch schlimmer als voriges Jahr.« Außerdem war
der Weg durch den Küchengarten sechsmal hin und <a id="page94" title="woldemar/MEsswein"></a> sechsmal
zurück gerade die richtige Entfernung. Beim Gehen sprachen sie
nicht.</p>
<p class="calibre2">»Der Arzt in Genf hat recht,« sagte Tante Bothilde,
»man soll es nicht tun. Man soll gehen und seinen Nerven Ruhe
gönnen.«</p>
<p class="calibre2">Bei jeder zweiten Schwenkung genossen sie ein
Schokoladeplätzchen.</p>
<p class="calibre2">»Das ist das Vortreffliche an der Schweizer
Schokolade,« sagten sie, »sie stärkt, ohne einem den
Appetit zu benehmen. Die hiesige Schokolade, Liebste, das ist ja,
als wenn man lauter Klumpen in den Mund bekommt.«</p>
<p class="calibre2">»Aber, das versteht sich, selbst in der Schweiz muß
man die Marken genau kennen.«</p>
<p class="calibre2">Wenn die Tanten zurückkamen, ruhten sie. Das heißt,
sie schliefen zwei Stunden, in wollene Decken eingewickelt.</p>
<p class="calibre2">»Liebes Kind,« sagte Tante Bothilde, »Wolle ist
das einzige. Die Franzosen, ein Volk; das sich rüstig erhalten
will, benutzen immer wollene Matratzen.«</p>
<p class="calibre2">»Über ihrer Sprungfedermatratze,« fügte sie
nach Verlauf einer Sekunde hinzu.</p>
<p class="calibre2">»Liebe,« sagte Tante Anna, »Franzosen sind eben
Franzosen.«</p>
<p class="calibre2">Die Angst der Mutter wuchs noch im Lauf des Tages. Die
Mahlzeiten waren ihre Schreckensstunden. Man konnte ja nicht
behaupten, daß die Kinder korrekt bei Tisch saßen.</p>
<p class="calibre2">Und das »Zutischsitzen« war die Spezialität der
Tanten.</p>
<p class="calibre2">»Man muß doch zugeben,« sagte Tante Bothilde,
»daß es von Wichtigkeit ist. Und lernt man es nicht in
der Kindheit, so lernt man es nie ...«</p>
<p class="calibre2">»Ich kann dir die Versicherung geben: wenn dieser
Stockfeldt es niemals zum Staatsminister brachte, so war es, weil
er mit dem Messer aß.«</p>
<p class="calibre2">Eine Stunde vor Mittag begann die große Abseifung der
Kinder.</p>
<p class="calibre2">Die Mutter stand daneben, während das Kindermädchen
<a id="page95" title="woldemar/MEsswein"></a> die
Körper der Kinder mit Schwämmen bearbeitete, als hobelte
sie rauhe Bretter ab.</p>
<p class="calibre2">»Anna Margrete,« sagte die Mutter, »passen Sie ja
auf die Nägel.«</p>
<p class="calibre2">Anna Margrete bürstete die Nägel, als wolle sie den
Kindern die Fingerspitzen abbürsten. »Sie sind noch nicht
rein,« sagte die Mutter, »der Himmel mag wissen, wo ihr
wieder herumgewühlt habt.«</p>
<p class="calibre2">»Und die Ohren,« sagte die Mutter.</p>
<p class="calibre2">»Lassen Sie mich!«</p>
<p class="calibre2">Sie machte sich selber über die Ohren her.</p>
<p class="calibre2">»Und hat man sie dann endlich rein,« sagte sie
verzweifelt, »dann werden sie rot.«</p>
<p class="calibre2">Rot wurden sie.</p>
<p class="calibre2">Nun kam das Anziehen, auf allen Kleidern waren Flecke.</p>
<p class="calibre2">Die Mutter rieb und rieb mit Handschuhleder und Eau de
Cologne.</p>
<p class="calibre2">»So, in Gottes Namen, nun muß es gehen,« sagte
die Mutter.</p>
<p class="calibre2">Der Vater führte die Tanten zu Tisch. Sie waren in schwarz-
und weißgestreifter Seide – ihren Table d'hote-Kleidern
vom Bade – und trugen viele Ringe, die an den sehr
abgemagerten Fingern gleichsam klapperten. Sie brachten zwei
Pulverschachteln mit, die sie neben ihren Teller stellten.</p>
<p class="calibre2">Die Augen der Kinder waren starr vor Angst. Sie beklecksten sich
sofort.</p>
<p class="calibre2">Die Mutter führte eine lebhafte Konversation, um die
Aufmerksamkeit abzulenken – sie bekam vor Aufregung hektische
Flecke auf ihren Wangen – sie sprachen von Kopenhagen und
allen Bekannten dort:</p>
<p class="calibre2">»Ja, sieh mal,« sagte Tante Bothilde, »Jane ist
ja furchtbar nett, aber sie hat ihre Eigenheiten. Man kann ja
wirklich kaum den Fuß unter ihren Tisch setzen, so fängt
sie schon von den Konfessionen an. Kleiner,« wendete sie sich
<a id="page96" title="woldemar/MEsswein"></a>
plötzlich an den ältesten Jungen, »ein artiges Kind
schiebt die Brust heraus und die Schultern in die Höhe, wenn
es ißt. Dann sitzt man gerade ... – Und ich finde
nun,« fuhr sie ohne Übergang fort, indem sie zu Jane und
den Konfessionen zurückkehrte, »solche Sachen darf man
nicht beim Essen diskutieren.«</p>
<p class="calibre2">»Man kann am ersten Weihnachtstag beim Bischof essen, und
die Religion und derartiges wird mit keiner Silbe erwähnt. Das
paßt doch wahrlich nicht zu geschliffenen Gläsern und
Porzellan.«</p>
<p class="calibre2">Tante Anna ging dazu über, von Kristall und Porzellan
überhaupt zu reden.</p>
<p class="calibre2">Sie sprach von einer Glashütte in Südfrankreich.</p>
<p class="calibre2">»Wo man,« sagte sie zum Vater, »wirklich
wunderbare Sachen bekommt ... Aber, Lieber, jetzt fällt mir
ein, weshalb sieht man dies Jahr nie deine schönen,
geschliffenen Karaffen, die zum Madeira.«</p>
<p class="calibre2">Das Blut schoß der Mutter ins Gesicht – bei den
Tanten ging nie etwas kaputt.</p>
<p class="calibre2">»Ja, Margrete hat – du entsinnst dich – sie hat
– hat unglücklicherweise die eine zerschlagen
..«</p>
<p class="calibre2">»Richtig, wo ist Margrete? Das nette Mädchen, ich
besinne mich so gut auf sie, diese nette, muntere kleine
Person,« sagte Tante Bothilde.</p>
<p class="calibre2">»Sie machte leider Dummheiten, und da mußte sie aus
dem Hause ...«</p>
<p class="calibre2">»Sie auch,« sagte Tante Anna.</p>
<p class="calibre2">Tante Bothilde aber fiel mit einem schnellen Blick auf die
Kinder dazwischen:</p>
<p class="calibre2">»So!«</p>
<p class="calibre2">Dieses einzige »So« klang, als würde eine eiserne
Pforte zugeschlagen.</p>
<p class="calibre2">Und es wurde nicht mehr von den Karaffen geredet.</p>
<p class="calibre2">»Kleine Stella,« hörte man nach einer Pause,
»ein kleines Mädchen schlägt bei Tisch die
Füße nicht übereinander.«</p>
<p class="calibre2"><a id="page97" title="woldemar/MEsswein"></a> Die
Schwester zuckte so heftig zusammen, daß sie die Gabel fallen
ließ.</p>
<p class="calibre2">»So, nun hast du dir einen Fleck auf das Kleid
gemacht,« sagte die Tante, und halb entschuldigend sagte sie,
zur Mutter gewendet: »Liebste, du weißt, solche Dinge
kommen nur vom beständigen Verbieten.«</p>
<p class="calibre2">Und bei ihrem Lieblingsthema angelangt, schloß sie damit,
daß sie sagte:</p>
<p class="calibre2">»Man lehrt die Kinder nur dadurch anständig bei Tisch
sitzen, daß man sie während des Essens die Ellbogen dicht
an den Körper halten läßt.«</p>
<p class="calibre2">Die Mahlzeit war zu Ende, und der Kaffee sollte in der
Gartenstube eingenommen werden.</p>
<p class="calibre2">Die Kinder waren aus der Eßstube mit einer Hast
hinausgestürzt, daß sie draußen im Gange
übereinanderfielen.</p>
<p class="calibre2">»Aber,« sagte Tante Anna, sie hatte kaum Platz
genommen, »das kann ich nicht vergessen, Margrete, dies
hübsche, muntre kleine Mädchen ...«</p>
<p class="calibre2">»Mit den Hübschen ist es immer am schlimmsten,«
warf die Mutter ein, die den Kaffee filtrierte.</p>
<p class="calibre2">»Aber,« bemerkte Tante Bothilde, »es passiert ja
buchstäblich jedes Jahr in eurem Kirchspiel.«</p>
<p class="calibre2">Die Mutter lächelte hinter der Maschine:</p>
<p class="calibre2">»Ja,« sagte sie, »mehrmals.«</p>
<p class="calibre2">Tante Bothilde war einige Minuten still.</p>
<p class="calibre2">Darauf sagte sie:</p>
<p class="calibre2">»Wir und unseresgleichen begreifen das ja nicht. Aber, Gott
sei Dank, es geht uns ja nichts an.«</p>
<p class="calibre2">Tante Anna bemerkte:</p>
<p class="calibre2">»Ja, du, es passiert gewiß viel im Leben ... das Beste
ist, zu tun, als sähe man es nicht ... die Sache ist ja nicht
so einfach. Aber die Leute haben ja auch keine Erziehung.«</p>
<p class="calibre2">Die Mutter lächelte noch immer.</p>
<p class="calibre2">»Ob das hilft?« sagte sie.</p>
<p class="calibre2">Und ohne an die Tanten zu denken fügte sie hastig hinzu:
<a id="page98" title="woldemar/MEsswein"></a>
»Das Unglück ist wohl, daß die Natur so grausam
gewesen ist, Tiere zu schaffen, die denken. Erst paart das Tier
sich und nachher ekelt sich der Mensch.«</p>
<p class="calibre2">Tante Bothilde saß wie versteinert, sie konnte kaum zu
Worte kommen:</p>
<p class="calibre2">»Hör mal, du sagst mitunter Dinge ... du sagst Dinge,
... wir sind doch wohl alle Gottes Geschöpfe.«</p>
<p class="calibre2">Wenn die Tanten mit dem Kaffee fertig waren, schlummerten
sie.</p>
<p class="calibre2">Tante Anna legte in aller Stille das Taschentuch über ihr
Gesicht.</p>
<p class="calibre2">Wenn sie geruht hatten, wurde gelesen. Die Schwestern wechselten
ab. Um in der Übung zu bleiben, lasen sie die belletristischen
Sachen der drei Weltsprachen.</p>
<p class="calibre2">Tante Bothildes Lieblingsdichter war Dickens.</p>
<p class="calibre2">»Ja, man erfährt von dem Mann doch wirklich viel
über die Menschen. Mit Goethe ist es ja ganz schön. Aber
er wirkt mit samt seinem Weimar auf mich, als wäre er von
Stein.«</p>
<p class="calibre2">Tante Anna zog die weiblichen Schriftsteller vor, und
darüber entstand ein lebhafter Zank.</p>
<p class="calibre2">»Die Sprache mag ja,« bemerkte Tante Thilde,
»sehr hübsch sein, aber der Inhalt ... es ist ja fast
immer nur von der Liebe die Rede. –</p>
<p class="calibre2">Und über das Stadium kommt man ja doch, Gott sei Dank,
hinaus. Außerdem kann man im Leben genug davon
haben.«</p>
<p class="calibre2">Vor dem Tee gingen die Tanten wieder spazieren. Diesmal in der
Allee.</p>
<p class="calibre2">Nach dem Tee saßen sie eine halbe Stunde auf der
Gartentreppe und tranken Luft.</p>
<p class="calibre2">»Man spricht immer vom Wasser,« sagten sie. »Das
Wichtigste ist die Luft. Wenn die Menschen klug wären und bei
offenem Fenster schliefen, würden sie hundert Jahre
alt.«</p>
<p class="calibre2"><a id="page99" title="woldemar/MEsswein"></a> Nach
Verlauf von sechs Wochen war die Nachkur beendigt. Sie reisten auf
den Tag ab.</p>
<p class="calibre2">Das Letzte, was sie unternahmen, war die Verteilung von in
Papier gewickelten Trinkgeldern.</p>
<p class="calibre2"> </p>
<p class="calibre2">Wenn die Tanten fort waren, kam eine andere Zeit. Die
Freundinnen der Mutter statteten einen Besuch ab. Es waren die
Töchter von dem Gute, wo sie erzogen war. Sie wirkten wie
bunte Vögel, die weit her kamen.</p>
<p class="calibre2">Acht Tage lang leuchteten ihre Sonnenschirme auf den
Gartenpfaden.</p>
<p class="calibre2">Die Fenster standen offen, so daß Haus und Garten
ineinander übergingen, es summte von fremden Namen, und der
Briefträger brachte Briefe, deren Aufschrift niemand in der
Küche herausbuchstabieren konnte.</p>
<p class="calibre2">Es war die heiterste Zeit im ganzen Jahr. Die Freundinnen trugen
Krinolinen, die in den Augen der Kinder aussahen wie die
großen umgekehrten Kronleuchter drüben in Kopenhagen, in
der Amalienstraße, und Mantillen mit langen Zipfeln. Fuhren
sie aber aus, so hatten sie Straußfedern auf den Köpfen,
ganz wie Zampa, das kleine Pferd, das sie in Augustenburg gesehen
hatten und das am Tisch sitzen und mit einer kleinen Glocke nach
seinem Essen schellen konnte. Alle plauderten sie durcheinander
– Mamas Freundinnen. Aber am meisten redete Lady Lipton.</p>
<p class="calibre2">Sie wohnte weit weg, in einem fremden Lande, und sie kannte
viele von den reichsten und vornehmsten Leuten. Der Vater
führte sie mittags immer zu Tisch.</p>
<p class="calibre2">Wenn sie aber gegessen hatten, tranken sie Kaffee in der
Gartenstube, und dann erzählte Lady Lipton. Sie erzählte
von der Rachel, die sie liebte, und vom Kaiserhofe in den Tuilerien
und von vielen fernen und sonderbaren Menschen, die sie kannte
– während die Mutter lauschte.</p>
<p class="calibre2">»Erzähle weiter,« bat die Mutter, und die Lady
erzählte <a id="page100" title="woldemar/MEsswein"></a> weiter; von den Dichtern des großen Landes,
unter denen sie lebte, von seinen Malern, deren Gemälde sie
besaß, und am liebsten von einem wunderlichen und seltsamen
jungen Dichter aus einem exotischen Lande, den sie in einer
großen Stadt, wo allerlei Existenzen sich zusammenfinden,
getroffen hatte, und dessen Bild sie auf ihrem Tisch oben im
Fremdenzimmer stehen hatte. Die Mutter hörte auch am liebsten
von ihm.</p>
<p class="calibre2">» <i class="calibre5">Ma chère</i>,« sagte die Lady, »ich
glaube, das Leben ist ihm entglitten. Er hat die Kunst vergessen,
da zu sein. Er kann seinen hohen Hut nicht mehr glatt streichen,
und er mag seine Handschuhe nicht mehr zuknöpfen, um einen
Besuch zu machen; er vermag es nicht mehr, alle die mechanischen
Dinge zu tun, aus denen das Leben besteht: wie zum Beispiel zu
seinem Barbier zu gehen, oder seinen Kaffee in einem Kaffeehause zu
trinken, oder sich mit einer liebenswürdigen Dame zu Tisch zu
setzen und einen gepuderten Hals zu betrachten ...«</p>
<p class="calibre2">»Das verstehe ich,« warf die Mutter ein.</p>
<p class="calibre2">»Er empfindet gewiß keine Trauer,« sagte die
Lady, »und er ist nicht desillusioniert, denn was die
Illusionen betrifft, so sind sie ganz sicher bereits von seinen
Vorfahren aufgezehrt.«</p>
<p class="calibre2">Sie schwieg eine Weile, dann sagte sie:</p>
<p class="calibre2">»Man könnte noch am ersten sagen, daß er zu den
<i class="calibre5">désintéressés</i> gehört. Die Lebensdinge
sind ihm gleichsam zu lauter Gleichgültigkeiten verwelkt, zu
Lächerlichkeiten oder Ähnlichem, über das er sich
höchstens wundern kann.«</p>
<p class="calibre2">Die Lady lachte plötzlich.</p>
<p class="calibre2">»Nie werde ich vergessen,« sagte sie, »wie er
eines Tages zu mir kam und plötzlich ›Le Figaro‹,
der auf meinem Tisch lag, auseinanderfaltete, und, indem er mit
seiner schlanken Hand über die jämmerliche Zeitung
hinwies, mit unbeschreiblichem, müdem Abscheu – nein
Abscheu nicht, mit mattem Erstaunen mir sagte:</p>
<p class="calibre2"><a id="page101" title="woldemar/MEsswein"></a>
»Alles das handelt vom Krieg mit China.«</p>
<p class="calibre2">Die Lady schwieg einen Augenblick, dann sagte sie:</p>
<p class="calibre2">»Das ist wohl die Sache, für ihn ist alles zum Krieg
mit China geworden.«</p>
<p class="calibre2">Die Mutter reichte die Tassen herum.</p>
<p class="calibre2">Dann sagte sie still:</p>
<p class="calibre2">»Vielleicht liebt er – oder hat geliebt.«</p>
<p class="calibre2">Die Lady antwortete:</p>
<p class="calibre2">»Das glaube ich nicht, <i class="calibre5">ma chère</i>. – Es
gibt in allen großen Ländern merkwürdige Menschen,
denen – ja, wie soll ich es sagen – die rein physische
Seite der Liebe unüberwindlichen Abscheu einflößt.
Sie werden Asketen aus Raffinement, und sie begehren
beständig, während sie die Befriedigung verdammen
–</p>
<p class="calibre2">René gehört zu ihnen.</p>
<p class="calibre2">Es treibt ihn zu den Frauen, und hält er sie nur im Arm,
überhäuft er sie mit Schimpfworten.«</p>
<p class="calibre2">»Dann liebt er nicht,« sagte die Mutter.</p>
<p class="calibre2">Die Lady schwieg. Darauf sagte sie:</p>
<p class="calibre2">»Ist Liebe etwas anderes, als Begierde fühlen und sich
dessen schämen?«</p>
<p class="calibre2">»Weißt du keines seiner Gedichte?« fragte die
Mutter.</p>
<p class="calibre2">»Ein einziges,« antwortete die Lady.</p>
<p class="calibre2">»Sag es uns,« bat die Mutter.</p>
<p class="calibre2">Die Lady lehnte sich in ihrem Stuhl zurück, und in ihrer
etwas fremdartigen Sprache, die den Worten einen seltsamen Klang
verlieh, sagte sie langsam:</p>
<p class="calibre2">Ich liebe dich, so wie das Meer den Strand,<br class="calibre3"/>
den weiten Strand, den es bespült,<br class="calibre3"/>
verdeckend ihn, bedeckend ihn vollständig<br class="calibre3"/>
mit ewgem Kuß.<br class="calibre3"/>
So wie der Liebende,<br class="calibre3"/>
wenn er von ihrer Füße Sohlen<br class="calibre3"/>
bis zu dem schönen Bogen ihrer Schläfen<br class="calibre3"/>
die Lippen führet,<br class="calibre3"/>
<a id="page102" title="woldemar/MEsswein"></a> den
ganzen Körper der geliebten Frau entlang,<br class="calibre3"/>
um, selig, alles zu besitzen ...<br class="calibre3"/>
So liebe ich dich –<br class="calibre3"/>
So.</p>
<p class="calibre2">Nein, ich liebe dich, so wie die Sonne liebt<br class="calibre3"/>
die goldenen Abendwolken,<br class="calibre3"/>
die ganz sie fassen und umfassen,<br class="calibre3"/>
wenn stolz, zum letztenmal, sie grüßet<br class="calibre3"/>
der Erde jammervolle Herrlichkeit und stirbt.</p>
<p class="calibre2">»Du kannst noch ein anderes,« sagte die Schwester der
Lady.</p>
<p class="calibre2">»Ja,« antwortete die Lady, »ich kann noch
eins.« Und in derselben Stellung, ohne sich zu regen, sprach
sie, und ihre Altstimme färbte sich weicher:</p>
<p class="calibre2">Wenn in den langen Nächten<br class="calibre3"/>
ich einsam ruhe<br class="calibre3"/>
und niemand schaut mein Antlitz<br class="calibre3"/>
und niemand meine trocknen Augen –<br class="calibre3"/>
dann denke ich:<br class="calibre3"/>
Wenn tot ich wäre,<br class="calibre3"/>
würdest du doch kommen<br class="calibre3"/>
und niederknien,<br class="calibre3"/>
dort, wo ich ruhte.<br class="calibre3"/>
Und meine Hand, die jetzt du meidest,<br class="calibre3"/>
würdest du fassen,<br class="calibre3"/>
meine kalte Hand,<br class="calibre3"/>
und in mein Ohr,<br class="calibre3"/>
das dich nicht hörte mehr,<br class="calibre3"/>
würdest du flüstern<br class="calibre3"/>
mit deiner Stimme Klang von damals:<br class="calibre3"/>
Wie ich dich liebte. – –<br class="calibre3"/>
Und der Tote würde lächeln.</p>
<p class="calibre2">Die Mutter hatte sich gesetzt und starrte mit großen Augen
vor sich hin, während sie die Hände um die Knie gefaltet
hielt. Dann flüsterte sie:</p>
<p class="calibre2">»Sage es noch mal, bis ich es kann.«</p>
<p class="calibre2">Die Lady lachte:</p>
<p class="calibre2">»Du kannst es ja schon,« sagte sie.</p>
<p class="calibre2"><a id="page103" title="woldemar/MEsswein"></a>
»Ja, das letzte.«</p>
<p class="calibre2">Und sehr sanft, fast unhörbar, wiederholte sie die fremden
Worte, während ihre weißen Hände noch immer um ihre
Knie gefaltet waren:</p>
<p class="calibre2">Ich liebe dich, so wie die Sonne liebt<br class="calibre3"/>
die goldnen Abendwolken,<br class="calibre3"/>
die ganz sie fassen und umfassen,<br class="calibre3"/>
wenn stolz, zum letztenmal, sie grüßet<br class="calibre3"/>
der Erde jammervolle Herrlichkeit und stirbt.</p>
<p class="calibre2">Alle schwiegen.</p>
<p class="calibre2">Dann sagte Lady Lipton:</p>
<p class="calibre2">»Aber auf sein Bild oben hat er den Vers geschrieben, den
ich am meisten liebe.«</p>
<p class="calibre2">»Den weiß ich,« sagte die Mutter.</p>
<p class="calibre2">Und mit einer Stimme, fast als summe sie ein Wiegenlied, sprach
sie den kleinen Vers vom Bilde – vom Bild des fremden und
unbekannten Dichters:</p>
<p class="calibre2">Wie die Pflanze welket,<br class="calibre3"/>
weil ihre Wurzel ohne Nahrung ist,<br class="calibre3"/>
wie die Blume verblaßt,<br class="calibre3"/>
weil die Sonne sie nicht erreicht,</p>
<p class="calibre2">so verwelke ich, und so verblasse ich, denn du hast mich nicht
lieb. – –</p>
<p class="calibre2">Sie schwiegen wieder, bis plötzlich eine von den Schwestern
der Lady zu lachen anfing und sagte:</p>
<p class="calibre2">»Kinderchen, es wäre nicht so übel, von dem
jungen Manne geliebt zu werden.«</p>
<p class="calibre2">Und sie lachten alle laut auf, die Mutter am lautesten, und
liefen alle in den Garten hinaus und warfen sich ins Gras, daß
die Krinolinen hoch in die Höhe stiegen.</p>
<p class="calibre2">Abends war es am allerlustigsten.</p>
<p class="calibre2">Die Freundinnen hatten Feuerwerk mitgebracht; und sie brachten
bengalische Flammen, blaue und grüne, in allen Büschen an
und waren nahe daran, den ganzen Garten in Brand zu stecken.</p>
<p class="calibre2"><a id="page104" title="woldemar/MEsswein"></a>
Die Mutter zündete sie mit den Streichhölzern an und
klatschte in die Hände.</p>
<p class="calibre2">Die Kinder sahen vom Kinderzimmer aus in ihren Nachtkleidern
zu.</p>
<p class="calibre2">»Wie schön ist das, wie schön ist das,« rief
die Mutter.</p>
<p class="calibre2">Von allen Büschen flammte es auf, blau und rot, sie selbst
stand mitten auf dem Rasenplatz. Ihr bleiches Gesicht war
aufwärts gerichtet, und die Hände hatte sie
emporgereckt.</p>
<p class="calibre2">Dann sagte sie plötzlich:</p>
<p class="calibre2">»Aber die Sterne sind doch schöner.«</p>
<p class="calibre2">Und während die künstlichen Lichter langsam erloschen,
eins nach dem andern, und das Boskett im Finstern lag, schauten sie
alle empor zu den Sternen der Augustnacht.</p>
<p class="calibre2">»Zeige uns jetzt deine Sterne,« sagte Lady Lipton.</p>
<p class="calibre2">Die Mutter schüttelte den Kopf:</p>
<p class="calibre2">»Nein,« sagte sie, »jetzt wollen wir still
sein.«</p>
<p class="calibre2">Sie blieb stehen, und die Freundinnen wurden schweigsam wie
sie.</p>
<p class="calibre2">Kurz darauf gingen sie hinein. In den Stuben war es dunkel und
kühl. Sie setzten sich alle in die Wohnstube, und niemand
sprach. Schließlich sagte die Mutter:</p>
<p class="calibre2">»Ich glaube, die Sterne sind für die Traurigen da,
damit sie verstehen sollen, daß es keinen Zweck hat, zu
trauern, denn selbst unsre Trauer ist zu klein.«</p>
<p class="calibre2">Niemand antwortete.</p>
<p class="calibre2">Aber die Mutter erhob sich und setzte sich in der dunkeln Stube
ans Klavier.</p>
<p class="calibre2">Die weißen Hände glitten über die Tasten, und
während sie langsam – ganz langsam – einige
Akkorde anschlug, sang sie leise, zu einer Melodie, die sie selbst
gefunden hatte, die fremden Worte:</p>
<p class="calibre2">Wie die Pflanze welket,<br class="calibre3"/>
weil ihre Wurzel ohne Nahrung ist,<br class="calibre3"/>
wie die Blume verblaßt,<br class="calibre3"/>
<a id="page105" title="woldemar/MEsswein"></a> weil
sie die Sonne nicht erreicht,<br class="calibre3"/>
so verwelke ich, und so verblasse ich,<br class="calibre3"/>
denn du hast mich nicht lieb. – –<br class="calibre3"/>
Alles war still.</p>
<p class="calibre2">Über dem Garten, über den Feldern, über allen
Wiesen funkelten die Sterne des Herbstes.</p>
<p class="calibre2"> </p>
<p class="calibre2">Die Freundinnen reisten ab, und die Erntezeit rückte heran,
wo die schwerbeladenen Getreidewagen durch das Hoftor hereinrollten
und die Mutter und Tine hoch oben auf dem Fuder neben den
Mägden saßen, während die Kinder sich jauchzend in
der Scheune wälzten, die gefüllt wurde.</p>
<p class="calibre2">Die Mutter sprang herunter, in Lars' Arme, und schrie:</p>
<p class="calibre2">»Halte mich, halte mich!«</p>
<p class="calibre2">Hinterher hatte sie solche Angst vor Ohrwürmern, daß
sie sich bis auf die Haut entkleidete.</p>
<p class="calibre2">Auch die Erntezeit verrann, und die stillen, weißen Tage
des Septembers kamen, der Garten lag leuchtend und ganz einsam da,
und kaum eine Mücke summte über dem Teich.</p>
<p class="calibre2">Die Mutter saß meistens auf der weißen Treppe und
ließ sich von der Sonne braten, während Tine zu ihren
Füßen im Garten hantierte. Die Pappeln in der Allee
bekamen gelbe Blätter und wurden gleichsam höher in der
dünnen, klaren Luft.</p>
<p class="calibre2">Die Mutter schauerte zusammen:</p>
<p class="calibre2">»Wie lang die Schatten werden,« sagte sie.</p>
<p class="calibre2">Tine band die Rosen auf und sah über die Rasenplätze
hin:</p>
<p class="calibre2">»Ja,« antwortete sie, »wir sind schon weit im
Jahr.«</p>
<p class="calibre2">Die Mutter aber, die über die sonnenhellen Beete
hinstarrte, wo nichts sich regte und alles glänzte,
Blätter und Astern und die späten Rosen, sagte:</p>
<p class="calibre2">»Tine, irgendwo muß es doch Frieden geben: im
Tode.«</p>
<p class="calibre2">Es wurde früh dunkel, und Tine und die Mutter und die
Kinder gingen durch die Allee über die Felder hin, wo die
Brombeerranken in den Gräben wucherten.</p>
<p class="calibre2"><a id="page106" title="woldemar/MEsswein"></a>
Sie begegneten niemandem, überall war es still. Hinter sich
sahen sie, wie die Lichter des Dorfes, eins nach dem andern,
angezündet wurden. Dann läuteten die Abendglocken.</p>
<p class="calibre2">Die Mutter blieb stehen; die Kinder hatten sich an sie
geschmiegt. So weit sie blickte, lagen nur die weiten Felder und
dort im Halbdunkel die stummen Lichter des Dorfes. Der Himmel war
finster und ohne Sterne.</p>
<p class="calibre2">Lange redete niemand von ihnen. Dann sagte die Mutter, die im
Dunkeln so groß aussah:</p>
<p class="calibre2">»Wissen Sie, Tine, hier sollte man die Menschen
hinführen, die leiden.«</p>
<p class="calibre2">Kurz darauf aber sagte sie – und ihre Stimme war
unbeschreiblich müde:</p>
<p class="calibre2">»Und doch, es würde nichts nützen. Ich glaube,
die Schönheit der Erde erhöht nur das Leiden der
Seele:</p>
<p class="calibre2">Es <em class="calibre5">gibt</em> keinen Trost.« –</p>
<p class="calibre2">Sie schritten weiter über die halbdunklen Felder. Die
Glocken hatten aufgehört zu läuten, und man hörte
keinen Laut außer dem Bellen einiger Hunde. Dann erstarb auch
das.</p>
<p class="calibre2">»Wir wollen nach Hause gehen,« sagte die Mutter. Aber
wenn sie nach Hause kamen, spielten die Kinder in der Wohnstube
Zirkus in ihren Nachtkleidern. –</p>
<p class="calibre2">Die Pfarrer aus der Nachbarschaft kamen zum L'Hombre. Sie kamen
herangerasselt in alten Kaleschen, mit dicken, rotbackigen
Kutschern auf dem Bock; der Spieltisch wurde in Vaters Stube
aufgestellt, wo der L'Hombre gespielt wurde, während man vor
dem Rauch aus den langen Pfeifen nicht die Hand vor Augen sehen
konnte.</p>
<p class="calibre2">Der alte Fangel fluchte und schimpfte, daß die Regale
bebten und Mynsters Betrachtungen tanzten. Die Kinder, die nicht
schlafen konnten, sprangen aus den Betten und bekamen Zwetschen,
damit sie wieder ins Bett gingen.</p>
<p class="calibre2"><a id="page107" title="woldemar/MEsswein"></a>
Die Mutter spielte Klavier.</p>
<p class="calibre2">In Vaters Stube wurden sie immer hitziger und hitziger, die
Groggläser wurden gefüllt, und der alte Fangel
fluchte.</p>
<p class="calibre2">Der Morgen konnte anbrechen, und die Pastoren spielten noch.</p>
<p class="calibre2">»Nun spielen wir die letzte Partie auf dem
Rasenplatz,« sagte der alte Fangel.</p>
<p class="calibre2">»Ja, tun Sie das, tun Sie das,« sagte die Mutter.</p>
<p class="calibre2">Die Pastoren verließen ihre Stühle – etwas
unsicher waren sie auf den Beinen – und zogen durch die
Wohnstube.</p>
<p class="calibre2">»Herrgott,« sagte Fangel, »so sieht man Gottes
liebe Sonne wieder.«</p>
<p class="calibre2">Sie wackelten die Gartentreppe hinunter, ihre Groggläser
wurden auf den Rasen gestellt, und auf dem Bauche liegend, spielten
sie und schlugen dabei mit den fetten Händen ins Gras.</p>
<p class="calibre2">Die Mutter saß auf der Gartentreppe und lachte, lachte
–</p>
<p class="calibre2">Doch legte sie dem alten Fangel eine wollene Decke
über.</p>
<p class="calibre2">Aus dem Dorfe kamen Leute die Allee hinauf und gingen an ihnen
vorüber.</p>
<p class="calibre2">»Guten Morgen,« sagten sie und nahmen still den Hut ab
vor den geistlichen Herren.</p>
<p class="calibre2">»Guten Morgen, guten Morgen,« sagte der alte
Fangel.</p>
<p class="calibre2">Die Sonne aber konnte hoch am Himmel stehen, und die Pastoren
spielten immer noch.</p>
<p class="calibre2"> </p>
<p class="calibre2">Die Tage wurden kürzer und kürzer, an den Bäumen
lichtete sich das Laub, und die allerletzten Rosen froren am
weißen Hause entlang.</p>
<p class="calibre2">An der Südwand hingen noch die Trauben, voll und
groß.</p>
<p class="calibre2">Die Mutter besah sie jeden Tag.</p>
<p class="calibre2"><a id="page108" title="woldemar/MEsswein"></a>
»Morgen wollen wir sie pflücken,« sagte sie zu
Tine.</p>
<p class="calibre2">Am andern Tage holte sie eine Leiter herbei, und auf der
obersten Stufe stehend, einen Korb in der Hand, pflückte sie
die reichen, schweren Trauben.</p>
<p class="calibre2">Nun aß sie, und nun warf sie Tine eine Traube an den
Kopf:</p>
<p class="calibre2">»Nimm sie, fang sie!« rief sie.</p>
<p class="calibre2">Die Leiter wurde weiter gerückt, und sie pflückte und
pflückte.</p>
<p class="calibre2">Ganz oben stand sie. Aus Scherz hielt sie eine Traube an ihr
dunkelschimmerndes Haar, während sie eine andere in der
erhobenen Hand hielt. Die Sonne fiel auf sie, auf die funkelnden
Trauben, auf das glänzende Haar.</p>
<p class="calibre2">Der Großknecht ging vorüber und blieb stehen.</p>
<p class="calibre2">Da warf ihm die Mutter die Traube gerade ins Gesicht:</p>
<p class="calibre2">»Ja, schön kann ich aussehen,« sagte sie und
stieg die Leiter hinunter.</p>
<p class="calibre2">Sie ließ die Leiter wegnehmen, und Tine begann die Trauben
zu zählen.</p>
<p class="calibre2">Die Mutter stand lange und betrachtete den nackten
Weinstock.</p>
<p class="calibre2">Ihr Gesicht war wie verändert:</p>
<p class="calibre2">»Jetzt ist es vorbei,« sagte sie.</p>
<p class="calibre2">Sie ging hinein, ohne die Trauben zu beachten, und blieb lange,
die Hände im Schoß, in ihrem Stuhl am Fenster sitzen,
ganz im Dunklen.</p>
<p class="calibre2">Drinnen in seinem Zimmer hörte man den Vater auf und ab
gehen.</p>
<p class="calibre2">Draußen in der Küche hörte man Tine mit den
Trauben herumwirtschaften, und die Stimmen der Leute, die
hereinmußten und ihr Urteil über die Ernte abgeben. Tine
kam in die Wohnstube und berichtete, wieviel Trauben es
gewesen.</p>
<p class="calibre2">»Das waren ja viele,« sagte die Mutter.</p>
<p class="calibre2">»Ja – zehn mehr als voriges Jahr,« antwortete
Tine.</p>
<p class="calibre2"><a id="page109" title="woldemar/MEsswein"></a>
»So.«</p>
<p class="calibre2">Im Hofe war es ganz finster.</p>
<p class="calibre2">Jens, der Kuhhirt, hatte seine Laterne angezündet, als er
zum Vieh hinein ging.</p>
<p class="calibre2">Als er die Tür öffnete, brüllten die Kühe
lang auf.</p>
<p class="calibre2">Die Mutter erhob sich von ihrem Platz. Wie ein Schatten glitt
sie durch das Dunkel der Stube.</p>
<p class="calibre2">Sie setzte sich ans Klavier.</p>
<p class="calibre2">»Sind Sie da, Tine?« fragte sie.</p>
<p class="calibre2">»Ja, gnädige Frau.«</p>
<p class="calibre2">»Wissen Sie, ich saß eben und dachte daran, wie die
Menschen glücklich sein könnten.«</p>
<p class="calibre2">»Aber es gibt ja auch überall glückliche
Menschen,« antwortete Tine.</p>
<p class="calibre2">Die Mutter hob das bleiche Gesicht und sagte langsam:</p>
<p class="calibre2">»Es gibt genügsame Menschen, Tine, das mag wohl
sein.«</p>
<p class="calibre2">Tine dachte eine Weile nach.</p>
<p class="calibre2">»Ja, Gottlob, es gibt ja so viele Arten Glück,«
sagte sie.</p>
<p class="calibre2">Die Mutter schwieg. Dann sagte sie:</p>
<p class="calibre2">»Nein, Tine, ich habe Ihnen früher schon einmal
gesagt, es gibt nur ein Glück, und der ist vielleicht am
glücklichsten, der es nie gekannt hat.«</p>
<p class="calibre2">»Das verstehe ich nicht,« sagte Tine.</p>
<p class="calibre2">»Ja, denn es dauert nicht.«</p>
<p class="calibre2">Es war eine Weile still, bis Mutters schöne Hände
über die Tasten glitten, und mit gedämpfter Stimme,
während man den Vater an seiner Tür wie einen Schatten
stehen sah, sang sie:</p>
<p class="calibre2">Wie die Pflanze welkt,<br class="calibre3"/>
weil ihre Wurzel ohne Nahrung ist,<br class="calibre3"/>
wie die Blume verblaßt,<br class="calibre3"/>
weil sie die Sonne nicht erreicht;<br class="calibre3"/>
so verwelke ich, und so verblasse ich,<br class="calibre3"/>
denn du hast mich nicht lieb.</p>
<p class="calibre2"><a id="page110" title="woldemar/MEsswein"></a>
Der Gesang hörte auf.</p>
<p class="calibre2">Draußen war es Nacht. Drinnen war es dunkel. Die Mutter
erhob sich.</p>
<p class="calibre2">»Zünden Sie die Lampe an, Tine,« sagte sie.
»Die Kinder müssen ins Bett, und die Leute müssen
Abendbrot bekommen.« <a id="page111" title="woldemar/MEsswein"></a></p>
<p class="calibre2"></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter1.vue?3da641fc